(function () {
    'use strict';

    angular.module('ProjectDirectory.resources', [
        'ui.bootstrap'
    ])
        .config(function (pdConfigProvider, LoopBackResourceProvider, $httpProvider, uiGmapGoogleMapApiProvider, localStorageServiceProvider) {

            /** loopback configuration */
            LoopBackResourceProvider.setAuthHeader('access-token');
            LoopBackResourceProvider.setUrlBase(pdConfigProvider.apiUrlBase);

            /** google maps */
            uiGmapGoogleMapApiProvider.configure({
                key: pdConfigProvider.gmapsApiKey,
                v: '3.37',
                libraries: 'weather,geometry,visualization'
            });

            /** interceptors */
            $httpProvider.interceptors.push(function ($q, $location, LoopBackAuth, $injector) {
                return {
                    responseError: function (rejection) {

                        var ignore401 = rejection &&
                            rejection.config &&
                            rejection.config.params &&
                            rejection.config.params.ignore401 &&
                            rejection.config.params.ignore401 === true;

                        if (rejection.status === 401 && !ignore401) {

                            var state = $injector.get('$state');
                            state.go('main.home');
                            return $q.reject(rejection);

                        } else {
                            return $q.reject(rejection);
                        }
                    }
                };
            });

            /** localstorage */
            localStorageServiceProvider.setPrefix('pad');
            localStorageServiceProvider.setStorageType('localStorage');

        });

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages', [
        'ui.router',

        'ProjectDirectory.pages.main',
        'ProjectDirectory.pages.associated',
        'ProjectDirectory.pages.components',
        'ProjectDirectory.pages.home',
        'ProjectDirectory.pages.static',
        'ProjectDirectory.pages.project',
        'ProjectDirectory.pages.subscription',
        'ProjectDirectory.pages.article',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider) {
        $urlRouterProvider.otherwise('/main');
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme', [
        'toastr',
        'ProjectDirectory.theme.components',
        'lbServices'
    ]).config(function ($locationProvider) {
        $locationProvider.html5Mode(true);
    });

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.article', [
        'ngAnimate',
        'ui.bootstrap',
        'ngSanitize',
        'textAngular'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.article', {
                url: '/articulos',
                abstract: true,
                template: '<div ui-view></div>',
                controller: 'ArticlePageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.article.list', {
                url: '?p=',
                templateUrl: 'app/pages/article/list.html',
                controller: 'ArticleFilterPageCtrl',
                params: {
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            })
            .state('main.article.find_by_slug', {
                url: '/:slug',
                templateUrl: 'app/pages/article/show.html',
                controller: 'ArticlePageCtrl',
                data: {
                    roles: ['*']
                }
            })
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated', [
        'ngFileUpload',

        'ProjectDirectory.pages.associated.home',
        'ProjectDirectory.pages.associated.profile',
        'ProjectDirectory.pages.associated.project',
        'ProjectDirectory.pages.associated.updates',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('associated', {
                url: '/asociado',
                templateUrl: 'app/pages/associated/associated.html',
                redirectTo: 'associated.home',
                authenticate: true,
                controller: 'AssociatedPageCtrl',
                data: {
                    roles: ['associated']
                }
            });
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components', []);

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home', [
        'ngAnimate',
        'ui.bootstrap'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.home', {
                url: '/inicio?p',
                templateUrl: 'app/pages/home/home.html',
                controller: 'HomePageCtrl',
                params: {
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.main', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                redirectTo: 'main.home',
                authenticate: true,
                controller: 'MainPageCtrl'
            });
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.project', [
        'ngAnimate',
        'ui.bootstrap'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.project', {
                url: '/proyectos',
                abstract: true,
                template: '<div ui-view></div>',
                controller: 'ProjectPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.show', {
                url: '/:id/ver',
                templateUrl: 'app/pages/project/project_show.html',
                controller: 'ProjectPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.find_by_slug', {
                url: '/:slug',
                templateUrl: 'app/pages/project/project_show.html',
                controller: 'ProjectPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.project_company', {
                url: '/empresa/:idCompany/ver?p=',
                templateUrl: 'app/pages/project/project_company.html',
                controller: 'ProjectFilterPageCtrl',
                params: {
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.project_sector', {
                url: '/sector/:idSector/ver?p=',
                templateUrl: 'app/pages/project/project_sector.html',
                controller: 'ProjectFilterPageCtrl',
                params: {
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.project_category', {
                url: '/categoria/:idCategory/ver?p=',
                templateUrl: 'app/pages/project/project_category.html',
                controller: 'ProjectFilterPageCtrl',
                params: {
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            })
            .state('main.project.project_search', {
                url: '/buscar/?s=&p=',
                templateUrl: 'app/pages/project/project_search.html',
                controller: 'ProjectFilterPageCtrl',
                params: {
                    s: {
                        value: '',
                        squash: true
                    },
                    p: {
                        value: '1',
                        squash: true
                    }
                },
                data: {
                    roles: ['*']
                }
            })
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.static', [
        'ngSanitize',
        'textAngular',
        'ngFileUpload',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $provide) {
        $stateProvider
            .state('main.about-us', {
                url: '/quienes-somos',
                templateUrl: 'app/pages/static/about-us.html',
                controller: 'StaticPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.contact', {
                url: '/contacto',
                templateUrl: 'app/pages/static/contact.html',
                controller: 'StaticPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.terms', {
                url: '/terminos',
                templateUrl: 'app/pages/static/terms.html',
                controller: 'StaticPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.objectives', {
                url: '/objetivos-desarrollo-sostenible',
                templateUrl: 'app/pages/static/objectives.html',
                controller: 'StaticPageCtrl',
                data: {
                    roles: ['*']
                }
            });

        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function (taRegisterTool, taOptions, $uibModal) {
            // taOptions.toolbar = [
            //     ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
            //     ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            //     ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            //     ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
            // ];

            /** custom upload image */
            taRegisterTool('uploadImage', {
                buttontext: 'Insertar imagen',
                tooltiptext: 'Insertar imagen',
                iconclass: "fa fa-image",
                action: function (deferred, restoreSelection) {

                    var textAngular = this;

                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/resources/components/taUploadImage/taFilesModal.html',
                        size: 'md',
                        controller: 'UploadImageCtrl'

                    }).result.then(function (result) {
                            restoreSelection();

                            // textAngular.$editor().wrapSelection('insertImage', result);

                            var embed = '<img src="' + result + '" style="float:left;" class="text-editor-m-10">';
                            textAngular.$editor().wrapSelection('insertHTML', embed, true);

                            deferred.resolve();
                        },
                        function () {
                            deferred.resolve();
                        }
                    );
                    return false;
                }
            });

            taOptions.toolbar.push(['uploadImage']);
            /** /custom upload image */

            var display = "<button type='button' class=\"btn btn-default font-size-dropdown\" uib-dropdown uib-dropdown-toggle ng-disabled='showHtml()'>" +
                "      <i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i>" +
                "      <ul class=\"\" uib-dropdown-menu>" +
                "        <li ng-repeat='o in options'>" +
                "           <div class=\"btn btn-xs btn-block\" style='font-size: {{o.css}};' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button>" +
                "        </li>" +
                "      </ul>" +
                "    </button>";

            taRegisterTool('fontSize', {
                display: display,
                action: function (event, size) {
                    //Ask if event is really an event.
                    if (!!event.stopPropagation) {
                        //With this, you stop the event of textAngular.
                        event.stopPropagation();
                        //Then click in the body to close the dropdown.
                        $("body").trigger("click");
                    }
                    return this.$editor().wrapSelection('fontSize', parseInt(size));
                },
                options: [
                    {name: 'xx-small', css: 'xx-small', value: 1},
                    {name: 'x-small', css: 'x-small', value: 2},
                    {name: 'small', css: 'small', value: 3},
                    {name: 'medium', css: 'medium', value: 4},
                    {name: 'large', css: 'large', value: 5},
                    {name: 'x-large', css: 'x-large', value: 6},
                    {name: 'xx-large', css: 'xx-large', value: 7}
                ]
            });

            taOptions.toolbar[1].push('fontSize');

            // remove fontSize actions included tag type header (h1, h2, ... h6)
            for (var i = 1; i <= 6; i++) {
                var index = taOptions.toolbar[0].indexOf('h' + i);
                if (index > -1) {
                    taOptions.toolbar[0].splice(index, 1);
                }
            }
            var indexFontSize = taOptions.toolbar[1].indexOf('fontSize');
            if (indexFontSize > -1) {
                taOptions.toolbar[1].splice(indexFontSize, 1);
            }

            return taOptions;
        }]);
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.subscription', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.subscription', {
                url: '/suscripcion',
                abstract: true,
                template: '<div ui-view></div>',
                controller: 'SubscriptionPageCtrl',
                data: {
                    roles: ['*']
                }
            })
            .state('main.subscription.confirm', {
                url: '/confirmar/:token',
                templateUrl: 'app/pages/subscription/confirm.html',
                controller: 'SubscriptionPageCtrl',
                data: {
                    roles: ['*']
                }
            })
    }

})();

(function () {
  'use strict';

  angular.module('ProjectDirectory.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme.inputs', []);

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.home', [
        'ngAnimate',
        'ui.bootstrap'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('associated.home', {
                url: '/inicio',
                templateUrl: 'app/pages/associated/home/associated_home.html',
                controller: 'AssociatedHomePageCtrl',
                title: 'Inicio'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.profile', [
        'ngAnimate',
        'ui.bootstrap',
        'textAngular',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('associated.profile', {
                url: '/perfil',
                templateUrl: 'app/pages/associated/profile/associated_profile.html',
                controller: 'AssociatedProfilePageCtrl',
                title: 'Perfil'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.project', [
        'ngAnimate',
        'ui.bootstrap',
        'textAngular',
        'angular-auto-save-form',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('associated.project', {
                url: '/proyectos',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
            })
            .state('associated.project.list', {
                url: '?s=',
                templateUrl: 'app/pages/associated/project/associated_project.html',
                controller: 'AssociatedProjectPageCtrl',
                title: 'Proyecto',
                params: {
                    s: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state('associated.project.create', {
                url: '/crear',
                templateUrl: 'app/pages/associated/project/associated_project_create_or_update.html',
                controller: 'AssociatedProjectManagePageCtrl',
                title: 'Proyecto creación'
            })
            .state('associated.project.edit', {
                url: '/:id/editar',
                templateUrl: 'app/pages/associated/project/associated_project_create_or_update.html',
                controller: 'AssociatedProjectManagePageCtrl',
                title: 'Proyecto edición'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.updates', [
        'ngAnimate',
        'ngSanitize',
        'ui.bootstrap',
        'textAngular',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('associated.updates', {
                url: '/actualizaciones',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
            })
            .state('associated.updates.list', {
                url: '?s=',
                templateUrl: 'app/pages/associated/updates/associated_updates.html',
                controller: 'AssociatedUpdatesPageCtrl',
                title: 'Actualización',
                params: {
                    s: {
                        value: '',
                        squash: true
                    }
                }
            });
    }

})();

'use strict';

angular.module('ProjectDirectory', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.bootstrap.collapse',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'ngSanitize',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',

    'ngResource',
    'lbServices',
    'angularValidator',
    'angularUtils.directives.dirPagination',
    'angular-highlight-text',
    'vcRecaptcha',
    'daterangepicker',
    'slick',

    'ls.LiveSet',
    'ls.ChangeStream',
    'uiGmapgoogle-maps',
    'ta-maxlength',
    'btorfs.multiselect',
    'videosharing-embed',
    'LocalStorageModule',

    'ProjectDirectory.theme',
    'ProjectDirectory.resources',
    'ProjectDirectory.pages',
]).config(config).run(run);

/** @ngInject */
function config() {

}

/** @ngInject */
function run($rootScope, $location, $window) {

    // Initialize google analytics
    $window.ga('create', 'UA-32678780-15', 'auto');

    // Track pageview on state change
    $rootScope.$on('$stateChangeSuccess', function (event) {
        $window.ga('send', 'pageview', $location.path());
    });

}
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .provider('pdConfig', configProvider);

    /** @ngInject */
    function configProvider() {
        var conf = {
            apiUrlBase: 'https://api.com-unidad.pe/api/v1',
            apiWsBase: 'https://api.com-unidad.pe',
            gaViewId: '203370737',
            geocodeApiKey: 'AIzaSyDhpcbnnt8wGh-HQecUWoWzX9t1Nj6IV5g',
            gmapsApiKey: 'AIzaSyDhpcbnnt8wGh-HQecUWoWzX9t1Nj6IV5g',
            reCaptchaKey: '6Lc2zLkUAAAAAGi_2aGhAIcV7_Ch4KqFH0CsD2Bx'
        };

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('ProjectDirectory.resources')
        .constant('paginateHelper', {
            pageSizeOptions: [5, 10, 25, 50, 100],
            pageSize: 25
        })
        .constant('assetPaths', {
            images: {
                root: IMAGES_ROOT,
                logo1x: IMAGES_ROOT + 'app/logo-1x.png',
                logo2x: IMAGES_ROOT + 'app/logo-2x.png',
                logoSNMPE: IMAGES_ROOT + 'app/logo-snmpe.png',
                noImageUrl: IMAGES_ROOT + '/no-photo.png',
                unknowUserImageUrl: IMAGES_ROOT + '/unknow-user.png',
                addFileUrl: IMAGES_ROOT + '/add-file.png',
                imageFileUrl: IMAGES_ROOT + '/image-file.png',
                pdfFileUrl: IMAGES_ROOT + '/pdf-file.png',
                emptyMarker: IMAGES_ROOT + 'app/icons/empty-marker-icon.png',
            }
        })
        .constant('errorCodes', {
            LOGIN_FAILED_EMAIL_NOT_VERIFIED: "LOGIN_FAILED_EMAIL_NOT_VERIFIED",
            AVOID_SELF_DELETION: "AVOID_SELF_DELETION",
            AVOID_OWNER_DELETION: "AVOID_OWNER_DELETION",
            MODEL_NOT_FOUND: "MODEL_NOT_FOUND",
            INVALID_TOKEN: "INVALID_TOKEN",
            EMPTY_SUBSCRIPTION_ADDRESSES: "EMPTY_SUBSCRIPTION_ADDRESSES",
            INVALID_PROJECT: "INVALID_PROJECT",
            INVALID_CONTACT_FORM: "INVALID_CONTACT_FORM",
            INVALID_RECAPTCHA_RESPONSE: "INVALID_RECAPTCHA_RESPONSE",
            UNKNOW_USER: "UNKNOW_USER",
            PENDING_APPROVAL: "PENDING_APPROVAL",
        })
        .constant('messagesHelper', {
            success_operation: 'Operación realizada correctamente.',
            fail_operation: 'No se pudo realizar la operación.',
            resource_does_not_exists: 'El recurso solicitado no existe.',
            confirm_operation: '¿Confirma que desea realizar la operación?',
            not_selected_elements: 'No existen elementos seleccionados.',
            bad_credentials: 'Usuario o contraseña incorrectos.',
            unverified_account: 'Cuenta no verificada.',
            email_already_exists: 'El email ya está en uso.',
            not_allowed_self_deletion: 'Un usuario no puede eliminarse a si mismo.',
            sended_recovery_email: 'Email de recuperación enviado correctamente.',
            invalid_token: 'El token no es válido.',
            empty_subscription_addresses: 'No existen direcciones de correo confirmadas en el listado de suscriptores.',
            complete_the_field: 'Complete el campo.',
            complete_all_fields: 'Complete todos los campos.',
            complete_all_location_fields: 'Complete todos los campos del lugar.',
            invalid_coordinates: 'El valor de las coordenadas es incorrecto.',
            accept_terms: 'Debe aceptar los términos y condiciones.',
            success_upload: 'Archivo subido correctamente.',
            invalid_project: 'El formulario de proyecto contiene algún error. Verifique los campos y envíelo nuevamente.',
            item_already_exist: 'EL elemento ya existe.',
            success_contact_form: 'Formulario de contacto enviado correctamente.',
            invalid_contact_form: 'Formulario de contacto incorrecto.',
            invalid_recaptcha: 'La verificación de recaptcha ha fallado.',
            success_recovery: 'Revise su correo electrónico. Se han enviado detalles para recuperar el acceso.',
            unknow_user: 'Usuario desconocido.',
            pending_approval: 'El proyecto tiene cambios pendientes de aprobación. El administrador debe aprobarlos.',
        })
        .constant('projectStatus', {
            DRAFT: 'draft',
            PENDING: 'pending',
            PUBLISHED: 'published'
        })
        .constant('updateStatus', {
            PENDING: 'pending',
            PUBLISHED: 'published'
        })
        .constant('projectFieldVisibility', {
            PUBLIC: "public",
            PRIVATE: "private",
            HIDDEN: "hidden"
        })
        .constant('projectFieldValidation', {
            REQUIRED: "required",
            UNREQUIRED: "unrequired"
        })
        .constant('bannerStatus', {
            "ENABLED": "enabled",
            "DISABLED": "disabled"
        })
        .constant('menuType', {
            "MAIN": "main",
            "ASSOCIATED": "associated"
        })
        .constant('socialType', {
            "FACEBOOK": "facebook",
            "TWITTER": "twitter",
            "LINKEDIN": "linkedin",
            "WHATSAPP": "whatsapp"
        })
        .constant('entityType', {
            "REMOTE": "remote",
            "LOCAL": "local"
        })
        .constant('nomenclator', {

            socialNetworks: [{
                id: 'facebook',
                icon: 'fa-facebook',
                name: 'Facebook'
            }, {
                id: 'twitter',
                icon: 'fa-twitter',
                name: 'Twitter'
            }, {
                id: 'linkedin',
                icon: 'fa-linkedin',
                name: 'Linkedin'
            }, {
                id: 'instagram',
                icon: 'fa-instagram',
                name: 'Instagram'
            }, {
                id: 'youtube',
                icon: 'fa-youtube',
                name: 'Youtube'
            }, {
                id: 'custom',
                icon: 'fa-share-alt',
                name: 'Otra'
            }],

            appPlatforms: [{
                id: 'android',
                name: 'Android'
            }, {
                id: 'apple',
                name: 'IOS'
            }],
        })
        .constant('recommendedSizes', {
            mainSlide: {
                desktop: {
                    width: 1140,
                    height: 175
                },
                mobile: {
                    width: 363,
                    height: 175
                }
            },
            publicityBanner: {
                desktop: {
                    width: 165,
                    height: 605
                },
                mobile: {
                    width: 165,
                    height: 165
                },
            },
            projectSlide: {
                width: 437,
                height: 379
            }
        });
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .run(themeRun);

    /** @ngInject */
    function themeRun($rootScope, UserAssociated, $state) {

        $rootScope.userLogged = null;
        UserAssociated.getCurrent({ignore401: true}, function (user) {
            $rootScope.userLogged = user;
        }, function (errorResponse) {
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromStateParams) {

            $rootScope.activeMenu = '';

            if (toState.redirectTo) {
                event.preventDefault();
                $state.go(toState.redirectTo, toStateParams, {location: 'replace'});
            }

            if (toState.data && toState.data.roles) {
                if (toState.data.roles.indexOf('*') !== -1) {
                    /** public state */
                } else {
                    if (UserAssociated.isAuthenticated()) {
                        /** grant access */
                    } else {
                        event.preventDefault();
                        $state.go('main.home');
                    }
                }
            }
        });
    }

})();
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme')
    .config(config);

  /** @ngInject */
  function config(colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, pdUtil) {
    return function (uiViewElement) {
      if (pdUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .provider('mfConfig', configProvider);

    /** @ngInject */
    function configProvider() {
        var conf = {};

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('ProjectDirectory.theme')
        .constant('layoutPaths', {
            images: {
                root: IMAGES_ROOT,
                logo: IMAGES_ROOT + 'app/logo.png',
                logoSNMPE: IMAGES_ROOT + 'app/logo-snmpe.png',
                profileIcon: IMAGES_ROOT + 'app/icons/profile-icon.png',
                newProjectIcon: IMAGES_ROOT + 'app/icons/new-project-icon.png',
                projectListIcon: IMAGES_ROOT + 'app/icons/projects-icon.png',
                updateProjectIcon: IMAGES_ROOT + 'app/icons/update-project-icon.png'
            }
        })
        .constant('colorHelper', {
            tint: function (color, weight) {
                return mix('#ffffff', color, weight);
            },
            shade: function (color, weight) {
                return mix('#000000', color, weight);
            },
        });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }

        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, $state, StateUtil, pdUtil, Configuration, projectFieldUtils, pdConfig, PubSub) {

        $rootScope.$stateUtil = StateUtil;
        $rootScope.$isEmptyOrNull = pdUtil.isEmptyOrNull;
        $rootScope.$projectFieldUtils = projectFieldUtils;

        $rootScope.currentConfig = null;

        var whatToWait = [
            Configuration.findOne(function (configuration, httpHeader) {
                PubSub.subscribe({
                    collectionName: 'Configuration',
                    method: 'PUT',
                    modelId: configuration.id
                }, onConfigurationUpdate);
            }).$promise,
            $timeout(3000)
        ];

        var onConfigurationUpdate = function (data) {
            console.log("Configuration updated ==>", data);
            if (data) {
                $rootScope.$apply(function () {
                    $rootScope.currentConfig = data;
                });
            }
        };

        $q.all(whatToWait).then(function (results) {

            $rootScope.currentConfig = results[0];

            $rootScope.$pageFinishedLoading = true;
        }, function (error) {
            console.log("Load initial resources error.", error);
            $rootScope.$pageFinishedLoading = true;
        });

        // var urlToChangeStream = pdConfig.apiUrlBase + '/Configuration/change-stream?_format=event-stream';
        // var src = new EventSource(urlToChangeStream);
        // src.addEventListener('data', function (msg) {
        //     var data = JSON.parse(msg.data);
        //     console.log("Current config.", data);
        //     if (data.data) {
        //         $rootScope.$apply(function () {
        //             $rootScope.currentConfig = data.data;
        //         });
        //     }
        // });

    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('cut', cut);

    /** @ngInject */
    function cut() {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                    //Also remove . and , so its gives a cleaner result.
                    if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                        lastspace = lastspace - 1;
                    }
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('formatUrl', formatUrl);

    /** @ngInject */
    function formatUrl() {
        return function (input) {
            if (input) {
                var value = input.toLowerCase();
                if (!value.startsWith('http://') && !value.startsWith('https://')) {
                    value = 'http://' + value;
                }
                return value;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('htmlToPlainText', htmlToPlainText);

    /** @ngInject */
    function htmlToPlainText() {
        return function (input) {
            return input ? String(input).replace(/<[^>]+>/gm, '') : '';
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('imageUrl', imageUrl);

    /** @ngInject */
    function imageUrl(pdConfig, assetPaths) {
        return function (input, container) {
            if (input && container) {
                return pdConfig.apiUrlBase + '/container/' + container + '/download/' + input;
            } else if (input) {
                return pdConfig.apiUrlBase + input;
            } else {
                if (container === 'userpics') {
                    return assetPaths.images.unknowUserImageUrl;
                }
                return assetPaths.images.noImageUrl;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('range', range);

    /** @ngInject */
    function range() {
        return function (total) {
            total = parseInt(total);
            var values = [];
            for (var i = 0; i < total; i++) {
                values.push(i);
            }
            return values;
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('secondsToTime', secondsToTime);

    /** @ngInject */
    function secondsToTime() {
        function padTime(t) {
            return t < 10 ? "0" + t : t;
        }

        return function (_seconds) {

            _seconds = Number(_seconds);

            if (typeof _seconds !== "number" || _seconds < 0)
                return "00:00:00";

            var hours = Math.floor(_seconds / 3600),
                minutes = Math.floor((_seconds % 3600) / 60),
                seconds = Math.floor(_seconds % 60);

            return padTime(hours) + ":" + padTime(minutes) + ":" + padTime(seconds);
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('url', url);

    /** @ngInject */
    function url(pdConfig, assetPaths) {
        return function (input) {
            if (input) {
                return pdConfig.apiUrlBase + input
            } else {
                return "no"
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('backgroundImage', backgroundImage);

    /** @ngInject */
    function backgroundImage() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var url = attrs.backgroundImage;
                var defaultHeight = attrs.backgroundImageHeight ? attrs.backgroundImageHeight + 'px' : '170px';

                element.css({
                    'height': defaultHeight,
                    'background-image': 'url(' + url + ')',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center center',
                    '-webkit-background-size': 'cover',
                    '-moz-background-size': 'cover',
                    '-o-background-size': 'cover',
                    'background-size': 'cover'
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('calculateMinHeight', calculateMinHeight);

    /** @ngInject */
    function calculateMinHeight() {
        return {
            restrict: 'EA',
            link: function (scope, element, attrs) {

                var header = angular.element(document.querySelector('#header-container'));
                var footer = angular.element(document.querySelector('#footer-container'));

                var configure = function () {
                    // var screenHeight = document.documentElement.clientHeight;
                    // var headerHeight = header[0].clientHeight;
                    // var footerHeight = footer[0].clientHeight;
                    // var elementHeight = element[0].clientHeight;

                    var screenHeight = document.documentElement.clientHeight;
                    var headerHeight = header[0].offsetHeight;
                    var footerHeight = footer[0].offsetHeight;
                    var elementHeight = element[0].offsetHeight;

                    var value = screenHeight - headerHeight - footerHeight;
                    element.css('min-height', value);

                    // console.log("screenHeight - headerHeight - footerHeight")
                    // console.log(screenHeight, headerHeight, footerHeight)
                    // console.log('min-height =>', value);
                };

                var resizeElement = function () {
                    configure();
                };

                window.addEventListener("orientationchange", resizeElement, false);
                window.addEventListener("resize", resizeElement, false);

                scope.$on('$destroy', function () {
                    window.removeEventListener("orientationchange", resizeElement, false);
                    window.removeEventListener("resize", resizeElement, false);
                });

                scope.$watch(function () {
                    // console.log("==========================================")
                    // console.log("screenHeight - headerHeight - footerHeight")
                    // console.log(document.documentElement.clientHeight, header[0].offsetHeight, footer[0].offsetHeight)
                    return document.documentElement.clientHeight + header[0].offsetHeight + footer[0].offsetHeight;
                    // return document.documentElement.clientHeight + header[0].clientHeight + footer[0].clientHeight;
                }, function onHeightChange(newValue, oldValue) {
                    configure();
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('onPressEnter', onPressEnter);

    /** @ngInject */
    function onPressEnter() {
        return {
            restrict: 'EA',
            link: function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.onPressEnter);
                        });

                        event.preventDefault();
                    }
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectpicker', selectpicker);

    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
                pre: function (scope, elem, attrs) {
                    elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
                },
                post: function (scope, elem, attrs) {
                    function refresh() {
                        elem.selectpicker('refresh');
                    }

                    if (attrs.ngModel) {
                        scope.$watch(attrs.ngModel, refresh);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refresh);
                    }

                    elem.selectpicker({dropupAuto: false, hideDisabled: true});
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('styleForAllChild', styleForAllChild);

    /** @ngInject */
    function styleForAllChild($timeout, pdUtil) {
        return {
            restrict: 'EA',
            scope: {
                styleForAllChild: '=styleForAllChild'
            },
            link: function (scope, element, attr) {
                var style = scope.styleForAllChild;
                if (!pdUtil.isEmptyOrNull(style)) {
                    $timeout(function () {
                        $("*", element).each(function (index, el) {
                            $(el).css(style);
                        });
                    });
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('confirmModal', confirmModal);

    /** @ngInject */
    function confirmModal($uibModal) {

        return function (message, title) {

            var modal = $uibModal.open({
                size: 'sm',
                template: '<div class="modal-header">\
                            <h4 class="modal-title" ng-bind="title"></h4>\
                        </div>\
                        <div class="modal-body" ng-bind="message"></div>\
                        <div class="modal-footer">\
                            <button class="btn btn-default" ng-click="modal.dismiss()">Cancelar</button>\
                            <button class="btn btn-primary" ng-click="modal.close()">Aceptar</button>\
                        </div>',
                controller: function ($scope, $uibModalInstance) {

                    $scope.modal = $uibModalInstance;

                    if (angular.isObject(message)) {
                        angular.extend($scope, message);
                    } else {
                        $scope.message = message;
                        $scope.title = angular.isUndefined(title) ? 'Mensagem' : title;
                    }
                }
            });

            return modal.result;
        }
    }
})();

(function () {
  'use strict';

  angular.module('ProjectDirectory.resources')
      .service('fileReaderService', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api/v1";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.UserEntity
 * @header lbServices.UserEntity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserEntity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserEntity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/user/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserEntity.notificationCompanies.link() instead.
            "prototype$__link__notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.unlink() instead.
            "prototype$__unlink__notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserEntity.notificationCompanies() instead.
            "prototype$__get__notificationCompanies": {
              isArray: true,
              url: urlBase + "/user/:id/notificationCompanies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#create
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/user",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#findById
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/user/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#replaceById
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/user/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#find
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#count
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/user/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$patchAttributes
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/user/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#login
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/user/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#logout
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/user/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$verify
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/user/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#resetPassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/user/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#changePassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/user/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#setPassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/user/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#destroyMultiple
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/user",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#profile
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Update user profile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "profile": {
              url: urlBase + "/user/profile",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#setReceiveNotificationFromAll
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Change user receive notification from all companies
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `enabled` – `{boolean}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setReceiveNotificationFromAll": {
              url: urlBase + "/user/:id/notification-from-all",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#createMany
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/user",
              method: "POST",
            },

            // INTERNAL. Use Company.administrators.link() instead.
            "::link::Company::administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.administrators.unlink() instead.
            "::unlink::Company::administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.administrators() instead.
            "::get::Company::administrators": {
              isArray: true,
              url: urlBase + "/company/:id/administrators",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#getCurrent
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/user" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$updateAttributes
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#getCachedCurrent
         * @methodOf lbServices.UserEntity
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.UserEntity#login} or
         * {@link lbServices.UserEntity#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A UserEntity instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#isAuthenticated
         * @methodOf lbServices.UserEntity
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#getCurrentId
         * @methodOf lbServices.UserEntity
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.UserEntity#modelName
        * @propertyOf lbServices.UserEntity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserEntity`.
        */
        R.modelName = "UserEntity";

    /**
     * @ngdoc object
     * @name lbServices.UserEntity.notificationCompanies
     * @header lbServices.UserEntity.notificationCompanies
     * @object
     * @description
     *
     * The object `UserEntity.notificationCompanies` groups methods
     * manipulating `Company` instances related to `UserEntity`.
     *
     * Call {@link lbServices.UserEntity#notificationCompanies UserEntity.notificationCompanies()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.UserEntity#notificationCompanies
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * notificationCompanies consultas de UserEntity.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.notificationCompanies = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserEntity.notificationCompanies#link
             * @methodOf lbServices.UserEntity.notificationCompanies
             *
             * @description
             *
             * Añadir un elemento relacionado por id para notificationCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `fk` – `{*}` - Clave foránea para notificationCompanies
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.notificationCompanies.link = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::link::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserEntity.notificationCompanies#unlink
             * @methodOf lbServices.UserEntity.notificationCompanies
             *
             * @description
             *
             * Eliminar la relación notificationCompanies con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para notificationCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.notificationCompanies.unlink = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::unlink::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Analytic
 * @header lbServices.Analytic
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Analytic` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Analytic",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/analytic/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Analytic#connectedUsers
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find connected users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `filters` – `{string=}` - Filters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "connectedUsers": {
              url: urlBase + "/analytic/connected-users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#tokens
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find tokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "tokens": {
              url: urlBase + "/analytic/tokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#totalStatistic
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find total users by range date.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "totalStatistic": {
              url: urlBase + "/analytic/total-statistic",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#mainChannel
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find main channels traffic.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "mainChannel": {
              url: urlBase + "/analytic/main-channel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#countryUser
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find users by country.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "countryUser": {
              url: urlBase + "/analytic/country-user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#users
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find users by dates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "users": {
              url: urlBase + "/analytic/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#visitor
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find visitors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "visitor": {
              url: urlBase + "/analytic/visitor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#destinationPage
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find destination page.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "destinationPage": {
              url: urlBase + "/analytic/destination-page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#exitPage
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find exit page.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "exitPage": {
              url: urlBase + "/analytic/exit-page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#socialMedia
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find social media.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "socialMedia": {
              url: urlBase + "/analytic/social-media",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#device
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find devices usage.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "device": {
              url: urlBase + "/analytic/device",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Analytic#modelName
        * @propertyOf lbServices.Analytic
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Analytic`.
        */
        R.modelName = "Analytic";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Sector
 * @header lbServices.Sector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Sector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Sector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sector/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Sector.imageMarker() instead.
            "prototype$__get__imageMarker": {
              url: urlBase + "/sector/:id/imageMarker",
              method: "GET",
            },

            // INTERNAL. Use Sector.imageLogo() instead.
            "prototype$__get__imageLogo": {
              url: urlBase + "/sector/:id/imageLogo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#create
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/sector",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#findById
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/sector/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#find
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/sector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#count
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/sector/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#prototype$patchAttributes
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/sector/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#destroyMultiple
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/sector",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#createMany
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/sector",
              method: "POST",
            },

            // INTERNAL. Use Article.sector() instead.
            "::get::Article::sector": {
              url: urlBase + "/article/:id/sector",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Sector#prototype$updateAttributes
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Sector#modelName
        * @propertyOf lbServices.Sector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Sector`.
        */
        R.modelName = "Sector";


            /**
             * @ngdoc method
             * @name lbServices.Sector#imageMarker
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Capta la relación belongsTo imageMarker.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMarker = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Sector::imageMarker"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sector#imageLogo
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Capta la relación belongsTo imageLogo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageLogo = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Sector::imageLogo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/category/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Category.subcategories.findById() instead.
            "prototype$__findById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.destroyById() instead.
            "prototype$__destroyById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.updateById() instead.
            "prototype$__updateById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/category/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories() instead.
            "prototype$__get__subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.create() instead.
            "prototype$__create__subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.destroyAll() instead.
            "prototype$__delete__subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.count() instead.
            "prototype$__count__subcategories": {
              url: urlBase + "/category/:id/subcategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/category",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/category/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/category",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/category/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/category/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyMultiple
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/category",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/category",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.findById() instead.
            "::findById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.destroyById() instead.
            "::destroyById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.updateById() instead.
            "::updateById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.category() instead.
            "::get::Category::category": {
              url: urlBase + "/category/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories() instead.
            "::get::Category::subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.create() instead.
            "::create::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.createMany() instead.
            "::createMany::Category::subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.destroyAll() instead.
            "::delete::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.count() instead.
            "::count::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories/count",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.findById() instead.
            "::findById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.destroyById() instead.
            "::destroyById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.updateById() instead.
            "::updateById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.link() instead.
            "::link::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.unlink() instead.
            "::unlink::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.exists() instead.
            "::exists::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.categories() instead.
            "::get::Project::categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.create() instead.
            "::create::Project::categories": {
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.createMany() instead.
            "::createMany::Project::categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.destroyAll() instead.
            "::delete::Project::categories": {
              url: urlBase + "/project/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.count() instead.
            "::count::Project::categories": {
              url: urlBase + "/project/:id/categories/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";

    /**
     * @ngdoc object
     * @name lbServices.Category.subcategories
     * @header lbServices.Category.subcategories
     * @object
     * @description
     *
     * The object `Category.subcategories` groups methods
     * manipulating `Category` instances related to `Category`.
     *
     * Call {@link lbServices.Category#subcategories Category.subcategories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Category#subcategories
             * @methodOf lbServices.Category
             *
             * @description
             *
             * subcategories consultas de Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#count
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Recuentos subcategories de Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subcategories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#create
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Crea una nueva instancia en subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#createMany
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Crea una nueva instancia en subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#destroyAll
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Suprime todos los subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subcategories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#destroyById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subcategories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#findById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Buscar un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#updateById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category#category
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Capta la relación belongsTo category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::category"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Project
 * @header lbServices.Project
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Project` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Project",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/project/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Project.publishedVersion() instead.
            "prototype$__get__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "GET",
            },

            // INTERNAL. Use Project.publishedVersion.create() instead.
            "prototype$__create__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.update() instead.
            "prototype$__update__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "PUT",
            },

            // INTERNAL. Use Project.publishedVersion.destroy() instead.
            "prototype$__destroy__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.findById() instead.
            "prototype$__findById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.destroyById() instead.
            "prototype$__destroyById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.updateById() instead.
            "prototype$__updateById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.link() instead.
            "prototype$__link__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.unlink() instead.
            "prototype$__unlink__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.exists() instead.
            "prototype$__exists__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.findById() instead.
            "prototype$__findById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.destroyById() instead.
            "prototype$__destroyById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.updateById() instead.
            "prototype$__updateById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.link() instead.
            "prototype$__link__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.unlink() instead.
            "prototype$__unlink__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.exists() instead.
            "prototype$__exists__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.findById() instead.
            "prototype$__findById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.destroyById() instead.
            "prototype$__destroyById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.updateById() instead.
            "prototype$__updateById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.link() instead.
            "prototype$__link__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.unlink() instead.
            "prototype$__unlink__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.exists() instead.
            "prototype$__exists__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.findById() instead.
            "prototype$__findById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.destroyById() instead.
            "prototype$__destroyById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.updateById() instead.
            "prototype$__updateById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.link() instead.
            "prototype$__link__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.unlink() instead.
            "prototype$__unlink__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.exists() instead.
            "prototype$__exists__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.findById() instead.
            "prototype$__findById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.destroyById() instead.
            "prototype$__destroyById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.updateById() instead.
            "prototype$__updateById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.link() instead.
            "prototype$__link__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.unlink() instead.
            "prototype$__unlink__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.exists() instead.
            "prototype$__exists__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.findById() instead.
            "prototype$__findById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.destroyById() instead.
            "prototype$__destroyById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.updateById() instead.
            "prototype$__updateById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.link() instead.
            "prototype$__link__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.unlink() instead.
            "prototype$__unlink__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.exists() instead.
            "prototype$__exists__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.findById() instead.
            "prototype$__findById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.destroyById() instead.
            "prototype$__destroyById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.updateById() instead.
            "prototype$__updateById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.link() instead.
            "prototype$__link__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.unlink() instead.
            "prototype$__unlink__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.exists() instead.
            "prototype$__exists__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.findById() instead.
            "prototype$__findById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.destroyById() instead.
            "prototype$__destroyById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.updateById() instead.
            "prototype$__updateById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.link() instead.
            "prototype$__link__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.unlink() instead.
            "prototype$__unlink__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.exists() instead.
            "prototype$__exists__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/project/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Project.images.findById() instead.
            "prototype$__findById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.images.destroyById() instead.
            "prototype$__destroyById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.updateById() instead.
            "prototype$__updateById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.link() instead.
            "prototype$__link__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.unlink() instead.
            "prototype$__unlink__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.exists() instead.
            "prototype$__exists__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.avatar() instead.
            "prototype$__get__avatar": {
              url: urlBase + "/project/:id/avatar",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.updates.findById() instead.
            "prototype$__findById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.destroyById() instead.
            "prototype$__destroyById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.updateById() instead.
            "prototype$__updateById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities() instead.
            "prototype$__get__activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.create() instead.
            "prototype$__create__activities": {
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.destroyAll() instead.
            "prototype$__delete__activities": {
              url: urlBase + "/project/:id/activities",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.count() instead.
            "prototype$__count__activities": {
              url: urlBase + "/project/:id/activities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectActivities consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectActivities": {
              isArray: true,
              url: urlBase + "/project/:id/projectActivities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectActivities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectActivities": {
              url: urlBase + "/project/:id/projectActivities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectActivities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectActivities": {
              url: urlBase + "/project/:id/projectActivities",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectActivities de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectActivities": {
              url: urlBase + "/project/:id/projectActivities/count",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances() instead.
            "prototype$__get__alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.create() instead.
            "prototype$__create__alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.destroyAll() instead.
            "prototype$__delete__alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.count() instead.
            "prototype$__count__alliances": {
              url: urlBase + "/project/:id/alliances/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectAlliances consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectAlliances": {
              isArray: true,
              url: urlBase + "/project/:id/projectAlliances",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectAlliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectAlliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectAlliances de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances/count",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries() instead.
            "prototype$__get__beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.create() instead.
            "prototype$__create__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.destroyAll() instead.
            "prototype$__delete__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.count() instead.
            "prototype$__count__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectBeneficiaries consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectBeneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectBeneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectBeneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectBeneficiaries de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries/count",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions() instead.
            "prototype$__get__diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.create() instead.
            "prototype$__create__diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.destroyAll() instead.
            "prototype$__delete__diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.count() instead.
            "prototype$__count__diffusions": {
              url: urlBase + "/project/:id/diffusions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectDiffusions consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectDiffusions": {
              isArray: true,
              url: urlBase + "/project/:id/projectDiffusions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectDiffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectDiffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectDiffusions de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions/count",
              method: "GET",
            },

            // INTERNAL. Use Project.financings() instead.
            "prototype$__get__financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.create() instead.
            "prototype$__create__financings": {
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.destroyAll() instead.
            "prototype$__delete__financings": {
              url: urlBase + "/project/:id/financings",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.count() instead.
            "prototype$__count__financings": {
              url: urlBase + "/project/:id/financings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectFinancings consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectFinancings": {
              isArray: true,
              url: urlBase + "/project/:id/projectFinancings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectFinancings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectFinancings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectFinancings de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings/count",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives() instead.
            "prototype$__get__objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.create() instead.
            "prototype$__create__objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.destroyAll() instead.
            "prototype$__delete__objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.count() instead.
            "prototype$__count__objectives": {
              url: urlBase + "/project/:id/objectives/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectObjectives consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectObjectives": {
              isArray: true,
              url: urlBase + "/project/:id/projectObjectives",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectObjectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectObjectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectObjectives de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives/count",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases() instead.
            "prototype$__get__informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.create() instead.
            "prototype$__create__informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.destroyAll() instead.
            "prototype$__delete__informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.count() instead.
            "prototype$__count__informationBases": {
              url: urlBase + "/project/:id/informationBases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectInformationBases consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectInformationBases": {
              isArray: true,
              url: urlBase + "/project/:id/projectInformationBases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectInformationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectInformationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectInformationBases de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases/count",
              method: "GET",
            },

            // INTERNAL. Use Project.categories() instead.
            "prototype$__get__categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.create() instead.
            "prototype$__create__categories": {
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.destroyAll() instead.
            "prototype$__delete__categories": {
              url: urlBase + "/project/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.count() instead.
            "prototype$__count__categories": {
              url: urlBase + "/project/:id/categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectCategories consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectCategories": {
              isArray: true,
              url: urlBase + "/project/:id/projectCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectCategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectCategories": {
              url: urlBase + "/project/:id/projectCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectCategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectCategories": {
              url: urlBase + "/project/:id/projectCategories",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectCategories de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectCategories": {
              url: urlBase + "/project/:id/projectCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectImages consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectImages": {
              isArray: true,
              url: urlBase + "/project/:id/projectImages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectImages": {
              url: urlBase + "/project/:id/projectImages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectImages": {
              url: urlBase + "/project/:id/projectImages",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectImages de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectImages": {
              url: urlBase + "/project/:id/projectImages/count",
              method: "GET",
            },

            // INTERNAL. Use Project.images() instead.
            "prototype$__get__images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Project.images.create() instead.
            "prototype$__create__images": {
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.destroyAll() instead.
            "prototype$__delete__images": {
              url: urlBase + "/project/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.count() instead.
            "prototype$__count__images": {
              url: urlBase + "/project/:id/images/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * locations consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__locations": {
              isArray: true,
              url: urlBase + "/project/:id/locations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en locations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__locations": {
              url: urlBase + "/project/:id/locations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los locations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__locations": {
              url: urlBase + "/project/:id/locations",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos locations de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__locations": {
              url: urlBase + "/project/:id/locations/count",
              method: "GET",
            },

            // INTERNAL. Use Project.updates() instead.
            "prototype$__get__updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.create() instead.
            "prototype$__create__updates": {
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.destroyAll() instead.
            "prototype$__delete__updates": {
              url: urlBase + "/project/:id/updates",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.count() instead.
            "prototype$__count__updates": {
              url: urlBase + "/project/:id/updates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#create
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/project",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/project",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/project/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#upsertWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/project/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#exists
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/project/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/project/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/project/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#find
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findOne
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/project/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#updateAll
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/project/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#deleteById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/project/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#count
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/project/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$patchAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/project/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createChangeStream
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/project/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createOrUpdate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create new project
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{ProjectModel=}` -
             *
             *  - `untouchable` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "createOrUpdate": {
              url: urlBase + "/project/createOrUpdate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#advancedSearch
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get list of projects by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "advancedSearch": {
              isArray: true,
              url: urlBase + "/project/advanced-search",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#advancedCount
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Count projects by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{integer=}` -
             */
            "advancedCount": {
              url: urlBase + "/project/advanced-count",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#destroyMultiple
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/project",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#exportExcel
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `filter` – `{ProjectFilterParamsModel=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/project/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#lastPublished
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get last published projects
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "lastPublished": {
              isArray: true,
              url: urlBase + "/project/last-published",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#compareWithPublished
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Compare with published and return changes
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "compareWithPublished": {
              isArray: true,
              url: urlBase + "/project/:id/compare-with-published",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#changeStatus
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Change project status
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `status` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changeStatus": {
              url: urlBase + "/project/:id/status",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#deletePublishedVersion
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete published version of project
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deletePublishedVersion": {
              url: urlBase + "/project/:id/delete-published",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findPublishedBySlug
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find project by slug.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` - Project slug.
             *
             *  - `filter` – `{object=}` - Project filter.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findPublishedBySlug": {
              url: urlBase + "/project/find-published-by-slug/:slug",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#changePublishedDate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Change project published date
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `publishedDate` – `{date}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePublishedDate": {
              url: urlBase + "/project/:id/published-date",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#getHtml
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get html test
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "getHtml": {
              url: urlBase + "/project/get-html",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createMany
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/project",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion() instead.
            "::get::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "GET",
            },

            // INTERNAL. Use Project.publishedVersion.create() instead.
            "::create::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.createMany() instead.
            "::createMany::Project::publishedVersion": {
              isArray: true,
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.update() instead.
            "::update::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "PUT",
            },

            // INTERNAL. Use Project.publishedVersion.destroy() instead.
            "::destroy::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "DELETE",
            },

            // INTERNAL. Use Update.project() instead.
            "::get::Update::project": {
              url: urlBase + "/update/:id/project",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Project#upsert
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Project#updateOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreateWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Project#update
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Project#destroyById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#removeById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$updateAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Project#modelName
        * @propertyOf lbServices.Project
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Project`.
        */
        R.modelName = "Project";

    /**
     * @ngdoc object
     * @name lbServices.Project.publishedVersion
     * @header lbServices.Project.publishedVersion
     * @object
     * @description
     *
     * The object `Project.publishedVersion` groups methods
     * manipulating `Project` instances related to `Project`.
     *
     * Call {@link lbServices.Project#publishedVersion Project.publishedVersion()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#publishedVersion
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación hasOne publishedVersion.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#create
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Crea una nueva instancia en publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.create = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::create::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#createMany
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Crea una nueva instancia en publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.createMany = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::createMany::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#destroy
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Suprime publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.publishedVersion.destroy = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::destroy::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#update
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Actualizar publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.update = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::update::Project::publishedVersion"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.activities
     * @header lbServices.Project.activities
     * @object
     * @description
     *
     * The object `Project.activities` groups methods
     * manipulating `Activity` instances related to `Project`.
     *
     * Call {@link lbServices.Project#activities Project.activities()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#activities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * activities consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::get::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#count
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Recuentos activities de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.activities.count = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::count::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#create
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Crea una nueva instancia en activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.create = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::create::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#createMany
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Crea una nueva instancia en activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.createMany = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::createMany::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#destroyAll
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Suprime todos los activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.destroyAll = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::delete::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#destroyById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.destroyById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::destroyById::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#exists
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Comprobar la existencia de la relación activities con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.exists = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::exists::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#findById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Buscar un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.findById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::findById::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#link
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Añadir un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.link = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::link::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#unlink
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Eliminar la relación activities con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.unlink = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::unlink::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#updateById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.updateById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::updateById::Project::activities"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.alliances
     * @header lbServices.Project.alliances
     * @object
     * @description
     *
     * The object `Project.alliances` groups methods
     * manipulating `Alliance` instances related to `Project`.
     *
     * Call {@link lbServices.Project#alliances Project.alliances()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#alliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * alliances consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::get::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#count
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Recuentos alliances de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.alliances.count = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::count::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#create
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Crea una nueva instancia en alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.create = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::create::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#createMany
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Crea una nueva instancia en alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.createMany = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::createMany::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#destroyAll
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Suprime todos los alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.destroyAll = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::delete::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#destroyById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.destroyById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::destroyById::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#exists
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Comprobar la existencia de la relación alliances con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.exists = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::exists::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#findById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Buscar un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.findById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::findById::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#link
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Añadir un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.link = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::link::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#unlink
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Eliminar la relación alliances con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.unlink = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::unlink::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#updateById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.updateById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::updateById::Project::alliances"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.beneficiaries
     * @header lbServices.Project.beneficiaries
     * @object
     * @description
     *
     * The object `Project.beneficiaries` groups methods
     * manipulating `Beneficiary` instances related to `Project`.
     *
     * Call {@link lbServices.Project#beneficiaries Project.beneficiaries()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#beneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * beneficiaries consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::get::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#count
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Recuentos beneficiaries de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.beneficiaries.count = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::count::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#create
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Crea una nueva instancia en beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.create = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::create::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#createMany
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Crea una nueva instancia en beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.createMany = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::createMany::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#destroyAll
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Suprime todos los beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.destroyAll = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::delete::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#destroyById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.destroyById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::destroyById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#exists
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Comprobar la existencia de la relación beneficiaries con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.exists = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::exists::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#findById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Buscar un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.findById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::findById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#link
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Añadir un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.link = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::link::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#unlink
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Eliminar la relación beneficiaries con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.unlink = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::unlink::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#updateById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.updateById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::updateById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.diffusions
     * @header lbServices.Project.diffusions
     * @object
     * @description
     *
     * The object `Project.diffusions` groups methods
     * manipulating `Diffusion` instances related to `Project`.
     *
     * Call {@link lbServices.Project#diffusions Project.diffusions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#diffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * diffusions consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::get::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#count
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Recuentos diffusions de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.diffusions.count = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::count::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#create
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Crea una nueva instancia en diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.create = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::create::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#createMany
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Crea una nueva instancia en diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.createMany = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::createMany::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#destroyAll
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Suprime todos los diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.destroyAll = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::delete::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#destroyById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.destroyById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::destroyById::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#exists
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Comprobar la existencia de la relación diffusions con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.exists = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::exists::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#findById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Buscar un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.findById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::findById::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#link
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Añadir un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.link = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::link::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#unlink
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Eliminar la relación diffusions con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.unlink = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::unlink::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#updateById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.updateById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::updateById::Project::diffusions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.financings
     * @header lbServices.Project.financings
     * @object
     * @description
     *
     * The object `Project.financings` groups methods
     * manipulating `Financing` instances related to `Project`.
     *
     * Call {@link lbServices.Project#financings Project.financings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#financings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * financings consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::get::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#count
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Recuentos financings de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.financings.count = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::count::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#create
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Crea una nueva instancia en financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.create = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::create::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#createMany
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Crea una nueva instancia en financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.createMany = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::createMany::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#destroyAll
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Suprime todos los financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.destroyAll = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::delete::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#destroyById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.destroyById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::destroyById::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#exists
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Comprobar la existencia de la relación financings con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.exists = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::exists::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#findById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Buscar un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.findById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::findById::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#link
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Añadir un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.link = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::link::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#unlink
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Eliminar la relación financings con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.unlink = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::unlink::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#updateById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.updateById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::updateById::Project::financings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.objectives
     * @header lbServices.Project.objectives
     * @object
     * @description
     *
     * The object `Project.objectives` groups methods
     * manipulating `Objective` instances related to `Project`.
     *
     * Call {@link lbServices.Project#objectives Project.objectives()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#objectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * objectives consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::get::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#count
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Recuentos objectives de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.objectives.count = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::count::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#create
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Crea una nueva instancia en objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.create = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::create::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#createMany
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Crea una nueva instancia en objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.createMany = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::createMany::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#destroyAll
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Suprime todos los objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.destroyAll = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::delete::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#destroyById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.destroyById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::destroyById::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#exists
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Comprobar la existencia de la relación objectives con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.exists = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::exists::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#findById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Buscar un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.findById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::findById::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#link
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Añadir un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.link = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::link::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#unlink
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Eliminar la relación objectives con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.unlink = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::unlink::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#updateById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.updateById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::updateById::Project::objectives"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.informationBases
     * @header lbServices.Project.informationBases
     * @object
     * @description
     *
     * The object `Project.informationBases` groups methods
     * manipulating `InformationBase` instances related to `Project`.
     *
     * Call {@link lbServices.Project#informationBases Project.informationBases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#informationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * informationBases consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::get::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#count
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Recuentos informationBases de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.informationBases.count = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::count::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#create
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Crea una nueva instancia en informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.create = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::create::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#createMany
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Crea una nueva instancia en informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.createMany = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::createMany::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#destroyAll
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Suprime todos los informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.destroyAll = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::delete::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#destroyById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.destroyById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::destroyById::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#exists
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Comprobar la existencia de la relación informationBases con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.exists = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::exists::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#findById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Buscar un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.findById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::findById::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#link
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Añadir un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.link = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::link::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#unlink
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Eliminar la relación informationBases con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.unlink = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::unlink::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#updateById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.updateById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::updateById::Project::informationBases"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.categories
     * @header lbServices.Project.categories
     * @object
     * @description
     *
     * The object `Project.categories` groups methods
     * manipulating `Category` instances related to `Project`.
     *
     * Call {@link lbServices.Project#categories Project.categories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#categories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * categories consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#count
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Recuentos categories de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.categories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#create
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Crea una nueva instancia en categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#createMany
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Crea una nueva instancia en categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#destroyAll
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Suprime todos los categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#destroyById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#exists
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Comprobar la existencia de la relación categories con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.exists = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::exists::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#findById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Buscar un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#link
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Añadir un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.link = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::link::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#unlink
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Eliminar la relación categories con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.unlink = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::unlink::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#updateById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project#company
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación belongsTo company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Project::company"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.images
     * @header lbServices.Project.images
     * @object
     * @description
     *
     * The object `Project.images` groups methods
     * manipulating `Files` instances related to `Project`.
     *
     * Call {@link lbServices.Project#images Project.images()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#images
             * @methodOf lbServices.Project
             *
             * @description
             *
             * images consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#count
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Recuentos images de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.images.count = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::count::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#create
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.create = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::create::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#createMany
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.createMany = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::createMany::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#destroyAll
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Suprime todos los images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyAll = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::delete::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#destroyById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::destroyById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#exists
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Comprobar la existencia de la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.exists = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::exists::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#findById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Buscar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.findById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::findById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#link
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Añadir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.link = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::link::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#unlink
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Eliminar la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.unlink = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::unlink::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#updateById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.updateById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::updateById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project#avatar
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación belongsTo avatar.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.avatar = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Project::avatar"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.updates
     * @header lbServices.Project.updates
     * @object
     * @description
     *
     * The object `Project.updates` groups methods
     * manipulating `Update` instances related to `Project`.
     *
     * Call {@link lbServices.Project#updates Project.updates()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#updates
             * @methodOf lbServices.Project
             *
             * @description
             *
             * updates consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::get::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#count
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Recuentos updates de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.updates.count = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::count::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#create
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Crea una nueva instancia en updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.create = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::create::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#createMany
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Crea una nueva instancia en updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.createMany = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::createMany::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#destroyAll
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Suprime todos los updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.updates.destroyAll = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::delete::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#destroyById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.updates.destroyById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::destroyById::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#findById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Buscar un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.findById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::findById::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#updateById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.updateById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::updateById::Project::updates"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Region
 * @header lbServices.Region
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Region` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Region",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/region/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Region.provinces.findById() instead.
            "prototype$__findById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.destroyById() instead.
            "prototype$__destroyById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.updateById() instead.
            "prototype$__updateById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Region.provinces() instead.
            "prototype$__get__provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.create() instead.
            "prototype$__create__provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.destroyAll() instead.
            "prototype$__delete__provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.count() instead.
            "prototype$__count__provinces": {
              url: urlBase + "/region/:id/provinces/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#create
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/region",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#findById
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/region/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#find
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/region",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#count
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/region/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#prototype$patchAttributes
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/region/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#destroyMultiple
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/region",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#createMany
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/region",
              method: "POST",
            },

            // INTERNAL. Use Province.region() instead.
            "::get::Province::region": {
              url: urlBase + "/province/:id/region",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Region#prototype$updateAttributes
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Region#modelName
        * @propertyOf lbServices.Region
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Region`.
        */
        R.modelName = "Region";

    /**
     * @ngdoc object
     * @name lbServices.Region.provinces
     * @header lbServices.Region.provinces
     * @object
     * @description
     *
     * The object `Region.provinces` groups methods
     * manipulating `Province` instances related to `Region`.
     *
     * Call {@link lbServices.Region#provinces Region.provinces()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Region#provinces
             * @methodOf lbServices.Region
             *
             * @description
             *
             * provinces consultas de Region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#count
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Recuentos provinces de Region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.provinces.count = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::count::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#create
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Crea una nueva instancia en provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.create = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::create::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#createMany
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Crea una nueva instancia en provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.createMany = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::createMany::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#destroyAll
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Suprime todos los provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.provinces.destroyAll = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::delete::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#destroyById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.provinces.destroyById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::destroyById::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#findById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Buscar un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.findById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::findById::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#updateById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.updateById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::updateById::Region::provinces"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Province
 * @header lbServices.Province
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Province` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Province",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/province/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Province.region() instead.
            "prototype$__get__region": {
              url: urlBase + "/province/:id/region",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#create
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/province",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#findById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/province/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#find
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/province",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#count
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/province/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$patchAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/province/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#destroyMultiple
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/province",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#createMany
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/province",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.findById() instead.
            "::findById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.destroyById() instead.
            "::destroyById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.updateById() instead.
            "::updateById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Region.provinces() instead.
            "::get::Region::provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.create() instead.
            "::create::Region::provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.createMany() instead.
            "::createMany::Region::provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.destroyAll() instead.
            "::delete::Region::provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.count() instead.
            "::count::Region::provinces": {
              url: urlBase + "/region/:id/provinces/count",
              method: "GET",
            },

            // INTERNAL. Use District.province() instead.
            "::get::District::province": {
              url: urlBase + "/district/:id/province",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$updateAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Province#modelName
        * @propertyOf lbServices.Province
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Province`.
        */
        R.modelName = "Province";


            /**
             * @ngdoc method
             * @name lbServices.Province#region
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Capta la relación belongsTo region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
        R.region = function() {
          var TargetResource = $injector.get("Region");
          var action = TargetResource["::get::Province::region"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Objective
 * @header lbServices.Objective
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Objective` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Objective",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/objective/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Objective.image() instead.
            "prototype$__get__image": {
              url: urlBase + "/objective/:id/image",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#create
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/objective",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#findById
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/objective/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#find
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/objective",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#count
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/objective/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#prototype$patchAttributes
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/objective/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#destroyMultiple
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/objective",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#createMany
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/objective",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.findById() instead.
            "::findById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.destroyById() instead.
            "::destroyById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.updateById() instead.
            "::updateById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.link() instead.
            "::link::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.unlink() instead.
            "::unlink::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.exists() instead.
            "::exists::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.objectives() instead.
            "::get::Project::objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.create() instead.
            "::create::Project::objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.createMany() instead.
            "::createMany::Project::objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.destroyAll() instead.
            "::delete::Project::objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.count() instead.
            "::count::Project::objectives": {
              url: urlBase + "/project/:id/objectives/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Objective#prototype$updateAttributes
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Objective#modelName
        * @propertyOf lbServices.Objective
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Objective`.
        */
        R.modelName = "Objective";


            /**
             * @ngdoc method
             * @name lbServices.Objective#image
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Capta la relación belongsTo image.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.image = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Objective::image"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Activity
 * @header lbServices.Activity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Activity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Activity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activity/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Activity#create
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/activity",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#findById
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/activity/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#find
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/activity",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#count
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/activity/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#prototype$patchAttributes
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Activity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/activity/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#destroyMultiple
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/activity",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#createMany
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/activity",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.findById() instead.
            "::findById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.destroyById() instead.
            "::destroyById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.updateById() instead.
            "::updateById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.link() instead.
            "::link::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.unlink() instead.
            "::unlink::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.exists() instead.
            "::exists::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.activities() instead.
            "::get::Project::activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.create() instead.
            "::create::Project::activities": {
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.createMany() instead.
            "::createMany::Project::activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.destroyAll() instead.
            "::delete::Project::activities": {
              url: urlBase + "/project/:id/activities",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.count() instead.
            "::count::Project::activities": {
              url: urlBase + "/project/:id/activities/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Activity#prototype$updateAttributes
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Activity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Activity#modelName
        * @propertyOf lbServices.Activity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Activity`.
        */
        R.modelName = "Activity";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InformationBase
 * @header lbServices.InformationBase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InformationBase` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InformationBase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/information-base/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#create
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/information-base",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#findById
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/information-base/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#find
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/information-base",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#count
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/information-base/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#prototype$patchAttributes
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InformationBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/information-base/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#destroyMultiple
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/information-base",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#createMany
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/information-base",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.findById() instead.
            "::findById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.destroyById() instead.
            "::destroyById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.updateById() instead.
            "::updateById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.link() instead.
            "::link::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.unlink() instead.
            "::unlink::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.exists() instead.
            "::exists::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.informationBases() instead.
            "::get::Project::informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.create() instead.
            "::create::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.createMany() instead.
            "::createMany::Project::informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.destroyAll() instead.
            "::delete::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.count() instead.
            "::count::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InformationBase#prototype$updateAttributes
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InformationBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InformationBase#modelName
        * @propertyOf lbServices.InformationBase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InformationBase`.
        */
        R.modelName = "InformationBase";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Alliance
 * @header lbServices.Alliance
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Alliance` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Alliance",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/alliance/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Alliance#create
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/alliance",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#findById
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/alliance/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#find
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/alliance",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#count
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/alliance/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#prototype$patchAttributes
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Alliance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/alliance/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#destroyMultiple
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/alliance",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#createMany
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/alliance",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.findById() instead.
            "::findById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.destroyById() instead.
            "::destroyById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.updateById() instead.
            "::updateById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.link() instead.
            "::link::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.unlink() instead.
            "::unlink::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.exists() instead.
            "::exists::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.alliances() instead.
            "::get::Project::alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.create() instead.
            "::create::Project::alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.createMany() instead.
            "::createMany::Project::alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.destroyAll() instead.
            "::delete::Project::alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.count() instead.
            "::count::Project::alliances": {
              url: urlBase + "/project/:id/alliances/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Alliance#prototype$updateAttributes
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Alliance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Alliance#modelName
        * @propertyOf lbServices.Alliance
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Alliance`.
        */
        R.modelName = "Alliance";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Financing
 * @header lbServices.Financing
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Financing` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Financing",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/financing/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Financing#create
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/financing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#findById
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/financing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#find
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/financing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#count
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/financing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#prototype$patchAttributes
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Financing id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/financing/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#destroyMultiple
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/financing",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#createMany
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/financing",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.findById() instead.
            "::findById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.destroyById() instead.
            "::destroyById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.updateById() instead.
            "::updateById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.link() instead.
            "::link::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.unlink() instead.
            "::unlink::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.exists() instead.
            "::exists::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.financings() instead.
            "::get::Project::financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.create() instead.
            "::create::Project::financings": {
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.createMany() instead.
            "::createMany::Project::financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.destroyAll() instead.
            "::delete::Project::financings": {
              url: urlBase + "/project/:id/financings",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.count() instead.
            "::count::Project::financings": {
              url: urlBase + "/project/:id/financings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Financing#prototype$updateAttributes
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Financing id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Financing#modelName
        * @propertyOf lbServices.Financing
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Financing`.
        */
        R.modelName = "Financing";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Beneficiary
 * @header lbServices.Beneficiary
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Beneficiary` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Beneficiary",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/beneficiary/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#create
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/beneficiary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#findById
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/beneficiary/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#find
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/beneficiary",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#count
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/beneficiary/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#prototype$patchAttributes
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Beneficiary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/beneficiary/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#destroyMultiple
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/beneficiary",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#createMany
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/beneficiary",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.findById() instead.
            "::findById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.destroyById() instead.
            "::destroyById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.updateById() instead.
            "::updateById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.link() instead.
            "::link::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.unlink() instead.
            "::unlink::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.exists() instead.
            "::exists::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.beneficiaries() instead.
            "::get::Project::beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.create() instead.
            "::create::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.createMany() instead.
            "::createMany::Project::beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.destroyAll() instead.
            "::delete::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.count() instead.
            "::count::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#prototype$updateAttributes
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Beneficiary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Beneficiary#modelName
        * @propertyOf lbServices.Beneficiary
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Beneficiary`.
        */
        R.modelName = "Beneficiary";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Diffusion
 * @header lbServices.Diffusion
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Diffusion` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Diffusion",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/diffusion/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#create
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/diffusion",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#findById
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/diffusion/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#find
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/diffusion",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#count
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/diffusion/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#prototype$patchAttributes
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Diffusion id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/diffusion/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#destroyMultiple
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/diffusion",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#createMany
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/diffusion",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.findById() instead.
            "::findById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.destroyById() instead.
            "::destroyById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.updateById() instead.
            "::updateById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.link() instead.
            "::link::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.unlink() instead.
            "::unlink::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.exists() instead.
            "::exists::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.diffusions() instead.
            "::get::Project::diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.create() instead.
            "::create::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.createMany() instead.
            "::createMany::Project::diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.destroyAll() instead.
            "::delete::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.count() instead.
            "::count::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Diffusion#prototype$updateAttributes
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Diffusion id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Diffusion#modelName
        * @propertyOf lbServices.Diffusion
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Diffusion`.
        */
        R.modelName = "Diffusion";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Synchronization
 * @header lbServices.Synchronization
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Synchronization` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Synchronization",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/synchronization/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#find
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/synchronization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#count
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/synchronization/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#destroyMultiple
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/synchronization",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#syncUsers
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Sync associated users
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "syncUsers": {
              url: urlBase + "/synchronization/syncUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#getDataToSync
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Get remote data to sync
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "getDataToSync": {
              isArray: true,
              url: urlBase + "/synchronization/getDataToSync",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Synchronization#modelName
        * @propertyOf lbServices.Synchronization
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Synchronization`.
        */
        R.modelName = "Synchronization";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Page
 * @header lbServices.Page
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Page` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Page",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/page/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Page#create
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/page",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#patchOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/page",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#replaceOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/page/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#upsertWithWhere
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/page/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#exists
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/page/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#findById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/page/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#replaceById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/page/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#find
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#findOne
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/page/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#updateAll
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/page/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#deleteById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/page/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#count
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/page/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#prototype$patchAttributes
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Page id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/page/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#createChangeStream
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/page/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#contact
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Contact with us.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "contact": {
              url: urlBase + "/page/contact",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#createMany
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/page",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Page#upsert
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Page#updateOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Page#patchOrCreateWithWhere
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Page#update
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Page#destroyById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Page#removeById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Page#prototype$updateAttributes
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Page id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Page#modelName
        * @propertyOf lbServices.Page
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Page`.
        */
        R.modelName = "Page";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Configuration
 * @header lbServices.Configuration
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Configuration` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Configuration",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/configuration/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Configuration#create
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configuration",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#patchOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/configuration",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#replaceOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configuration/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#upsertWithWhere
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configuration/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#exists
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configuration/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#findById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configuration/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#replaceById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configuration/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#find
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configuration",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#findOne
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configuration/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#updateAll
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configuration/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#deleteById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configuration/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#count
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configuration/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#prototype$patchAttributes
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Configuration id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/configuration/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#createChangeStream
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configuration/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#createMany
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configuration",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Configuration#upsert
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#updateOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#patchOrCreateWithWhere
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#update
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#destroyById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#removeById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#prototype$updateAttributes
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Configuration id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Configuration#modelName
        * @propertyOf lbServices.Configuration
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Configuration`.
        */
        R.modelName = "Configuration";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteFiscalData
 * @header lbServices.RemoteFiscalData
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteFiscalData` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteFiscalData",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteFiscalData/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteFiscalData#find
             * @methodOf lbServices.RemoteFiscalData
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteFiscalData` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteFiscalData",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.datosFiscales() instead.
            "::get::RemoteCompany::datosFiscales": {
              url: urlBase + "/RemoteCompanies/:id/datosFiscales",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteFiscalData#modelName
        * @propertyOf lbServices.RemoteFiscalData
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteFiscalData`.
        */
        R.modelName = "RemoteFiscalData";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteCompany
 * @header lbServices.RemoteCompany
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteCompany` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteCompany",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteCompanies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RemoteCompany.datosFiscales() instead.
            "prototype$__get__datosFiscales": {
              url: urlBase + "/RemoteCompanies/:id/datosFiscales",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.tipoInstitucion() instead.
            "prototype$__get__tipoInstitucion": {
              url: urlBase + "/RemoteCompanies/:id/tipoInstitucion",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#find
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteCompany` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteCompanies",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteCompany#modelName
        * @propertyOf lbServices.RemoteCompany
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteCompany`.
        */
        R.modelName = "RemoteCompany";


            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#datosFiscales
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Capta la relación belongsTo datosFiscales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteCompany id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteFiscalData` object.)
             * </em>
             */
        R.datosFiscales = function() {
          var TargetResource = $injector.get("RemoteFiscalData");
          var action = TargetResource["::get::RemoteCompany::datosFiscales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#tipoInstitucion
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Capta la relación belongsTo tipoInstitucion.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteCompany id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteInstitutionKind` object.)
             * </em>
             */
        R.tipoInstitucion = function() {
          var TargetResource = $injector.get("RemoteInstitutionKind");
          var action = TargetResource["::get::RemoteCompany::tipoInstitucion"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteSubSector
 * @header lbServices.RemoteSubSector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteSubSector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteSubSector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteSubSectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteSubSector#find
             * @methodOf lbServices.RemoteSubSector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSubSector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteSubSectors",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.subsector() instead.
            "::get::RemoteInstitutionKind::subsector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/subsector",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteSubSector#modelName
        * @propertyOf lbServices.RemoteSubSector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteSubSector`.
        */
        R.modelName = "RemoteSubSector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteSector
 * @header lbServices.RemoteSector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteSector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteSector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteSectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteSector#find
             * @methodOf lbServices.RemoteSector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteSectors",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.sector() instead.
            "::get::RemoteInstitutionKind::sector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/sector",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteSector#modelName
        * @propertyOf lbServices.RemoteSector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteSector`.
        */
        R.modelName = "RemoteSector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteInstitutionKind
 * @header lbServices.RemoteInstitutionKind
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteInstitutionKind` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteInstitutionKind",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteInstitutionKinds/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RemoteInstitutionKind.subsector() instead.
            "prototype$__get__subsector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/subsector",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.sector() instead.
            "prototype$__get__sector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/sector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#find
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteInstitutionKind` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteInstitutionKinds",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.tipoInstitucion() instead.
            "::get::RemoteCompany::tipoInstitucion": {
              url: urlBase + "/RemoteCompanies/:id/tipoInstitucion",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteInstitutionKind#modelName
        * @propertyOf lbServices.RemoteInstitutionKind
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteInstitutionKind`.
        */
        R.modelName = "RemoteInstitutionKind";


            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#subsector
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Capta la relación belongsTo subsector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteInstitutionKind id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSubSector` object.)
             * </em>
             */
        R.subsector = function() {
          var TargetResource = $injector.get("RemoteSubSector");
          var action = TargetResource["::get::RemoteInstitutionKind::subsector"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#sector
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Capta la relación belongsTo sector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteInstitutionKind id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSector` object.)
             * </em>
             */
        R.sector = function() {
          var TargetResource = $injector.get("RemoteSector");
          var action = TargetResource["::get::RemoteInstitutionKind::sector"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Company
 * @header lbServices.Company
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Company` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Company",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/company/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Company.administrators.link() instead.
            "prototype$__link__administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.administrators.unlink() instead.
            "prototype$__unlink__administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.administrators() instead.
            "prototype$__get__administrators": {
              isArray: true,
              url: urlBase + "/company/:id/administrators",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#findById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/company/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#find
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/company",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#count
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/company/count",
              method: "GET",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.link() instead.
            "::link::UserEntity::notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.unlink() instead.
            "::unlink::UserEntity::notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserEntity.notificationCompanies() instead.
            "::get::UserEntity::notificationCompanies": {
              isArray: true,
              url: urlBase + "/user/:id/notificationCompanies",
              method: "GET",
            },

            // INTERNAL. Use Project.company() instead.
            "::get::Project::company": {
              url: urlBase + "/project/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company() instead.
            "::get::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company.create() instead.
            "::create::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.createMany() instead.
            "::createMany::UserAssociated::company": {
              isArray: true,
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.update() instead.
            "::update::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "PUT",
            },

            // INTERNAL. Use Article.company() instead.
            "::get::Article::company": {
              url: urlBase + "/article/:id/company",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Company#modelName
        * @propertyOf lbServices.Company
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Company`.
        */
        R.modelName = "Company";

    /**
     * @ngdoc object
     * @name lbServices.Company.administrators
     * @header lbServices.Company.administrators
     * @object
     * @description
     *
     * The object `Company.administrators` groups methods
     * manipulating `UserEntity` instances related to `Company`.
     *
     * Call {@link lbServices.Company#administrators Company.administrators()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#administrators
             * @methodOf lbServices.Company
             *
             * @description
             *
             * administrators consultas de Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R.administrators = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::get::Company::administrators"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.administrators#link
             * @methodOf lbServices.Company.administrators
             *
             * @description
             *
             * Añadir un elemento relacionado por id para administrators.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Clave foránea para administrators
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R.administrators.link = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::link::Company::administrators"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.administrators#unlink
             * @methodOf lbServices.Company.administrators
             *
             * @description
             *
             * Eliminar la relación administrators con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para administrators
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.administrators.unlink = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::unlink::Company::administrators"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserAssociated
 * @header lbServices.UserAssociated
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserAssociated` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserAssociated",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/user-associated/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserAssociated.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company.create() instead.
            "prototype$__create__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.update() instead.
            "prototype$__update__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#create
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/user-associated",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#findById
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/user-associated/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#replaceById
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/user-associated/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#find
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/user-associated",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#count
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/user-associated/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#prototype$patchAttributes
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/user-associated/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#login
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/user-associated/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#logout
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/user-associated/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#destroyMultiple
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/user-associated",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#sendNewPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Generate new password and send by email
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "sendNewPassword": {
              url: urlBase + "/user-associated/:id/send-new-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#showPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Show user associated plain password
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `password` – `{string=}` -
             */
            "showPassword": {
              url: urlBase + "/user-associated/:id/show-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#exportExcel
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/user-associated/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#getProjects
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get projects of user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `search` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "getProjects": {
              isArray: true,
              url: urlBase + "/user-associated/:id/projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#sendPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Send password
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `username` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "sendPassword": {
              url: urlBase + "/user-associated/send-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#advancedSearch
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get list of user associated by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "advancedSearch": {
              isArray: true,
              url: urlBase + "/user-associated/advanced-search",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#advancedCount
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Count user associated by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{integer=}` -
             */
            "advancedCount": {
              url: urlBase + "/user-associated/advanced-count",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#createMany
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/user-associated",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#getCurrent
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/user-associated" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#prototype$updateAttributes
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#getCachedCurrent
         * @methodOf lbServices.UserAssociated
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.UserAssociated#login} or
         * {@link lbServices.UserAssociated#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A UserAssociated instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#isAuthenticated
         * @methodOf lbServices.UserAssociated
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#getCurrentId
         * @methodOf lbServices.UserAssociated
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.UserAssociated#modelName
        * @propertyOf lbServices.UserAssociated
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserAssociated`.
        */
        R.modelName = "UserAssociated";

    /**
     * @ngdoc object
     * @name lbServices.UserAssociated.company
     * @header lbServices.UserAssociated.company
     * @object
     * @description
     *
     * The object `UserAssociated.company` groups methods
     * manipulating `Company` instances related to `UserAssociated`.
     *
     * Call {@link lbServices.UserAssociated#company UserAssociated.company()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#company
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Capta la relación hasOne company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#create
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Crea una nueva instancia en company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.create = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::create::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#createMany
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Crea una nueva instancia en company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.createMany = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::createMany::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#update
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Actualizar company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.update = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::update::UserAssociated::company"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Container
 * @header lbServices.Container
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Container` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Container",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/container/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainers
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#download
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/container/:container/download/:file",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Container#modelName
        * @propertyOf lbServices.Container
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Container`.
        */
        R.modelName = "Container";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Files
 * @header lbServices.Files
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Files` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Files",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/files/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Files#find
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#deleteById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/files/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#count
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/files/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#prototype$patchAttributes
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Files id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/files/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#upload
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Upload files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "upload": {
              url: urlBase + "/files/:container/upload",
              method: "POST",
            },

            // INTERNAL. Use Sector.imageMarker() instead.
            "::get::Sector::imageMarker": {
              url: urlBase + "/sector/:id/imageMarker",
              method: "GET",
            },

            // INTERNAL. Use Sector.imageLogo() instead.
            "::get::Sector::imageLogo": {
              url: urlBase + "/sector/:id/imageLogo",
              method: "GET",
            },

            // INTERNAL. Use Project.images.findById() instead.
            "::findById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.images.destroyById() instead.
            "::destroyById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.updateById() instead.
            "::updateById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.link() instead.
            "::link::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.unlink() instead.
            "::unlink::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.exists() instead.
            "::exists::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.avatar() instead.
            "::get::Project::avatar": {
              url: urlBase + "/project/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Project.images() instead.
            "::get::Project::images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Project.images.create() instead.
            "::create::Project::images": {
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.createMany() instead.
            "::createMany::Project::images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.destroyAll() instead.
            "::delete::Project::images": {
              url: urlBase + "/project/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.count() instead.
            "::count::Project::images": {
              url: urlBase + "/project/:id/images/count",
              method: "GET",
            },

            // INTERNAL. Use Objective.image() instead.
            "::get::Objective::image": {
              url: urlBase + "/objective/:id/image",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageWeb() instead.
            "::get::Banner::imageWeb": {
              url: urlBase + "/banner/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageMobile() instead.
            "::get::Banner::imageMobile": {
              url: urlBase + "/banner/:id/imageMobile",
              method: "GET",
            },

            // INTERNAL. Use Image.imageWeb() instead.
            "::get::Image::imageWeb": {
              url: urlBase + "/image/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Image.imageMobile() instead.
            "::get::Image::imageMobile": {
              url: urlBase + "/image/:id/imageMobile",
              method: "GET",
            },

            // INTERNAL. Use Article.avatar() instead.
            "::get::Article::avatar": {
              url: urlBase + "/article/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Article.images.findById() instead.
            "::findById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Article.images.destroyById() instead.
            "::destroyById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.updateById() instead.
            "::updateById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.link() instead.
            "::link::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.unlink() instead.
            "::unlink::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.exists() instead.
            "::exists::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Article.images() instead.
            "::get::Article::images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Article.images.create() instead.
            "::create::Article::images": {
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.createMany() instead.
            "::createMany::Article::images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.destroyAll() instead.
            "::delete::Article::images": {
              url: urlBase + "/article/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.count() instead.
            "::count::Article::images": {
              url: urlBase + "/article/:id/images/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Files#destroyById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Files#removeById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Files#prototype$updateAttributes
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Files id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Files#modelName
        * @propertyOf lbServices.Files
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Files`.
        */
        R.modelName = "Files";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Subscription
 * @header lbServices.Subscription
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Subscription` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Subscription",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscription/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Subscription#create
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#findById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscription/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#find
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscription",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#count
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscription/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$patchAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscription/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#destroyMultiple
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/subscription",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#resend
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Resend subscription confirmation email
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "resend": {
              url: urlBase + "/subscription/:id/resend",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#exportExcel
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/subscription/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#importExcel
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Import excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "importExcel": {
              url: urlBase + "/subscription/import-excel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#confirm
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Confirm subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/subscription/confirm/:token",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createSubscription
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "createSubscription": {
              url: urlBase + "/subscription/create-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createMany
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscription",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$updateAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Subscription#modelName
        * @propertyOf lbServices.Subscription
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Subscription`.
        */
        R.modelName = "Subscription";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Email
 * @header lbServices.Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emails/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Email#modelName
        * @propertyOf lbServices.Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Email`.
        */
        R.modelName = "Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Bulletin
 * @header lbServices.Bulletin
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Bulletin` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Bulletin",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/bulletin/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#create
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/bulletin",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#patchOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/bulletin",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#replaceOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/bulletin/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#upsertWithWhere
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/bulletin/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#exists
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/bulletin/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#findById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/bulletin/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#replaceById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/bulletin/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#find
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/bulletin",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#findOne
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/bulletin/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#updateAll
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/bulletin/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#deleteById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/bulletin/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#count
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/bulletin/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#prototype$patchAttributes
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bulletin id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/bulletin/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#createChangeStream
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/bulletin/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#destroyMultiple
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/bulletin",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#preview
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Get preview of bulletin.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `projects` – `{*=}` - Bulletin project ids.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "preview": {
              url: urlBase + "/bulletin/preview",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#getStatus
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Get delivery status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` - bulletin Id.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "getStatus": {
              url: urlBase + "/bulletin/:id/status",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#createMany
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/bulletin",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Bulletin#upsert
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#updateOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#patchOrCreateWithWhere
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#update
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#destroyById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#removeById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#prototype$updateAttributes
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bulletin id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Bulletin#modelName
        * @propertyOf lbServices.Bulletin
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Bulletin`.
        */
        R.modelName = "Bulletin";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.District
 * @header lbServices.District
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `District` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "District",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/district/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use District.province() instead.
            "prototype$__get__province": {
              url: urlBase + "/district/:id/province",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#create
             * @methodOf lbServices.District
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/district",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#findById
             * @methodOf lbServices.District
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/district/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#find
             * @methodOf lbServices.District
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/district",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#count
             * @methodOf lbServices.District
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/district/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#prototype$patchAttributes
             * @methodOf lbServices.District
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/district/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#destroyMultiple
             * @methodOf lbServices.District
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/district",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#createMany
             * @methodOf lbServices.District
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/district",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.District#prototype$updateAttributes
             * @methodOf lbServices.District
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.District#modelName
        * @propertyOf lbServices.District
        * @description
        * The name of the model represented by this $resource,
        * i.e. `District`.
        */
        R.modelName = "District";


            /**
             * @ngdoc method
             * @name lbServices.District#province
             * @methodOf lbServices.District
             *
             * @description
             *
             * Capta la relación belongsTo province.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.province = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::District::province"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProjectModel
 * @header lbServices.ProjectModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProjectModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProjectModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ProjectModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ProjectModel#modelName
        * @propertyOf lbServices.ProjectModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProjectModel`.
        */
        R.modelName = "ProjectModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Banner
 * @header lbServices.Banner
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Banner` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Banner",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/banner/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Banner.imageWeb() instead.
            "prototype$__get__imageWeb": {
              url: urlBase + "/banner/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageMobile() instead.
            "prototype$__get__imageMobile": {
              url: urlBase + "/banner/:id/imageMobile",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#create
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/banner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#patchOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/banner",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#replaceOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/banner/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#upsertWithWhere
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/banner/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#exists
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/banner/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#findById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/banner/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#replaceById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/banner/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#find
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/banner",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#findOne
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/banner/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#updateAll
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/banner/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#deleteById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/banner/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#count
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/banner/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#prototype$patchAttributes
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/banner/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#createChangeStream
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/banner/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#destroyMultiple
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/banner",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#createMany
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/banner",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Banner#upsert
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#updateOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#patchOrCreateWithWhere
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#update
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#destroyById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#removeById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#prototype$updateAttributes
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Banner#modelName
        * @propertyOf lbServices.Banner
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Banner`.
        */
        R.modelName = "Banner";


            /**
             * @ngdoc method
             * @name lbServices.Banner#imageWeb
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Capta la relación belongsTo imageWeb.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageWeb = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Banner::imageWeb"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Banner#imageMobile
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Capta la relación belongsTo imageMobile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMobile = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Banner::imageMobile"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Image
 * @header lbServices.Image
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Image` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Image",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/image/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Image.imageWeb() instead.
            "prototype$__get__imageWeb": {
              url: urlBase + "/image/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Image.imageMobile() instead.
            "prototype$__get__imageMobile": {
              url: urlBase + "/image/:id/imageMobile",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#create
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/image",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#patchOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/image",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#replaceOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/image/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#upsertWithWhere
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/image/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#exists
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/image/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#findById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/image/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#replaceById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/image/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#find
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/image",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#findOne
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/image/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#updateAll
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/image/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#deleteById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/image/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#count
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/image/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#prototype$patchAttributes
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/image/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#createChangeStream
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/image/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#destroyMultiple
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/image",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#createMany
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/image",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Image#upsert
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Image#updateOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Image#patchOrCreateWithWhere
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Image#update
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Image#destroyById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Image#removeById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Image#prototype$updateAttributes
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Image#modelName
        * @propertyOf lbServices.Image
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Image`.
        */
        R.modelName = "Image";


            /**
             * @ngdoc method
             * @name lbServices.Image#imageWeb
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Capta la relación belongsTo imageWeb.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageWeb = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Image::imageWeb"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Image#imageMobile
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Capta la relación belongsTo imageMobile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMobile = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Image::imageMobile"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProjectFilterParamsModel
 * @header lbServices.ProjectFilterParamsModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProjectFilterParamsModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProjectFilterParamsModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ProjectFilterParamsModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ProjectFilterParamsModel#modelName
        * @propertyOf lbServices.ProjectFilterParamsModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProjectFilterParamsModel`.
        */
        R.modelName = "ProjectFilterParamsModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Update
 * @header lbServices.Update
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Update` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Update",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/update/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Update.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/update/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#create
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#findById
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/update/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#find
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/update",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#count
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/update/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#prototype$patchAttributes
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/update/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#destroyMultiple
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/update",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#createMany
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/update",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.findById() instead.
            "::findById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.destroyById() instead.
            "::destroyById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.updateById() instead.
            "::updateById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.updates() instead.
            "::get::Project::updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.create() instead.
            "::create::Project::updates": {
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.createMany() instead.
            "::createMany::Project::updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.destroyAll() instead.
            "::delete::Project::updates": {
              url: urlBase + "/project/:id/updates",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.count() instead.
            "::count::Project::updates": {
              url: urlBase + "/project/:id/updates/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Update#prototype$updateAttributes
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Update#modelName
        * @propertyOf lbServices.Update
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Update`.
        */
        R.modelName = "Update";


            /**
             * @ngdoc method
             * @name lbServices.Update#project
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Capta la relación belongsTo project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Update::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ContactFormModel
 * @header lbServices.ContactFormModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ContactFormModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ContactFormModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ContactFormModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ContactFormModel#modelName
        * @propertyOf lbServices.ContactFormModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ContactFormModel`.
        */
        R.modelName = "ContactFormModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserAssociatedFilterParamsModel
 * @header lbServices.UserAssociatedFilterParamsModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserAssociatedFilterParamsModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserAssociatedFilterParamsModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/UserAssociatedFilterParamsModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.UserAssociatedFilterParamsModel#modelName
        * @propertyOf lbServices.UserAssociatedFilterParamsModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserAssociatedFilterParamsModel`.
        */
        R.modelName = "UserAssociatedFilterParamsModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Article
 * @header lbServices.Article
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Article` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Article",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/article/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Article.avatar() instead.
            "prototype$__get__avatar": {
              url: urlBase + "/article/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Article.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/article/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Article.sector() instead.
            "prototype$__get__sector": {
              url: urlBase + "/article/:id/sector",
              method: "GET",
            },

            // INTERNAL. Use Article.images.findById() instead.
            "prototype$__findById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Article.images.destroyById() instead.
            "prototype$__destroyById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.updateById() instead.
            "prototype$__updateById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.link() instead.
            "prototype$__link__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.unlink() instead.
            "prototype$__unlink__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.exists() instead.
            "prototype$__exists__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__findById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Buscar un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__findById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__destroyById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__updateById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__updateById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images() instead.
            "prototype$__get__images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Article.images.create() instead.
            "prototype$__create__images": {
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.destroyAll() instead.
            "prototype$__delete__images": {
              url: urlBase + "/article/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.count() instead.
            "prototype$__count__images": {
              url: urlBase + "/article/:id/images/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__get__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * articleImages consultas de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__get__articleImages": {
              isArray: true,
              url: urlBase + "/article/:id/articleImages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__create__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Crea una nueva instancia en articleImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__create__articleImages": {
              url: urlBase + "/article/:id/articleImages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__delete__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Suprime todos los articleImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__articleImages": {
              url: urlBase + "/article/:id/articleImages",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__count__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Recuentos articleImages de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__articleImages": {
              url: urlBase + "/article/:id/articleImages/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#create
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/article",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#findById
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/article/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#find
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/article",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#count
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/article/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$patchAttributes
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/article/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#changePublishedDate
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Change article published date
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `publishedDate` – `{date}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePublishedDate": {
              url: urlBase + "/article/:id/published-date",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#findPublishedBySlug
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find article by slug.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` - Article slug.
             *
             *  - `filter` – `{object=}` - Article filter.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "findPublishedBySlug": {
              url: urlBase + "/article/find-published-by-slug/:slug",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#createMany
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/article",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$updateAttributes
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Article#modelName
        * @propertyOf lbServices.Article
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Article`.
        */
        R.modelName = "Article";


            /**
             * @ngdoc method
             * @name lbServices.Article#avatar
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo avatar.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.avatar = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Article::avatar"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article#company
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Article::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article#sector
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo sector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
        R.sector = function() {
          var TargetResource = $injector.get("Sector");
          var action = TargetResource["::get::Article::sector"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Article.images
     * @header lbServices.Article.images
     * @object
     * @description
     *
     * The object `Article.images` groups methods
     * manipulating `Files` instances related to `Article`.
     *
     * Call {@link lbServices.Article#images Article.images()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Article#images
             * @methodOf lbServices.Article
             *
             * @description
             *
             * images consultas de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#count
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Recuentos images de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.images.count = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::count::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#create
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.create = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::create::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#createMany
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.createMany = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::createMany::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#destroyAll
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Suprime todos los images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyAll = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::delete::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#destroyById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::destroyById::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#exists
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Comprobar la existencia de la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.exists = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::exists::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#findById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Buscar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.findById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::findById::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#link
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Añadir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.link = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::link::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#unlink
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Eliminar la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.unlink = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::unlink::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#updateById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.updateById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::updateById::Article::images"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('projectFieldUtils', projectFieldUtils);

    /** @ngInject */
    function projectFieldUtils($rootScope, projectFieldVisibility, projectFieldValidation, LoopBackAuth, UserAssociated) {
        this.isVisible = function (fieldName) {
            return !!(this.isPublic(fieldName) || (this.isPrivate(fieldName) && UserAssociated.isAuthenticated()));
        };
        this.isVisibleSomeItem = function (fieldNames) {
            if (Array.isArray(fieldNames)) {
                for (var i = 0; i < fieldNames.length; i++) {
                    if (this.isVisible(fieldNames[i])) {
                        return true;
                    }
                }
            } else {
                console.log('Fieldnames array expected.');
            }
            return false;
        };
        this.isPrivate = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.PRIVATE;
        };
        this.isPublic = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.PUBLIC;
        };
        this.isHidden = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.HIDDEN;
        };
        this.isOwner = function (projectCompanyId) {
            if (UserAssociated.isAuthenticated() && $rootScope.userLogged && $rootScope.userLogged.company) {
                return $rootScope.userLogged.company.id === projectCompanyId;
            }
            return false;
        };
        this.isPublicOrOwner = function (fieldName, projectCompanyId) {
            return this.isPublic(fieldName) || this.isOwner(projectCompanyId);
        };
        this.getVisibility = function (fieldName) {
            return ($rootScope.currentConfig &&
                $rootScope.currentConfig.project &&
                $rootScope.currentConfig.project[fieldName] &&
                $rootScope.currentConfig.project[fieldName].visibility) ?
                $rootScope.currentConfig.project[fieldName].visibility :
                undefined;
        };
        this.getValidation = function (fieldName) {
            return ($rootScope.currentConfig &&
                $rootScope.currentConfig.project &&
                $rootScope.currentConfig.project[fieldName] &&
                $rootScope.currentConfig.project[fieldName].validation) ?
                $rootScope.currentConfig.project[fieldName].validation :
                undefined;
        };
        this.isRequired = function (fieldName) {
            return this.getValidation(fieldName) === projectFieldValidation.REQUIRED;
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .factory('PubSub', PubSub);

    /** @ngInject */
    function PubSub(socket) {
        var container = [];
        return {
            subscribe: function (options, callback) {
                if (options) {
                    var collectionName = options.collectionName;
                    var modelId = options.modelId;
                    var method = options.method;
                    if (method === 'POST') {
                        var name = '/' + collectionName + '/' + method;
                        socket.on(name, callback);
                    }
                    else {
                        var name = '/' + collectionName + '/' + modelId + '/' + method;
                        socket.on(name, callback);
                    }
                    //Push the container..
                    this.pushContainer(name);
                } else {
                    throw 'Error: Option must be an object';
                }
            }, //end subscribe

            pushContainer: function (subscriptionName) {
                container.push(subscriptionName);
            },

            //Unsubscribe all containers..
            unSubscribeAll: function () {
                for (var i = 0; i < container.length; i++) {
                    socket.removeAllListeners(container[i]);
                }
                //Now reset the container..
                container = [];
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('sharedLink', ShareLink);

    /** @ngInject */
    function ShareLink() {
        return {
            facebook: function (url) {
                url = encodeURI(url);
                return 'https://www.facebook.com/sharer/sharer.php?u=' + url;
            },
            twitter: function (url) {
                url = encodeURI(url);
                return 'https://twitter.com/home?status=' + url;
            },
            linkedin: function (url) {
                url = encodeURI(url);
                return 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=&summary=&source=';
            },
            whatsapp: function (url) {
                url = encodeURI(url);
                // return 'whatsapp://send?text=' + url;
                // return 'https://wa.me?text=' + url;
                return 'https://api.whatsapp.com/send?text=' + url;
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .factory('socket', socket);

    /** @ngInject */
    function socket(LoopBackAuth, pdConfig) {

        var socket = io(pdConfig.apiWsBase, {
            'reconnection': true,
            'reconnectionDelay': 500,
            'forceNew': true,
            'transports': ['websocket'],
        });

        var id = LoopBackAuth.accessTokenId;
        var userId = LoopBackAuth.currentUserId;
        socket.on('connect', function () {

            console.log('Socket connected');

            socket.emit('authentication', {id: id, userId: userId});
            socket.on('authenticated', function () {
                console.log('User is authenticated');
            });
        });
        socket.on('disconnect', function () {
            console.log('Socket disconnected');
        });
        socket.on('reconnecting', function (attemptNumber) {
            console.log('Socket reconnecting, attempt:', attemptNumber);
        });
        return socket;
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('validationUtils', validationUtils);

    /** @ngInject */
    function validationUtils(toastr, messagesHelper, errorCodes) {

        this.isValidEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        };

        this.hasUniquenessError = function (errorResponse, fieldName) {
            return errorResponse &&
                errorResponse.data &&
                errorResponse.data.error &&
                errorResponse.data.error.details &&
                errorResponse.data.error.details.codes &&
                errorResponse.data.error.details.codes[fieldName] &&
                errorResponse.data.error.details.codes[fieldName].indexOf('uniqueness') !== 1;

        };

        this.processErrorResponse = function (errorResponse) {
            var code = errorResponse &&
            errorResponse.data &&
            errorResponse.data.error &&
            errorResponse.data.error.code
                ? errorResponse.data.error.code : null;

            var details = errorResponse &&
            errorResponse.data &&
            errorResponse.data.error &&
            errorResponse.data.error.details
                ? errorResponse.data.error.details : null;

            var errorsDetails = [];
            if (details) {
                Object.keys(details).forEach(function (key) {
                    if (Array.isArray(details[key])) {
                        errorsDetails = errorsDetails.concat(details[key]);
                    }
                });
            }

            toastr.clear();
            switch (code) {
                case errorCodes.AVOID_SELF_DELETION:
                    toastr.error(messagesHelper.not_allowed_self_deletion);
                    break;
                case errorCodes.MODEL_NOT_FOUND:
                    toastr.error(messagesHelper.resource_does_not_exists);
                    break;
                case errorCodes.INVALID_TOKEN:
                    toastr.error(messagesHelper.invalid_token);
                    break;
                case errorCodes.EMPTY_SUBSCRIPTION_ADDRESSES:
                    toastr.error(messagesHelper.empty_subscription_addresses);
                    break;
                case errorCodes.INVALID_PROJECT:
                    var msg = messagesHelper.invalid_project;
                    /** show error details when project is invalid */
                    var strDetails = errorsDetails.length ? '<br><br>' + errorsDetails.join('<br>') : '';
                    toastr.error(msg + strDetails);
                    break;
                case errorCodes.INVALID_CONTACT_FORM:
                    toastr.error(messagesHelper.invalid_contact_form);
                    break;
                case errorCodes.INVALID_RECAPTCHA_RESPONSE:
                    toastr.error(messagesHelper.invalid_recaptcha);
                    break;
                case errorCodes.UNKNOW_USER:
                    toastr.error(messagesHelper.unknow_user);
                    break;
                case errorCodes.PENDING_APPROVAL:
                    toastr.error(messagesHelper.pending_approval);
                    break;
                default:
                    toastr.error(messagesHelper.fail_operation);
            }

        };

        this.inRange = function (min, number, max) {
            return !isNaN(number) && (number >= min) && (number <= max);
        };

        this.isValidLatitude = function (value) {
            if (value === null) {
                return false;
            }
            return this.inRange(-90, value, 90);
        };

        this.isValidLongitude = function (value) {
            if (value === null) {
                return false;
            }
            return this.inRange(-180, value, 180)
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home')
        .controller('ArticleFilterPageCtrl', ArticleFilterPageCtrl);

    /** @ngInject */
    function ArticleFilterPageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Project, Sector, Category, Company, Region, Province, District, Objective, Banner, bannerStatus, Article, localStorageService) {

        /** applied filters as full entities, not include fixed filters*/
        $scope.appliedFilters = localStorageService.get('articleFilters') || {
            sectors: [],
            companies: [],
            categories: [], // not used
            districts: [], // not used
            objectives: [], // not used
            provinces: [], // not used
            regions: [] // not used
        };

        $scope.sectionName = $rootScope.currentConfig.article ? $rootScope.currentConfig.article.sectionName : null;
        $scope.searchText = $stateParams.s || "";

        $scope.cardImageHeight = 140;
        $scope.isLoading = false;
        $scope.hasPublicity = false;
        $scope.pageSize = 12;
        $scope.pagination = {
            current: $stateParams.p || 1
        };

        $scope.finishedLoadingArticles = false;
        $scope.finishedLoadingEntity = false;

        /** apply list filters */
        $scope.applyListFilter = function (pageNumber, filters) {

            if (!filters) {
                filters = {};

                /** fixed lost filters on page change*/
                filters = $scope.getAllFilters();
            }

            ScreenLoader.show();
            $scope.finishedLoadingArticles = false;

            $scope.pagination.current = pageNumber || 1;

            $state.go('.', {
                p: pageNumber
            }, {notify: false});

            pageNumber = (!pageNumber || pageNumber) <= 1 ? 0 : pageNumber - 1;
            var start = pageNumber * $scope.pageSize;
            var number = $scope.pageSize;

            var filter = {
                limit: number,
                offset: start,
                where: {},
                order: 'publishedAt DESC',
                include: ["avatar", "company", "sector"]
            };

            var sectorIds = filters && filters.sectors && Array.isArray(filters.sectors) ? filters.sectors : [];
            var companyIds = filters && filters.companies && Array.isArray(filters.companies) ? filters.companies : [];

            if (sectorIds.length) {
                filter.where.idSector = {inq: sectorIds};
            }
            if (companyIds.length) {
                filter.where.idCompany = {inq: companyIds};
            }

            $q.all([
                Article.count({where: filter.where}).$promise,
                Article.find({filter: filter}).$promise,
                // Banner.count({where: {status: bannerStatus.ENABLED}}).$promise, /** commented to force hide publicity*/
                $timeout(1000)
            ]).then(function (results) {
                ScreenLoader.hide();
                $scope.finishedLoadingArticles = true;

                $scope.listTotal = results[0].count;
                $scope.listResults = results[1];
                // $scope.hasPublicity = results[2].count > 0; /** commented to force hide publicity*/

            }, function (error) {
                ScreenLoader.hide();
                $scope.finishedLoadingArticles = true;
            });
        };

        /** get article href */
        $scope.getArticleHref = function (slug) {
            return $state.href('main.article.find_by_slug', {slug: slug}, {absolute: true});
        };

        /** get all filters
         * include fixed filters and applied filters ids
         * only include ids and is used for paginator call
         *
         * fix lost filters on change page
         * **/
        $scope.getAllFilters = function () {
            var filters = {};
            var fixedFilters = angular.copy($scope.fixedFilters);
            var appliedFilters = angular.copy($scope.appliedFilters);

            if (typeof fixedFilters !== undefined) {
                Object.assign(filters, fixedFilters);
            }
            if (typeof appliedFilters !== undefined) {
                Object.keys(appliedFilters).forEach(function (key) {
                    if (appliedFilters.hasOwnProperty(key)) {
                        if (!filters[key] || !Array.isArray(filters[key])) {
                            filters[key] = [];
                        }
                        var ids = appliedFilters[key].map(function (item) {
                            return item.id;
                        });
                        filters[key] = filters[key].concat(ids);
                    }
                });
            }
            return filters;
        };

        /** applied filter watch */
        $scope.$watch('appliedFilters', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                localStorageService.set('articleFilters', Object.assign({}, newValue));
            }
        }, true);

        /** init */
        $scope.init = function () {
            var filter = {
                sectors: $scope.appliedFilters.sectors.map(function (item) {
                    return item.id;
                }),
                companies: $scope.appliedFilters.companies.map(function (item) {
                    return item.id;
                })
            };

            $scope.applyListFilter($stateParams.p, filter);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home')
        .controller('ArticlePageCtrl', ArticlePageCtrl);

    /** @ngInject */
    function ArticlePageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Sector, Category, Company, Article) {

        $scope.finishedLoadingResources = false;
        $scope.sectionName = $rootScope.currentConfig.article ? $rootScope.currentConfig.article.sectionName : null;
        $scope.showGallery = false;

        /** load project */
        $scope.loadArticle = function () {
            $scope.article = {};
            var filter = {
                include: [
                    "images",
                    "avatar",
                    "company",
                    "sector"
                ]
            };
            ScreenLoader.show();
            if ($stateParams.slug) {
                Article.findPublishedBySlug({slug: $stateParams.slug, filter: filter}, function (response) {
                    ScreenLoader.hide();
                    $scope.article = response;
                    $scope.showGallery = response.images && response.images.length > 2;
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    console.log('Article load error.', errorResponse);
                });
            }
        };

        /** load resources */
        $scope.loadResources = function () {
            $scope.finishedLoadingResources = false;
            $q.all([
                Sector.find().$promise,
                Company.find({filter: {"order": "publicName ASC"}}).$promise
            ]).then(function (results) {

                $scope.finishedLoadingResources = true;

                $scope.sectors = results[0];
                $scope.companies = results[1];

            }, function (err) {
                $scope.finishedLoadingResources = true;
                console.log('Load resources error.', err);
            });
        };

        /** init */
        if ($stateParams.slug) {
            $scope.loadArticle();
        }
        $scope.loadResources();

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated')
        .controller('AssociatedPageCtrl', AssociatedPageCtrl);

    /** @ngInject */
    function AssociatedPageCtrl($scope, layoutPaths, pdConfig, LoopBackAuth) {

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home')
        .controller('HomePageCtrl', HomePageCtrl);

    /** @ngInject */
    function HomePageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Region, Province, District, Sector, Category, Company, Objective, Project, Banner, bannerStatus) {

        $scope.regions = [];
        $scope.provinces = [];
        $scope.districts = [];
        $scope.sectors = [];
        $scope.companies = [];
        $scope.categories = [];
        $scope.objectives = [];

        $scope.mapResults = [];
        $scope.listResults = [];
        $scope.mapTotal = 0;
        $scope.listTotal = 0;

        $scope.cardImageHeight = 140;
        $scope.isLoading = false;
        $scope.hasPublicity = false;
        $scope.pageSize = 12;
        $scope.pagination = {
            current: $stateParams.p || 1
        };

        $scope.finishedLoadingResources = false;
        $scope.finishedLoadingProjects = false;

        /** applied filters as full entitities, not include fixed filters*/
        $scope.appliedFilters = {
            sectors: [],
            regions: [],
            provinces: [],
            districts: [],
            categories: [],
            companies: [],
            objectives: []
        };

        /** load resources */
        $scope.loadResources = function () {
            $scope.finishedLoadingResources = false;
            $q.all([
                Region.find({filter: {"order": "name ASC"}}).$promise,
                Province.find({filter: {"order": "name ASC"}}).$promise,
                District.find({filter: {"order": "name ASC"}}).$promise,
                Sector.find().$promise,
                Company.find({filter: {"order": "publicName ASC"}}).$promise,
                Category.find({filter: {"order": "name ASC"}}).$promise,
                Objective.find().$promise,
            ]).then(function (results) {

                $scope.finishedLoadingResources = true;

                $scope.regions = results[0];
                $scope.provinces = results[1];
                $scope.districts = results[2];
                $scope.sectors = results[3];
                $scope.companies = results[4];
                $scope.categories = results[5];
                $scope.objectives = results[6];

            }, function (err) {
                $scope.finishedLoadingResources = true;
                console.log('Load resources error.', err);
            });
        };

        /** find provinces */
        $scope.loadProvinces = function (idRegion) {
            // ScreenLoader.show();
            Province.find({filter: {where: {idRegion: idRegion}}}, function (response) {
                ScreenLoader.hide();
                $scope.provinces = response;
                $scope.districts = [];
                $scope.mapFilters.idProvince = "";
                $scope.mapFilters.idDistrict = "";
            }, function (errorResponse) {
                // ScreenLoader.hide();
            })
        };

        /** find districts */
        $scope.loadDistricts = function (idProvince) {
            // ScreenLoader.show();
            District.find({filter: {where: {idProvince: idProvince}}}, function (response) {
                ScreenLoader.hide();
                $scope.districts = response;
                $scope.mapFilters.idDistrict = "";
            }, function (errorResponse) {
                // ScreenLoader.hide();
            })
        };

        /** apply map filters */
        $scope.applyMapFilter = function (unused, filters) {
            if (!filters) {
                filters = {};
            }

            /** increment limit to show more results in map */
            filters.limit = 1000;

            ScreenLoader.show();

            $q.all([
                Project.advancedCount(filters).$promise,
                Project.advancedSearch(filters).$promise
            ]).then(function (results) {
                ScreenLoader.hide();

                $scope.mapTotal = results[0].count;
                var mapResults = results[1];

                /**
                 * remove project locations that not match with regions,
                 * provinces and districts filters
                 * */
                if (mapResults && Array.isArray(mapResults)) {

                    var regions = filters.regions || [];
                    var provinces = filters.provinces || [];
                    var districts = filters.districts || [];

                    for (var i = 0; i < mapResults.length; i++) {
                        if (mapResults[i].locations && Array.isArray(mapResults[i].locations)) {
                            mapResults[i].locations = mapResults[i].locations.filter(function (location) {

                                return (regions.length ? regions.indexOf(location.idRegion) !== -1 : true) &&
                                    (provinces.length ? provinces.indexOf(location.idProvince) !== -1 : true) &&
                                    (districts.length ? districts.indexOf(location.idDistrict) !== -1 : true);

                            });
                        }
                    }
                }
                $scope.mapResults = mapResults;

            }, function (error) {
                ScreenLoader.hide();
            });
        };

        /** apply list filters */
        $scope.applyListFilter = function (pageNumber, filters) {
            if (!filters) {
                filters = {};

                /** fixed lost filters on page change*/
                filters = $scope.getAllFilters();
            }

            ScreenLoader.show();
            $scope.finishedLoadingProjects = false;

            $scope.pagination.current = pageNumber || 1;

            $state.go('.', {
                p: pageNumber
            }, {notify: false});

            pageNumber = (!pageNumber || pageNumber) <= 1 ? 0 : pageNumber - 1;
            var start = pageNumber * $scope.pageSize;
            var number = $scope.pageSize;

            filters.offset = start;
            filters.limit = number;

            $q.all([
                Project.advancedCount(filters).$promise,
                Project.advancedSearch(filters).$promise,
                Banner.count({where: {status: bannerStatus.ENABLED}}).$promise,
                $timeout(1000)
            ]).then(function (results) {
                ScreenLoader.hide();
                $scope.finishedLoadingProjects = true;

                $scope.listTotal = results[0].count;
                $scope.listResults = results[1];
                $scope.hasPublicity = results[2].count > 0;

            }, function (error) {
                ScreenLoader.hide();
                $scope.finishedLoadingProjects = true;
            });
        };

        /** get project href */
        $scope.getProjectHref = function (slug) {
            return $state.href('main.project.find_by_slug', {slug: slug}, {absolute: true});
        };

        /** check if has filters */
        $scope.hasAppliedFilters = function () {
            return $scope.appliedFilters.sectors.length ||
                $scope.appliedFilters.regions.length ||
                $scope.appliedFilters.provinces.length ||
                $scope.appliedFilters.districts.length ||
                $scope.appliedFilters.categories.length ||
                $scope.appliedFilters.companies.length ||
                $scope.appliedFilters.objectives.length;
        };

        /** get all filters
         * include fixed filters and applied filters ids
         * only include ids and is used for paginator call
         *
         * fix lost filters on change page
         * **/
        $scope.getAllFilters = function () {
            var filters = {};
            var fixedFilters = angular.copy($scope.fixedFilters);
            var appliedFilters = angular.copy($scope.appliedFilters);

            if (typeof fixedFilters !== undefined) {
                Object.assign(filters, fixedFilters);
            }
            if (typeof appliedFilters !== undefined) {
                Object.keys(appliedFilters).forEach(function (key) {
                    if (appliedFilters.hasOwnProperty(key)) {
                        if (!filters[key] || !Array.isArray(filters[key])) {
                            filters[key] = [];
                        }
                        var ids = appliedFilters[key].map(function (item) {
                            return item.id;
                        });
                        filters[key] = filters[key].concat(ids);
                    }
                });
            }
            return filters;
        };

        /** init */
        $scope.loadResources();
        $scope.applyMapFilter();
        $scope.applyListFilter($stateParams.p);
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.main')
        .controller('MainPageCtrl', MainPageCtrl);

    /** @ngInject */
    function MainPageCtrl($scope, $rootScope, layoutPaths, pdConfig, LoopBackAuth) {
        $scope.logoSNMPE = layoutPaths.images.logoSNMPE;
        $scope.logo = layoutPaths.images.logo;

        $scope.isSearchCollapsed = true;
        $scope.isSectionsCollapsed = true;
        $scope.scrolledMobile = false;
        $scope.isMenuCollapsed = true;
        $scope.activeMenu = null;

        // $scope.$watch('activeMenu', function (newValue, oldValue) {
        //
        //     console.log('entre al watch con valor nuevo', newValue);
        //
        //     // console.log('newValue', newValue)
        //     // if (newValue) {
        //     //     $scope.openModalMenu = false;
        //     // } else {
        //     //     $scope.openModalMenu = true;
        //     // }
        //     // console.log($scope.openModalMenu);
        // }, true);

        $scope.setActiveMenu = function (menu) {
            $scope.activeMenu = menu;
            if (menu) {
                $scope.isMenuCollapsed = false;
            } else {
                $scope.isMenuCollapsed = true;
            }
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.main')
        .controller('SecurityCtrl', SecurityCtrl);

    /** @ngInject */
    function SecurityCtrl($scope, $rootScope, layoutPaths, pdConfig, LoopBackAuth, UserEntity, ScreenLoader, toastr) {

        $scope.credentials = {};

        $scope.signin = function (isValid) {
            if (isValid) {
                $scope.login($scope.credentials, true);
            }
        };

        $scope.login = function (credentials, rememberMe) {

            rememberMe = !!rememberMe;
            ScreenLoader.show();
            UserEntity.login({rememberMe: rememberMe}, credentials, function (response) {
                ScreenLoader.hide();
                $rootScope.userLogged = LoopBackAuth.currentUserData;

                if ($rootScope.userLogged.roles.indexOf('admin') === -1) {
                    toastr.clear();
                    toastr.error('El acceso al backend es solo para administradores.');
                    return $scope.logout();
                }

                $rootScope.$broadcast('user-authenticate');

            }, function (errorResponse) {
                ScreenLoader.hide();

                /** not verified account */
                if (errorResponse.data.error.code === "LOGIN_FAILED_EMAIL_NOT_VERIFIED") {
                    toastr.clear();
                    toastr.error('Cuenta no verificada.');
                    return;
                }

                toastr.clear();
                toastr.error('Usuario o contraseña incorrectos.');
                console.log('Error al autenticar el usuario. ', errorResponse);
            });
        };


    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home')
        .controller('ProjectFilterPageCtrl', ProjectFilterPageCtrl);

    /** @ngInject */
    function ProjectFilterPageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Project, Sector, Category, Company, Region, Province, District, Objective, Banner, bannerStatus) {

        /** applied filters as full entitities, not include fixed filters*/
        $scope.appliedFilters = {
            sectors: [],
            regions: [],
            provinces: [],
            districts: [],
            categories: [],
            companies: [],
            objectives: []
        };

        $scope.fixedFilters = {};
        $scope.sector = {};
        $scope.category = {};
        $scope.company = {};
        $scope.searchText = $stateParams.s || "";

        $scope.cardImageHeight = 140;
        $scope.isLoading = false;
        $scope.hasPublicity = false;
        $scope.pageSize = 12;
        $scope.pagination = {
            current: $stateParams.p || 1
        };

        $scope.finishedLoadingProjects = false;
        $scope.finishedLoadingEntity = false;

        /** load sector */
        $scope.loadSector = function (id) {
            if (!id) {
                console.log('Sector id is required.');
                return;
            }
            $scope.finishedLoadingEntity = false;
            Sector.findById({id: id}, function (response) {
                $scope.sector = response;
                $scope.finishedLoadingEntity = true;
            }, function (errorResponse) {
                $scope.finishedLoadingEntity = true;
                console.log("Sector load error.", errorResponse);
            });
        };

        /** load category */
        $scope.loadCategory = function (id) {
            if (!id) {
                console.log('Category id is required.');
                return;
            }
            $scope.finishedLoadingEntity = false;
            Category.findById({id: id}, function (response) {
                $scope.category = response;
                $scope.finishedLoadingEntity = true;
            }, function (errorResponse) {
                $scope.finishedLoadingEntity = true;
                console.log("Category load error.", errorResponse);
            });
        };

        /** load company */
        $scope.loadCompany = function (id) {
            if (!id) {
                console.log('Company id is required.');
                return;
            }
            $scope.finishedLoadingEntity = false;
            Company.findById({id: id}, function (response) {
                $scope.company = response;
                $scope.finishedLoadingEntity = true;
            }, function (errorResponse) {
                $scope.finishedLoadingEntity = true;
                console.log("Company load error.", errorResponse);
            });
        };

        /** apply list filters */
        $scope.applyListFilter = function (pageNumber, filters) {
            if (!filters) {
                filters = {};

                /** fixed lost filters on page change*/
                filters = $scope.getAllFilters();
            }

            ScreenLoader.show();
            $scope.finishedLoadingProjects = false;

            $scope.pagination.current = pageNumber || 1;

            $state.go('.', {
                p: pageNumber
            }, {notify: false});

            pageNumber = (!pageNumber || pageNumber) <= 1 ? 0 : pageNumber - 1;
            var start = pageNumber * $scope.pageSize;
            var number = $scope.pageSize;

            filters.offset = start;
            filters.limit = number;

            $q.all([
                Project.advancedCount(filters).$promise,
                Project.advancedSearch(filters).$promise,
                Banner.count({where: {status: bannerStatus.ENABLED}}).$promise,
                $timeout(1000)
            ]).then(function (results) {
                ScreenLoader.hide();
                $scope.finishedLoadingProjects = true;

                $scope.listTotal = results[0].count;
                $scope.listResults = results[1];
                $scope.hasPublicity = results[2].count > 0;

            }, function (error) {
                ScreenLoader.hide();
                $scope.finishedLoadingProjects = true;
            });
        };

        /** get project href */
        $scope.getProjectHref = function (slug) {
            return $state.href('main.project.find_by_slug', {slug: slug}, {absolute: true});
        };

        /** get all filters
         * include fixed filters and applied filters ids
         * only include ids and is used for paginator call
         *
         * fix lost filters on change page
         * **/
        $scope.getAllFilters = function () {
            var filters = {};
            var fixedFilters = angular.copy($scope.fixedFilters);
            var appliedFilters = angular.copy($scope.appliedFilters);

            if (typeof fixedFilters !== undefined) {
                Object.assign(filters, fixedFilters);
            }
            if (typeof appliedFilters !== undefined) {
                Object.keys(appliedFilters).forEach(function (key) {
                    if (appliedFilters.hasOwnProperty(key)) {
                        if (!filters[key] || !Array.isArray(filters[key])) {
                            filters[key] = [];
                        }
                        var ids = appliedFilters[key].map(function (item) {
                            return item.id;
                        });
                        filters[key] = filters[key].concat(ids);
                    }
                });
            }
            return filters;
        };

        /** init */
        $scope.init = function (action) {
            if (action === "filter_by_sector") {
                $scope.fixedFilters = {sectors: [$stateParams.idSector]};
                $scope.loadSector($stateParams.idSector);
            }
            if (action === "filter_by_category") {
                $scope.fixedFilters = {categories: [$stateParams.idCategory]};
                $scope.loadCategory($stateParams.idCategory);
            }
            if (action === "filter_by_company") {
                $scope.fixedFilters = {companies: [$stateParams.idCompany]};
                $scope.loadCompany($stateParams.idCompany);
            }
            if (action === "filter_by_search") {
                $scope.fixedFilters = {search: $stateParams.s};
            }
            $scope.applyListFilter($stateParams.p, $scope.fixedFilters);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.home')
        .controller('ProjectPageCtrl', ProjectPageCtrl);

    /** @ngInject */
    function ProjectPageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Project, Sector, Category, Company, Region, Province, District, Objective, updateStatus) {

        $scope.finishedLoadingResources = false;
        $scope.collapseItems = {
            updates: true,
            locations: true,
            categories: true,
            summary: true,
            duration: true,
            alliances: true,
            financings: true,
            history: true,
            beneficiaries: true,
            awards: true,
            links: true,
            referred: true,
            company: true
        };

        /** load project */
        $scope.loadProject = function () {
            $scope.project = {};
            var filter = {
                include: [
                    "activities",
                    "alliances",
                    {"objectives": "image"},
                    "informationBases",
                    "categories",
                    "beneficiaries",
                    "diffusions",
                    "financings",
                    {"locations": ["region", "province", "district"]},
                    "images",
                    "avatar",
                    {
                        relation: 'updates',
                        scope: {
                            where: {status: updateStatus.PUBLISHED},
                            order: "date DESC"
                        }
                    },
                    {"company": {"sector": "imageLogo"}}
                ]
            };
            ScreenLoader.show();
            if ($stateParams.id) {
                Project.findById({id: $stateParams.id, filter: filter}, function (response) {
                    ScreenLoader.hide();
                    $scope.project = response;
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    console.log('Project load error.', errorResponse);
                });
            } else if ($stateParams.slug) {
                var where = {slug: $stateParams.slug};
                Project.findOne({filter: {where: where}}, function (response) {
                    Project.findById({id: response.id, filter: filter}, function (response) {
                        ScreenLoader.hide();
                        $scope.project = response;
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        console.log('Project load error.', errorResponse);
                    });
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    console.log('Project load error.', errorResponse);
                });
            }

        };

        /** load resources */
        $scope.loadResources = function () {
            $scope.finishedLoadingResources = false;
            $q.all([
                Region.find({filter: {"order": "name ASC"}}).$promise,
                Province.find({filter: {"order": "name ASC"}}).$promise,
                District.find({filter: {"order": "name ASC"}}).$promise,
                Sector.find().$promise,
                Company.find({filter: {"order": "publicName ASC"}}).$promise,
                Category.find({filter: {"order": "name ASC"}}).$promise,
                Objective.find().$promise,
            ]).then(function (results) {

                $scope.finishedLoadingResources = true;

                $scope.regions = results[0];
                $scope.provinces = results[1];
                $scope.districts = results[2];
                $scope.sectors = results[3];
                $scope.companies = results[4];
                $scope.categories = results[5];
                $scope.objectives = results[6];

            }, function (err) {
                $scope.finishedLoadingResources = true;
                console.log('Load resources error.', err);
            });
        };

        var unregisterWatch = $scope.$watch('collapseItems', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                var keyOpened = Object.keys(newValue).find(function (key, index) {
                    return newValue.hasOwnProperty(key) && newValue[key] !== oldValue[key] && newValue[key] === false;
                });

                var collapseItems = {};
                if (keyOpened) {
                    collapseItems[keyOpened] = false;
                    Object.keys(newValue).forEach(function (key, index) {
                        if (newValue.hasOwnProperty(key) && key !== keyOpened) {
                            collapseItems[key] = true;
                        }
                    });
                    $scope.collapseItems = collapseItems;
                }
            }
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });

        /** init */
        if ($stateParams.id || $stateParams.slug) {
            $scope.loadProject();
        }
        $scope.loadResources();

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.static')
        .controller('StaticPageCtrl', StaticPageCtrl);

    /** @ngInject */
    function StaticPageCtrl($scope, $rootScope, $state, toastr, $q, Page, ScreenLoader, $sce, pdConfig, vcRecaptchaService, messagesHelper, validationUtils) {

        $scope.contact = {};
        $scope.page = {};
        $scope.reCaptchaKey = pdConfig.reCaptchaKey;
        $scope.widgetId = null;

        /** send contact form */
        $scope.sendContactForm = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                Page.contact($scope.contact,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_contact_form);
                        contactForm.reset();
                        vcRecaptchaService.reload($scope.widgetId);
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        validationUtils.processErrorResponse(errorResponse);
                        console.log('Contact form error. ', errorResponse);
                    }
                );
            } else {
                toastr.clear();
                toastr.error('Contact form error.');
            }
        };

        /** Get the widgetId when the recaptcha instance is created via onCreate callback */
        $scope.onWidgetCreate = function (widgetId) {
            $scope.widgetId = widgetId;
        };

        $scope.loadPage = function (type) {
            $scope.page = {};

            ScreenLoader.show();
            Page.findOne({filter: {where: {type: type}}}, function (response) {
                ScreenLoader.hide();
                $scope.page = response;
            }, function (errorResponse) {
                ScreenLoader.hide();
                $scope.page.type = type;
                console.log('Page load error.', errorResponse);
            });
        };

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };

        $scope.init = function (action) {
            if (action === 'contact' || action === 'about-us' || action === 'terms' || action === 'ods') {
                $scope.loadPage(action);
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.subscription')
        .controller('SubscriptionPageCtrl', SubscriptionPageCtrl);

    /** @ngInject */
    function SubscriptionPageCtrl($scope, $rootScope, $state, $stateParams, $timeout, toastr, $q, ScreenLoader, Subscription) {

        $scope.statusMessage = "";

        /** confirm subscription */
        $scope.confirm = function (token) {
            ScreenLoader.show();
            $scope.statusMessage = "Verificando información ...";
            Subscription.confirm({token: token}, function (response) {
                ScreenLoader.hide();
                $scope.statusMessage = "Suscripción confirmada con éxito."
            }, function (errorResponse) {
                ScreenLoader.hide();
                $scope.statusMessage = "No se pudo confirmar la suscripción. Token incorrecto.";
                console.log("Subscrition confirm error.", errorResponse);
            });
        };

        /** init */
        $scope.init = function (action) {
            if (action === "confirm") {
                var token = $stateParams.token;
                $scope.confirm(token);
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme.components')
        .config(toastrLibConfig);

    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            closeButton: false,
            closeHtml: '<button>&times;</button>',
            timeOut: 3000,
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-bottom-center',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body',
            allowHtml: true
        });
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('backgroundImage', backgroundImage);

    /** @ngInject */
    function backgroundImage() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var url = attrs.backgroundImage;
                var defaultHeight = attrs.backgroundImageHeight ? attrs.backgroundImageHeight + 'px' : '170px';

                element.css({
                    'height': defaultHeight,
                    'background-image': 'url(' + url + ')',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center center',
                    '-webkit-background-size': 'cover',
                    '-moz-background-size': 'cover',
                    '-o-background-size': 'cover',
                    'background-size': 'cover'
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('breakLine', breakLine);

    /** @ngInject */
    function breakLine() {
        return {
            restrict: 'EA',
            link: function (scope, element, attr) {

                var breakLine = function () {
                    var index = attr.breakLine;
                    var elementWidth = element.outerWidth();
                    var parentWidth = angular.element(element).parent().width();
                    var itemsByRow = parentWidth / elementWidth;

                    if (index % itemsByRow == 0) {
                        element.css('clear', 'both');
                    } else {
                        element.css('clear', 'unset');
                    }
                };

                breakLine();
                window.addEventListener("resize", breakLine, false);
                scope.$on('$destroy', function () {
                    window.removeEventListener("resize", breakLine, false);
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('carouselControls', carouselControls);

    /** @ngInject */
    function carouselControls() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.goNext = function () {
                    element.isolateScope().next();
                };
                scope.goPrev = function () {
                    element.isolateScope().prev();
                };

            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('equalizeHeight', equalizeHeight)
        .directive('equalizeHeightAdd', equalizeHeightAdd);

    /** @ngInject */
    function equalizeHeight($timeout, preloader, $q) {
        return {
            restrict: 'A',
            controller: function ($scope) {

                var ctrl = this;

                var elements = [];
                this.addElement = function (element) {
                    elements.push(element);
                };

                // reset height
                this.resetHeight = function () {
                    $timeout(function () {
                        angular.forEach(elements, function (el) {
                            el[0].style.height = 'auto';
                        });
                    }, 0);
                };

                // resize elements once the last element is found
                this.resize = function (avoidResetHeight) {
                    if (!avoidResetHeight)
                        ctrl.resetHeight();

                    $timeout(function () {
                        function calculateHeight() {
                            // find the tallest
                            var tallest = 0, height;
                            angular.forEach(elements, function (el) {
                                height = el[0].offsetHeight;
                                if (height > tallest)
                                    tallest = height;
                            });
                            // resize
                            angular.forEach(elements, function (el) {
                                el[0].style.height = tallest + 'px';
                            });
                        }

                        var promises = [];
                        angular.forEach(elements, function (el) {
                            el[0].querySelectorAll('img').forEach(function (img) {
                                promises.push(preloader.loadImg(img.src));
                            });
                        });

                        if (promises.length > 0) {
                            $q.all(promises).then(function (results) {
                                calculateHeight();
                            });
                        } else {
                            calculateHeight();
                        }
                    }, 0);
                };

                window.addEventListener("resize", ctrl.resize, false);
                $scope.$on('$destroy', function () {
                    window.removeEventListener("resize", ctrl.resize, false);
                });
            }
        };
    }

    function equalizeHeightAdd($timeout) {
        return {
            restrict: 'A',
            require: '^^equalizeHeight',
            link: function (scope, element, attrs, ctrl_for) {
                // add element to list of elements
                ctrl_for.addElement(element);

                // if (scope.$last) {
                //     ctrl_for.resize();
                // }

                var unregister = scope.$watch(function () {
                    return element.height();
                }, function (newHeight, oldHeight) {

                    if (scope.$last && newHeight !== oldHeight) {
                        var avoidResetHeight = true;
                        ctrl_for.resize(avoidResetHeight);
                    }
                });

                scope.$on('$destroy', function () {
                    unregister();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('fontColor', fontColor);

    /** @ngInject */
    function fontColor() {
        return {
            restrict: 'EA',
            link: function (scope, element, attr) {
                element.css('color', attr.fontColor);
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .directive('hoverColor', hoverColor);

    /** @ngInject */
    function hoverColor() {
        return {
            restrict: 'EA',
            link: function (scope, element, attr) {
                var color = element.css('color');
                var background = element.css('background-color');
                element.on('mouseenter', function () {
                    if (attr.hoverBackgroundColor) {
                        element.css('background-color', attr.hoverBackgroundColor);
                    }
                    element.css('color', attr.hoverColor);
                });
                element.on('mouseleave', function () {
                    if (attr.hoverBackgroundColor) {
                        element.css('background-color', background);
                    }
                    element.css('color', color);
                });
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .filter('fileUrl', fileUrl);

    /** @ngInject */
    function fileUrl(mfConfig) {
        return function (input, container) {
            if (input && container) {
                return mfConfig.apiUrlBase + '/container/' + container + '/download/' + input;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .filter('imageUrl', imageUrl);

    /** @ngInject */
    function imageUrl(mfConfig, assetPaths) {
        return function (input, container) {
            if (input && container) {
                return mfConfig.apiUrlBase + '/container/' + container + '/download/' + input;
            } else {
                if (container == 'userpics') {
                    return assetPaths.images.unknowUserImageUrl;
                }
                return assetPaths.images.addFileUrl;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .filter('monthName', monthName);

    /** @ngInject */
    function monthName() {
        return function (monthNumber) {
            var months = [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre'];

            return months[monthNumber - 1];
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .filter('range', range);

    /** @ngInject */
    function range() {
        return function (total) {
            total = parseInt(total);
            var values = [];
            for (var i = 0; i < total; i++) {
                values.push(i);
            }
            return values;
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('MenuItem', MenuItem);

    /** @ngInject */
    function MenuItem($state, Edition, $q) {

        function orderItems(items, orderBy) {
            return items.sort(function (a, b) {
                if (a[orderBy] > b[orderBy]) {
                    return 1;
                }
                if (a[orderBy] < b[orderBy]) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });
        }

        return {
            getTopMenuItems: function (idEdition) {

                var defered = $q.defer();
                var promise = defered.promise;

                if (!idEdition) {
                    console.error('Edition id is required.');
                    defered.reject();
                }
                var items = [
                    {
                        title: 'Índice',
                        href: $state.href('main.edition.index', {id_edition: idEdition}, {absolute: true}),
                        target: '',
                        order: 1
                    },
                    {
                        title: 'Agenda',
                        href: $state.href('main.schedule', {}, {absolute: true}),
                        target: '',
                        order: 1
                    },
                    {
                        title: 'Quiénes somos',
                        href: $state.href('main.about-us', {}, {absolute: true}),
                        target: '',
                        order: 2
                    },
                    {
                        title: 'Contacto',
                        href: $state.href('main.contact', {}, {absolute: true}),
                        target: '',
                        order: 3
                    },
                    {
                        title: 'Imágenes',
                        href: $state.href('main.edition.images', {id_edition: idEdition}, {absolute: true}),
                        target: '',
                        order: 4
                    },
                    {
                        title: 'Ediciones anteriores',
                        href: $state.href('main.prev_edition.list', {}, {absolute: true}),
                        target: '',
                        order: 5
                    }
                ];
                defered.resolve(orderItems(items, 'order'));

                return promise;
            },

            getMainMenuItems: function (idEdition) {

                var defered = $q.defer();
                var promise = defered.promise;

                if (!idEdition) {
                    console.error('Edition id is required.');
                    defered.reject();
                }

                var items = [];
                $q.all([
                    Edition.menus({
                        id: idEdition,
                        filter: {
                            where: {
                                enabled: true,
                                templatePosition: 'main'
                            },
                            order: 'order ASC'
                        }
                    }).$promise,
                    Edition.sections({
                        id: idEdition,
                        filter: {
                            where: {
                                enabled: true,
                                idParent: null
                            },
                            include: [
                                {
                                    relation: 'sections',
                                    scope: {
                                        where: {enabled: true}
                                    }
                                }
                            ],
                            order: 'name ASC'
                        }
                    }).$promise
                ]).then(function (results) {

                    var sectionItems = [];
                    if (results[1] && Array.isArray(results[1])) {
                        results[1].forEach(function (section) {

                            var countArticlesChilds = 0;
                            if (Array.isArray(section.sections)) {
                                section.sections.forEach(function (item) {
                                    countArticlesChilds += item.enabledArticlesCount;
                                });
                            }

                            if (section.enabledArticlesCount > 0 || countArticlesChilds > 0) {
                                sectionItems.push({
                                    title: section.name,
                                    href: $state.href('main.section.show', {
                                        id_edition: idEdition,
                                        section: section.id
                                    }, {absolute: true}),
                                    target: '',
                                    idSection: section.id // used to include article link in prev edition show
                                });
                            }
                        });
                    }

                    if (results[0] && Array.isArray(results[0])) {
                        results[0].forEach(function (menu) {

                            var item = {
                                title: menu.name,
                                href: '',
                                target: '',
                                childrens: []
                            };

                            if (menu.type == 'tag' || menu.type == 'single_section') {
                                item.href = $state.href('main.article.list_by_menu', {
                                    id_edition: idEdition,
                                    id_menu: menu.id,
                                    page: 1
                                }, {absolute: true});
                            }

                            if (menu.type == 'url') {
                                item.href = menu.url;
                                item.target = '_blank';
                            }

                            if (menu.type == 'section') {
                                item.href = $state.href('main.section.list', {
                                    id_edition: idEdition
                                }, {absolute: true});
                                item.childrens = sectionItems;
                            }
                            items.push(item);
                        });
                    }

                    defered.resolve(items);

                }, function (error) {
                    defered.reject(error);
                });

                return promise;
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('pdUtil', pdUtil);

    /** @ngInject */
    function pdUtil() {

        this.hexToRGB = function (hex, alpha) {
            var r = parseInt(hex.slice(1, 3), 16);
            var g = parseInt(hex.slice(3, 5), 16);
            var b = parseInt(hex.slice(5, 7), 16);
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        };

        this.hasAttr = function (elem, attrName) {
            var attr = $(elem).attr(attrName);
            return (typeof attr !== typeof undefined && attr !== false);
        };

        this.isEmptyOrNull = function (obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop))
                    return false;
            }
            return obj === null || JSON.stringify(obj) === JSON.stringify({});
        }
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('preloader', preloader);

    /** @ngInject */
    function preloader($q) {
        return {
            loadImg: function (src) {
                var d = $q.defer();
                var img = new Image();
                img.src = src;
                img.onload = function () {
                    d.resolve();
                };
                return d.promise;
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('ScreenLoader', ScreenLoader);

    /** @ngInject */
    function ScreenLoader($rootScope, $timeout) {
        return {
            show: function () {
                $timeout(function () {
                    if ($rootScope.$currentEdition) {
                        $('#loading').find('i').css('color', $rootScope.$currentEdition.color1);
                    }
                    $('#loading').fadeIn();
                });
            },
            hide: function () {
                $timeout(function () {
                    $('#loading').fadeOut();
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('SharedLink', ShareLink);

    /** @ngInject */
    function ShareLink() {
        return {
            facebook: function (url) {
                url = encodeURI(url);
                return 'https://www.facebook.com/sharer/sharer.php?u=' + url
            },
            twitter: function (url) {
                url = encodeURI(url);
                return 'https://twitter.com/home?status=' + url
            },
            linkedin: function (url) {
                url = encodeURI(url);
                return 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=&summary=&source='
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme')
        .service('StateUtil', StateUtil);

    /** @ngInject */
    function StateUtil($state) {
        return {
            getStateTitle: function (stateName) {
                // if not specify state name take the current state
                var state = null;
                if (!stateName) {
                    state = $state.current;
                } else {
                    state = $state.get(stateName);
                }
                if (state && state.title) {
                    return state.title;
                }
                return null;
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('UploadImageCtrl', UploadImageCtrl);

    /** @ngInject */
    function UploadImageCtrl($scope, toastr, $timeout, $q, messagesHelper, Upload, $uibModal, Files, pdConfig, paginateHelper, LoopBackAuth, $uibModalInstance, ScreenLoader) {

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** obtain results */
        $scope.callFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {container: 'Pages'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFiles = function (file, errFiles) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Pages/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setImage(response.data[0].name);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** set image */
        $scope.setImage = function (image) {
            $scope.f = null;
            $scope.errFile = null;

            var imageUrl = pdConfig.apiUrlBase + '/container/Pages/download/' + image;
            $uibModalInstance.close(imageUrl);
        };

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('advancedFilters', advancedFilters);

    /** @ngInject */
    function advancedFilters() {
        return {
            restrict: 'AE',
            scope: {
                sectors: "<sectors",
                regions: "<regions",
                provinces: "<provinces",
                districts: "<districts",
                categories: "<categories",
                companies: "<companies",
                objectives: "<objectives",
                fixedFilters: "=fixedFilters",
                showReset: "=showReset",
                appliedFilters: "=appliedFilters",
                apply: "&apply"
            },
            templateUrl: 'app/resources/directives/advancedFilters/advancedFilters.html',
            controller: function ($scope, $element, $attrs, $window) {

                $scope.windowWidth = $window.innerWidth;
                $scope.isFiltersCollapsed = true;
                $scope.showToggleCollapsed = false;

                $scope.filteredProvinces = [];
                $scope.filteredDistricts = [];

                $scope.filters = {
                    sectors: [],
                    regions: [],
                    provinces: [],
                    districts: [],
                    categories: [],
                    companies: [],
                    objectives: []
                };

                $scope.filters = Object.assign($scope.filters, angular.copy($scope.appliedFilters));

                $scope.regionLabels = {
                    itemsSelected: "REGIONES",
                    select: "REGIÓN",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.provinceLabels = {
                    itemsSelected: "PROVINCIAS",
                    select: "PROVINCIA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.districtLabels = {
                    itemsSelected: "DISTRITOS",
                    select: "DISTRITO",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.sectorLabels = {
                    itemsSelected: "SECTORES",
                    select: "SECTOR",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.categoryLabels = {
                    itemsSelected: "TEMAS",
                    select: "TEMA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.companyLabels = {
                    itemsSelected: "EMPRESAS",
                    select: "EMPRESA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.objectiveLabels = {
                    itemsSelected: "ODS",
                    select: "ODS",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.applyFilters = function () {
                    var filters = {
                        sectors: $scope.filters.sectors.map(function (item) {
                            return item.id
                        }),
                        regions: $scope.filters.regions.map(function (item) {
                            return item.id
                        }),
                        provinces: $scope.filters.provinces.map(function (item) {
                            return item.id
                        }),
                        districts: $scope.filters.districts.map(function (item) {
                            return item.id
                        }),
                        categories: $scope.filters.categories.map(function (item) {
                            return item.id
                        }),
                        companies: $scope.filters.companies.map(function (item) {
                            return item.id
                        }),
                        objectives: $scope.filters.objectives.map(function (item) {
                            return item.id
                        })
                    };
                    Object.assign($scope.appliedFilters, angular.copy($scope.filters));
                    $scope.apply({
                        newPageNumber: 1,
                        newPageFilters: Object.assign(filters, $scope.fixedFilters)
                    });
                };

                $scope.resetFilters = function () {
                    $scope.filters = {
                        sectors: [],
                        regions: [],
                        provinces: [],
                        districts: [],
                        categories: [],
                        companies: [],
                        objectives: []
                    };
                    Object.assign($scope.appliedFilters, angular.copy($scope.filters));
                    $scope.apply({
                        newPageNumber: 1,
                        newPageFilters: Object.assign($scope.filters, $scope.fixedFilters)
                    });
                };

                var onResize = function () {
                    $scope.windowWidth = window.innerWidth;
                    $scope.$digest();
                };

                $scope.filterProvinces = function () {
                    // var provinces = [];
                    // $scope.filters.regions.forEach(function (region) {
                    //
                    //     $scope.provinces.forEach(function (prov) {
                    //         if (prov.idRegion === region.id) {
                    //             provinces.push(prov);
                    //         }
                    //     });
                    //
                    // });
                    // $scope.filteredProvinces = provinces;
                };

                $window.addEventListener("resize", onResize, false);

                var unregisterWatch = $scope.$watch('windowWidth', function (newValue, oldValue) {
                    if (newValue > 768) {
                        $scope.showToggleCollapsed = false;
                        $scope.isFiltersCollapsed = false;
                    } else {
                        $scope.showToggleCollapsed = true;
                    }
                }, true);

                var unregisterAppliedFiltersWatch = $scope.$watch('appliedFilters', function (newValue, oldValue) {
                    if (newValue && newValue !== oldValue) {
                        $scope.filters = Object.assign($scope.filters, angular.copy(newValue));
                        $scope.applyFilters();
                    }
                }, true);

                var unregisterRegionsWatch = $scope.$watch('filters.regions', function (newValue, oldValue) {
                    if (newValue && Array.isArray(newValue)) {

                        var provinces = [];
                        newValue.forEach(function (region) {
                            if ($scope.provinces && Array.isArray($scope.provinces)) {
                                $scope.provinces.forEach(function (prov) {
                                    if (prov.idRegion === region.id) {
                                        provinces.push(prov);
                                    }
                                });
                            }
                        });
                        $scope.filteredProvinces = provinces;

                        // update filters
                        var filterProvinces = [];
                        if ($scope.filters.provinces && Array.isArray($scope.filters.provinces)) {
                            $scope.filters.provinces.forEach(function (prov) {
                                var exist = provinces.find(function (item) {
                                    return item.id === prov.id;
                                });
                                if (exist) {
                                    filterProvinces.push(exist);
                                }
                            });
                        }
                        $scope.filters.provinces = filterProvinces;

                    }
                }, true);

                var unregisterProvincesWatch = $scope.$watch('filters.provinces', function (newValue, oldValue) {
                    if (newValue && Array.isArray(newValue)) {

                        var districts = [];
                        newValue.forEach(function (prov) {

                            if ($scope.districts && Array.isArray($scope.districts)) {
                                $scope.districts.forEach(function (dist) {
                                    if (dist.idProvince === prov.id) {
                                        districts.push(dist);
                                    }
                                });
                            }

                        });
                        $scope.filteredDistricts = districts;

                        // update filters
                        var filterDistricts = [];
                        if ($scope.filters.districts && Array.isArray($scope.filters.districts)) {
                            $scope.filters.districts.forEach(function (dist) {
                                var exist = districts.find(function (item) {
                                    return item.id === dist.id;
                                });
                                if (exist) {
                                    filterDistricts.push(exist);
                                }
                            });
                        }
                        $scope.filters.districts = filterDistricts;

                    }
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterAppliedFiltersWatch();
                    unregisterRegionsWatch();
                    unregisterProvincesWatch();
                    $window.removeEventListener("resize", onResize, false);
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('filterTags', filterTags);

    /** @ngInject */
    function filterTags() {
        return {
            restrict: 'AE',
            scope: {
                filters: "=filters",
                showTooltips: "=showTooltips"
            },
            templateUrl: 'app/resources/directives/advancedFilters/filterTags.html',
            controller: function ($scope, $element, $attrs, $window) {

                $scope.removeFilter = function (key, index) {
                    if ($scope.filters.hasOwnProperty(key) && $scope.filters[key][index]) {
                        $scope.filters[key].splice(index, 1);
                    }
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('charCounter', charCounter);

    /** @ngInject */
    function charCounter() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                limit: "=limit",
            },
            templateUrl: 'app/resources/directives/charCounter/charCounter.html',
            controller: function ($scope, $rootScope, $element, $attrs) {

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('companyInfo', companyInfo);

    /** @ngInject */
    function companyInfo() {
        return {
            restrict: 'EA',
            scope: {
                company: "=company"
            },
            templateUrl: 'app/resources/directives/companyInfo/companyInfo.html',
            controller: function ($scope, $element, $attrs) {

                // $scope.removeItem = function (index) {
                //     $scope.selected.splice(index, 1);
                // };
                //
                // var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                //
                // }, true);
                //
                // $scope.$on('$destroy', function () {
                //     unregisterWatch();
                // });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('darkSocialLinks', darkSocialLinks);

    /** @ngInject */
    function darkSocialLinks() {
        return {
            restrict: 'EA',
            scope: {
                links: "=links"
            },
            templateUrl: 'app/resources/directives/darkSocialLinks/darkSocialLinks.html',
            controller: function ($scope, $element, $attrs) {

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('GmapProjectsCtrl', GmapProjectsCtrl);

    /** @ngInject */
    function GmapProjectsCtrl($scope, $rootScope, toastr, $state, ScreenLoader, uiGmapGoogleMapApi, uiGmapIsReady, Project, assetPaths, $filter) {

        $scope.markers = [];
        $scope.windowOptions = {
            boxClass: "gmap-infobox",
        };
        $scope.defaultMapCenter = {latitude: -12.046374, longitude: -77.042793};
        $scope.mapControl = {};
        $scope.options = {
            minZoom: 2,
            maxZoom: 11,
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true
        };

        uiGmapGoogleMapApi.then(function (maps) {
            $scope.map = {
                center: $scope.defaultMapCenter,
                zoom: 6,
                bounds: {
                    northeast: {
                        latitude: -12,
                        longitude: -77
                    },
                    southwest: {
                        latitude: -12.046374,
                        longitude: -77.042793
                    }
                }
            };
        });

        /** get marker image */
        $scope.getMarkerImage = function (project) {
            if (project && project.company && project.company.sector && project.company.sector.imageMarker) {
                return $filter('imageUrl')(project.company.sector.imageMarker.url)
            }
            return assetPaths.images.emptyMarker;
        };

        /** calculate center of map */
        $scope.recalculateMapCenter = function () {
            if ($scope.markers.length) {
                var bounds = new google.maps.LatLngBounds();
                $scope.markers.forEach(function (marker) {
                    bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
                });

                $scope.mapControl.getGMap().fitBounds(bounds);
            }
        };

        /** refresh markers in map */
        $scope.updateMap = function () {
            uiGmapIsReady.promise()
                .then(function (instances) {
                    var markers = [];

                    if (Array.isArray($scope.projects) && $scope.projects.length > 0) {
                        $scope.projects.forEach(function (project, projIndex) {
                            if (Array.isArray(project.locations) && project.locations.length > 0) {
                                project.locations.forEach(function (location, locIndex) {

                                    markers.push({
                                        id: 'marker_' + location.id,
                                        latitude: location.latitude,
                                        longitude: location.longitude,
                                        options: {
                                            draggable: false
                                        },
                                        icon: {
                                            url: $scope.getMarkerImage(project)
                                        },
                                        title: project.nameToPublish,
                                        idProject: project.id,
                                        slug: project.slug,
                                        description: project.company ? project.company.publicName : null,
                                        imageUrl: project.avatar ? $filter('imageUrl')(project.avatar.url) : null,
                                        show: false
                                    })
                                });
                            }
                        });
                    }

                    $scope.markers = markers;
                    $scope.recalculateMapCenter();
                });
        };

        /** show marker info box */
        $scope.onClick = function (marker, eventName, model) {
            model.show = true;
            $scope.activeModel = model;
        };

        /** close marker info box */
        $scope.closeClick = function () {
            $scope.activeModel.show = false;
        };

        /** watch projects changes */
        var unregisterWatch = $scope.$watch('projects', function (newValues, oldValues) {
            $scope.updateMap();
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('gmapProjects', gmapProjects);

    /** @ngInject */
    function gmapProjects() {
        return {
            restrict: 'EA',
            scope: {
                projects: "=projects",
            },
            templateUrl: 'app/resources/directives/gmapProjects/gmapProjects.html',
            controller: 'GmapProjectsCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('introMessage', introMessage);

    /** @ngInject */
    function introMessage() {
        return {
            restrict: 'AE',
            scope: {
                message: "=ngModel"
            },
            templateUrl: 'app/resources/directives/introMessage/introMessage.html',
            controller: function ($scope, $element, $attrs, $window) {

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('LastProjectsCtrl', LastProjectsCtrl);

    /** @ngInject */
    function LastProjectsCtrl($scope, $rootScope, toastr, $state, Project) {

        $scope.results = [];

        /** load last projects */
        $scope.loadProjects = function () {
            Project.lastPublished(function (response) {
                $scope.results = response;
            }, function (errorResponse) {

            });
        };

        /** init */
        $scope.loadProjects();
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('lastProjects', lastProjects);

    /** @ngInject */
    function lastProjects() {
        return {
            restrict: 'EA',
            templateUrl: 'app/resources/directives/lastProjects/lastProjects.html',
            controller: 'LastProjectsCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('publicityBanner', publicityBanner);

    /** @ngInject */
    function publicityBanner() {
        return {
            restrict: 'EA',
            scope: {
                title: "=title",
                description: "=description"
            },
            templateUrl: 'app/resources/directives/publicityBanner/publicityBanner.html',
            controller: function ($scope, $element, $attrs, Banner, bannerStatus) {

                $scope.interval = 5000;
                $scope.noWrapSlides = false;
                $scope.active = 0;
                $scope.banners = [];

                /** load banners */
                $scope.loadBanners = function () {
                    Banner.find({
                        filter: {
                            include: ['imageWeb', 'imageMobile'],
                            where: {status: bannerStatus.ENABLED}
                        }
                    }, function (response) {
                        $scope.banners = response;
                    }, function (errorResponse) {
                        console.log('Banners slide error to load.', errorResponse);
                    });
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

                /** init */
                $scope.loadBanners();
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('recommendedSizes', recommendedSizes);

    /** @ngInject */
    function recommendedSizes() {
        return {
            restrict: 'EA',
            scope: {
                width: "=width",
                height: "=height",
                unit: "@unit",
            },
            templateUrl: 'app/resources/directives/recommendedSizes/recommendedSizes.html',
            controller: function ($scope, $rootScope, $element, $attrs) {
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('sectionHeader', sectionHeader);

    /** @ngInject */
    function sectionHeader() {
        return {
            restrict: 'EA',
            scope: {
                title: "=title",
                description: "=description"
            },
            templateUrl: 'app/resources/directives/sectionHeader/sectionHeader.html',
            controller: function ($scope, $element, $attrs) {

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('slideTop', slideTop);

    /** @ngInject */
    function slideTop() {
        return {
            restrict: 'EA',
            scope: {
                title: "=title",
                description: "=description"
            },
            templateUrl: 'app/resources/directives/slideTop/slideTop.html',
            controller: function ($scope, $element, $attrs, Image, bannerStatus, $window) {

                $scope.interval = 5000;
                $scope.noWrapSlides = false;
                $scope.active = 0;
                $scope.slides = [];
                $scope.imageHeight = 175;

                /** load images */
                $scope.loadImages = function () {
                    Image.find({
                        filter: {
                            include: ['imageWeb', 'imageMobile'],
                            where: {status: bannerStatus.ENABLED}
                        }
                    }, function (response) {
                        $scope.slides = response;
                    }, function (errorResponse) {
                        console.log('Images slide error to load.', errorResponse);
                    });
                };

                /** go to url */
                $scope.goto = function (url) {
                    if (url) {
                        $window.open(url, "_blank")
                    }
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

                /** init */
                $scope.loadImages();
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('SubscriptionCtrl', SubscriptionCtrl);

    /** @ngInject */
    function SubscriptionCtrl($scope, $rootScope, toastr, $state, ScreenLoader, Subscription, messagesHelper, validationUtils) {

        $scope.subscription = {};

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.subscription.terms) {
                    toastr.clear();
                    toastr.error(messagesHelper.accept_terms);
                    return;
                }

                Subscription.createSubscription($scope.subscription,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                    }, function (errorResponse) {

                        toastr.clear();
                        if (validationUtils.hasUniquenessError(errorResponse, "email")) {
                            toastr.error(messagesHelper.email_already_exists);
                            return;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('subscriptionForm', subscriptionForm);

    /** @ngInject */
    function subscriptionForm() {
        return {
            restrict: 'EA',
            templateUrl: 'app/resources/directives/subscriptionForm/subscriptionForm.html',
            controller: 'SubscriptionCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.home')
        .controller('AssociatedHomePageCtrl', AssociatedHomePageCtrl);

    /** @ngInject */
    function AssociatedHomePageCtrl($scope, $rootScope, $state, toastr, $q, uiGmapGoogleMapApi, Region, Sector, Category, layoutPaths) {

        $scope.profileIcon = layoutPaths.images.profileIcon;
        $scope.newProjectIcon = layoutPaths.images.newProjectIcon;
        $scope.projectListIcon = layoutPaths.images.projectListIcon;
        $scope.updateProjectIcon = layoutPaths.images.updateProjectIcon;

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.profile')
        .controller('AssociatedProfilePageCtrl', AssociatedProfilePageCtrl);

    /** @ngInject */
    function AssociatedProfilePageCtrl($scope, $rootScope, $state, toastr, $q, ScreenLoader, UserAssociated, LoopBackAuth, messagesHelper, validationUtils, textAngularManager, nomenclator, entityType) {

        $scope.company = $rootScope.userLogged && $rootScope.userLogged.company ? $rootScope.userLogged.company : {};
        $scope.socialNetworks = nomenclator.socialNetworks;

        /** load user company */
        $scope.loadCompany = function () {
            ScreenLoader.show();
            UserAssociated.prototype$__get__company({id: LoopBackAuth.currentUserId}, function (response) {
                ScreenLoader.hide();
                $scope.company = response;
            }, function (errorResponse) {
                ScreenLoader.hide();
            });
        };

        /** create or update user company */
        $scope.createOrUpdate = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                if ($scope.company.id) {
                    UserAssociated.prototype$__update__company({id: LoopBackAuth.currentUserId}, $scope.company,
                        function (response) {
                            ScreenLoader.hide();
                            $scope.company = response;
                            $rootScope.userLogged.company = angular.copy(response);
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            toastr.clear();
                            validationUtils.processErrorResponse(errorResponse);
                        }
                    );
                } else {
                    $scope.company.type = entityType.LOCAL;
                    UserAssociated.prototype$__create__company({id: LoopBackAuth.currentUserId}, $scope.company,
                        function (response) {
                            ScreenLoader.hide();
                            $scope.company = response;
                            $rootScope.userLogged.company = angular.copy(response);
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            toastr.clear();
                            validationUtils.processErrorResponse(errorResponse);
                        }
                    );
                }
            }
        };

        /** get char count of editor */
        $scope.getCharCount = function (editor) {
            return textAngularManager.retrieveEditor(editor).scope.charcount;
        };

        /** add social */
        $scope.addSocial = function (social) {
            if ($scope.company.social && Array.isArray($scope.company.social)) {
                var index = $scope.company.social.findIndex(function (item) {
                    return social === item.id
                });
                if (index !== -1) {
                    toastr.clear();
                    toastr.error(messagesHelper.item_already_exist);
                } else {
                    $scope.company.social.push({
                        id: social,
                        url: ""
                    })
                }
            } else {
                $scope.company.social = [{
                    id: social,
                    url: ""
                }]
            }
        };

        /** remove social */
        $scope.removeSocial = function (index) {
            $scope.company.social.splice(index, 1);
        };

        /** init */
        $scope.loadCompany();
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.project')
        .controller('AssociatedProjectManagePageCtrl', AssociatedProjectManagePageCtrl);

    /** @ngInject */
    function AssociatedProjectManagePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Project, Sector, Region, Province, Activity, InformationBase, Category, Objective, Alliance, Financing, Beneficiary, Diffusion, ScreenLoader, validationUtils, messagesHelper, projectStatus, errorCodes) {

        moment.locale('precise-es', {
            relativeTime: {
                future: "en %s",
                past: "hace %s segundos",
                s: "%d segundos", //see https://github.com/timrwood/moment/pull/232#issuecomment-4699806
                m: "un minuto",
                mm: "%d minutes",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            }
        });
        $scope.startDatePicker = {
            date: ''
        };
        $scope.endDatePicker = {
            date: ''
        };
        $scope.options = {
            singleDatePicker: true,
            showDropdowns: true,
            // timePicker: true,
            applyClass: 'btn-primary',
            cancelClass: 'btn',
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {

                    // var startDate = moment($scope.startDatePicker.date);
                    // var endDate = moment($scope.endDatePicker.date);
                    //
                    // $scope.project.startDate = startDate.isValid() ? startDate.format() : null;
                    // $scope.project.endDate = endDate.isValid() ? endDate.format() : null;
                    // $scope.project.duration = startDate.isValid() && endDate.isValid()
                    //     ? moment.duration(startDate.diff(endDate)).locale('precise-es').humanize()
                    //     : null;
                }
            }
        };

        $scope.project = {};

        $scope.selectedActivities = [];
        $scope.selectedAlliances = [];
        $scope.selectedCategories = [];
        $scope.selectedBeneficiaries = [];
        $scope.selectedInformationBases = [];
        $scope.selectedObjectives = [];
        $scope.selectedFinancings = [];
        $scope.selectedDiffusions = [];
        $scope.selectedLocations = [];

        $scope.errorDetails = {};

        /** prevData only used to detect changes */
        $scope.prevData = {};
        $scope.step = 1;

        $scope.charLimits = {
            objective: 400,
            summary: 2000,
            action: 2000,
            goals: 2000,
            referred: 600,
            history: 600,
            award: 600,
            results: 2000,
            impact: 2000,
            monitoring: 2000
        };

        /** filter resources */
        $scope.filter = {
            projectName: "",
            objectives: [],
            status: [],

            sectors: [],
            categories: [],
            companies: [],

            regions: [],
            provinces: [],
            districts: []
        };

        /** find */
        $scope.loadProject = function () {
            $scope.project = {};
            var filter = {
                include: [
                    "activities",
                    "alliances",
                    "objectives",
                    "informationBases",
                    "categories",
                    "beneficiaries",
                    "diffusions",
                    "financings",
                    "locations",
                    "images",
                    "avatar",
                    "company"
                ]
            };
            Project.findById({id: $stateParams.id, filter: filter}, function (response) {
                $scope.project = response;

                /** equalize relations data for directives */
                $scope.selectedActivities = response.activities.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customActivity"].value
                    }
                });
                $scope.selectedAlliances = response.alliances.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customAlliance"].value
                    }
                });
                $scope.selectedInformationBases = response.informationBases.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customInformationBase"].value
                    }
                });
                $scope.selectedCategories = response.categories.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customCategory"].value
                    }
                });
                $scope.selectedDiffusions = response.diffusions.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customDiffusion"].value
                    }
                });
                $scope.selectedFinancings = response.financings.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customFinancing"].value
                    }
                });
                $scope.selectedBeneficiaries = response.beneficiaries.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customBeneficiary"].value,
                        customAmount: item["customBeneficiary"].amount
                    }
                });
                $scope.selectedLocations = response.locations || [];

                /** datepicker value */
                var startDate = moment(response.startDate);
                var endDate = moment(response.endDate);
                $scope.startDatePicker.date = startDate.isValid() ? startDate : '';
                $scope.endDatePicker.date = endDate.isValid() ? endDate : '';

            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create or update */
        $scope.createOrUpdate = function (isValid, status) {
            if (isValid) {

                if (status !== projectStatus.DRAFT && status !== projectStatus.PENDING) {
                    console.log('Invalid project status');
                    return;
                } else {
                    $scope.project.status = status;
                }

                var data = {
                    project: $scope.project,
                };

                data.activities = [].concat($scope.selectedActivities).map(function (item) {
                    return {
                        idActivity: item.id,
                        value: item.customValue
                    }
                });
                data.alliances = [].concat($scope.selectedAlliances).map(function (item) {
                    return {
                        idAlliance: item.id,
                        value: item.customValue
                    }
                });
                data.beneficiaries = [].concat($scope.selectedBeneficiaries).map(function (item) {
                    return {
                        idBeneficiary: item.id,
                        value: item.customValue,
                        amount: item.customAmount
                    }
                });
                data.categories = [].concat($scope.selectedCategories).map(function (item) {
                    return {
                        idCategory: item.id,
                        value: item.customValue
                    }
                });
                data.diffusions = [].concat($scope.selectedDiffusions).map(function (item) {
                    return {
                        idDiffusion: item.id,
                        value: item.customValue
                    }
                });
                data.financings = [].concat($scope.selectedFinancings).map(function (item) {
                    return {
                        idFinancing: item.id,
                        value: item.customValue
                    }
                });
                data.images = [].concat($scope.project.images).map(function (item) {
                    return {
                        idImage: item.id,
                    }
                });
                data.informationBases = [].concat($scope.selectedInformationBases).map(function (item) {
                    return {
                        idInformationBase: item.id,
                        value: item.customValue
                    }
                });
                data.objectives = [].concat($scope.project.objectives || []).map(function (item) {
                    return {
                        idObjective: item.id
                    }
                });
                data.locations = $scope.selectedLocations;

                ScreenLoader.show();
                $scope.errorDetails = {};
                Project.createOrUpdate(data,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('associated.project.list');
                    }, function (errorResponse) {
                        ScreenLoader.hide();

                        if (errorResponse &&
                            errorResponse.data &&
                            errorResponse.data.error &&
                            errorResponse.data.error.code &&
                            errorResponse.data.error.code === errorCodes.INVALID_PROJECT &&
                            errorResponse.data.error.details) {
                            $scope.errorDetails = errorResponse.data.error.details;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** clear start date */
        $scope.clearStartDate = function () {
            $scope.startDatePicker.date = '';
        };

        /** clear end date */
        $scope.clearEndDate = function () {
            $scope.endDatePicker.date = '';
        };

        /** watch datepickers values */
        var unregisterStartDatepickerWatch = $scope.$watch('startDatePicker.date', function (newValue) {

            var date = moment(newValue);
            var current = moment();
            var picker = $('#startDate').data('daterangepicker');

            if (date.isValid()) {
                $scope.project.startDate = date;
                if (picker) {
                    picker.setStartDate(date);
                    picker.setEndDate(date);
                }
            } else {
                $scope.project.startDate = null;
                if (picker) {
                    picker.setStartDate(current);
                    picker.setEndDate(current);
                }
            }

        }, true);

        var unregisterEndDatepickerWatch = $scope.$watch('endDatePicker.date', function (newValue) {

            var date = moment(newValue);
            var current = moment();
            var picker = $('#endDate').data('daterangepicker');

            if (date.isValid()) {
                $scope.project.endDate = date;
                if (picker) {
                    picker.setStartDate(date);
                    picker.setEndDate(date);
                }
            } else {
                $scope.project.endDate = null;
                if (picker) {
                    picker.setStartDate(current);
                    picker.setEndDate(current);
                }
            }

        }, true);

        /** removing errors after project fields changed */
        var keys = [
            'project.name',
            'project.nameToPublish',
            'project.objective',
            'project.womanEmpowerment',
            'project.objectives',
            'project.summary',
            'project.startDate',
            'project.endDate',
            'project.duration',
            'project.actions',
            'project.goals',
            'project.monitoring',
            'project.results',
            'project.impact',
            'project.history',
            'project.satisfactionIndicator',
            'project.images',
            'project.idAvatar',
            'project.videos',
            'project.links',
            'project.awards',
            'project.referred',
            'project.companyName',
            'project.companyCharge',
            'project.companyEmail',
            'project.companyPhone',

            'selectedActivities',
            'selectedAlliances',
            'selectedBeneficiaries',
            'selectedCategories',
            'selectedDiffusions',
            'selectedFinancings',
            'selectedInformationBases',
            'selectedLocations'
        ];
        var errKeys = {
            'project.name': 'name',
            'project.nameToPublish': 'nameToPublish',
            'project.objective': 'objective',
            'project.womanEmpowerment': 'womanEmpowerment',
            'project.objectives': 'objectives',
            'project.summary': 'summary',
            'project.startDate': 'startDate',
            'project.endDate': 'endDate',
            'project.duration': 'duration',
            'project.actions': 'actions',
            'project.goals': 'goals',
            'project.monitoring': 'monitoring',
            'project.results': 'results',
            'project.impact': 'impact',
            'project.history': 'history',
            'project.satisfactionIndicator': 'satisfactionIndicator',
            'project.images': 'images',
            'project.idAvatar': 'idAvatar',
            'project.videos': 'videos',
            'project.links': 'links',
            'project.awards': 'awards',
            'project.referred': 'referred',
            'project.companyName': 'companyName',
            'project.companyCharge': 'companyCharge',
            'project.companyEmail': 'companyEmail',
            'project.companyPhone': 'companyPhone',

            'selectedActivities': 'activities',
            'selectedAlliances': 'alliances',
            'selectedBeneficiaries': 'beneficiaries',
            'selectedCategories': 'categories',
            'selectedDiffusions': 'diffusions',
            'selectedFinancings': 'financing',
            'selectedInformationBases': 'informationBases',
            'selectedLocations': 'locations'
        };
        var unregisterFieldsWatchers = [];

        angular.forEach(keys, function (key) {
            unregisterFieldsWatchers.push(
                $scope.$watch(key, function (newValue, oldValue) {
                    if (errKeys[key]) {
                        delete $scope.errorDetails[errKeys[key]];
                    } else {
                        console.log("no has err key for: ", key)
                    }
                }, true)
            );
        });

        $scope.$on('$destroy', function () {
            unregisterStartDatepickerWatch();
            unregisterEndDatepickerWatch();

            angular.forEach(unregisterFieldsWatchers, function (watcher) {
                watcher();
            });
        });

        /** toggle endDateExecution */
        $scope.toggleEndDateExecution = function (endDateExecution) {
            if (endDateExecution === true) {
                $scope.endDatePicker.date = '';
            }
        };

        /** init */
        if ($state.is('associated.project.edit') && $stateParams.id) {
            $scope.loadProject();
        }

        if ($state.is('associated.project.create')) {
            $scope.startDatePicker.date = '';
            $scope.endDatePicker.date = '';
        }

        $scope.autosave = function () {
            console.log('autosave!');
            // var hasChanges = !angular.equals($scope.prevData, data);
            // $scope.prevData = angular.copy(data);
            // console.log("hasChanges", hasChanges);
        }
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.project')
        .controller('AssociatedProjectPageCtrl', AssociatedProjectPageCtrl);

    /** @ngInject */
    function AssociatedProjectPageCtrl($scope, $rootScope, $state, $stateParams, toastr, $q, UserAssociated, ScreenLoader, LoopBackAuth, projectStatus) {

        $scope.projects = [];
        $scope.search = $stateParams.s;
        $scope.finishedLoading = false;

        /** find projects */
        $scope.loadProjects = function () {
            ScreenLoader.show();
            $scope.finishedLoading = false;

            $state.go('.', {
                s: $scope.search
            }, {notify: true});

            UserAssociated.getProjects({id: LoopBackAuth.currentUserId, search: $scope.search}, function (response) {
                ScreenLoader.hide();
                $scope.finishedLoading = true;
                $scope.projects = response;
            }, function (errorResponse) {
                console.log('User associated load projects error.', errorResponse);
                ScreenLoader.hide();
                $scope.finishedLoading = true;
            })
        };

        /** get status name */
        $scope.getStatusName = function (status) {
            switch (status) {
                case projectStatus.DRAFT:
                    return 'Editable';
                case projectStatus.PENDING:
                    return 'Por Revisar';
                case projectStatus.PUBLISHED:
                    return 'Editable';
            }
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'list') {
                $scope.loadProjects();
            }
        }

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.updates')
        .controller('AssociatedUpdatesPageCtrl', AssociatedUpdatesPageCtrl);

    /** @ngInject */
    function AssociatedUpdatesPageCtrl($scope, $rootScope, $state, $stateParams, toastr, $q, UserAssociated, Update, ScreenLoader, LoopBackAuth, messagesHelper, validationUtils, updateStatus, textAngularManager) {

        $scope.projects = [];
        $scope.search = $stateParams.s;
        $scope.finishedLoading = false;

        $scope.selectedProject = null;
        $scope.update = {};

        $scope.taToolbar = [
            [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
        ];

        /** find projects */
        $scope.loadProjects = function () {
            $scope.selectedProject = null;

            ScreenLoader.show();
            $scope.finishedLoading = false;

            $state.go('.', {
                s: $scope.search
            }, {notify: true});

            UserAssociated.getProjects({id: LoopBackAuth.currentUserId, search: $scope.search}, function (response) {
                ScreenLoader.hide();
                $scope.finishedLoading = true;
                $scope.projects = response;
            }, function (errorResponse) {
                console.log('User associated load projects error.', errorResponse);
                ScreenLoader.hide();
                $scope.finishedLoading = true;
            })
        };

        /** create update */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.update.content || $scope.getCharCount() === 0) {
                    toastr.clear();
                    toastr.error(messagesHelper.complete_all_fields);
                    return;
                }

                ScreenLoader.show();
                $scope.errorDetails = {};
                $scope.update.status = updateStatus.PENDING;
                Update.create($scope.update,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);

                        $scope.selectedProject = null;

                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        validationUtils.processErrorResponse(errorResponse);
                        console.log('Update creation error.', errorResponse);
                    }
                );
            }
        };

        /** select project to add update */
        $scope.selectProject = function (project) {
            $scope.selectedProject = project;
        };

        /** cancel update */
        $scope.cancelUpdate = function () {
            $scope.selectedProject = null;
        };

        /** selected project watch */
        var unregisterWatch = $scope.$watch('selectedProject', function (newValue, oldValue) {
            if (newValue && newValue.id) {
                $scope.update = {
                    idProject: newValue.id,
                    date: moment().format(),
                    content: ""
                }
            } else {
                $scope.update = {};
            }
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });

        $scope.getCharCount = function () {
            return textAngularManager.retrieveEditor('ta-project-update').scope.charcount;
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'list') {
                $scope.loadProjects();
            }
        }

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .controller('MenuTopCtrl', MenuTopCtrl);

    /** @ngInject */
    function MenuTopCtrl($scope, $rootScope, $q, toastr, assetPaths, $state, $stateParams, LoopBackAuth, ScreenLoader, UserAssociated, Sector, Category, menuType) {

        $scope.logoTop = assetPaths.images.logo1x;
        $scope.mainMenuItems = [];
        $rootScope.searchText = $stateParams.s || "";
        $scope.searchActive = !!$stateParams.s;


        /** check if is article state */
        $scope.isArticleState = function (toName) {
            return toName === 'main.article.list' || toName === 'main.article.find_by_slug';
        };

        /** show search component for all states except for article states */
        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromStateParams) {
            $rootScope.enabledSearchComponent = !$scope.isArticleState(toState.name);
        });

        /** show/hide search component flag */
        $rootScope.enabledSearchComponent = !$scope.isArticleState($state.current.name);

        $scope.articleConfig = $rootScope.currentConfig ? $rootScope.currentConfig.article || {} : {};

        /** load main menu items */
        $scope.loadMainMenuItems = function () {
            $scope.mainMenuItems = [];

            $q.all([
                Sector.find({filter: {where: {mainMenu: true}, order: "mainMenuOrder ASC"}}).$promise,
                Category.find({filter: {where: {mainMenu: true}, order: "name ASC"}}).$promise
            ]).then(function (results) {

                var sectors = results[0];
                var categories = results[1];
                var items = [];

                items.push({
                    title: 'Inicio',
                    childrens: [],
                    href: $state.href('main.home', {absolute: true})
                });

                sectors.forEach(function (item) {
                    items.push({
                        title: item.name,
                        childrens: [],
                        href: $state.href('main.project.project_sector', {idSector: item.id}, {absolute: true})
                    });
                });

                if (categories && Array.isArray(categories) && categories.length) {
                    var menuItem = {
                        title: 'Tema',
                        childrens: categories.map(function (item) {
                            return {
                                title: item.name,
                                href: $state.href('main.project.project_category', {idCategory: item.id}, {absolute: true})
                            }
                        })
                    };
                    items.push(menuItem);
                }

                if ($scope.articleConfig && $scope.articleConfig.menuName) {
                    items.push({
                        title: $scope.articleConfig.menuName,
                        childrens: [],
                        href: $state.href('main.article.list', {}, {absolute: true})
                    });
                }

                $scope.mainMenuItems = items;

            }, function (error) {
                console.log("Load menu items error.", error);
            });
        };

        /** load associated menu items */
        $scope.loadAssociatedMenuItems = function () {
            $scope.mainMenuItems = [
                {
                    title: 'Menú',
                    childrens: [
                        {
                            title: "Inicio",
                            href: $state.href('associated.home', {}, {absolute: true})
                        }, {
                            title: "Perfil",
                            href: $state.href('associated.profile', {}, {absolute: true})
                        }, {
                            title: "Proyectos",
                            href: $state.href('associated.project.list', {}, {absolute: true})
                        }, {
                            title: "Nuevo Proyecto",
                            href: $state.href('associated.project.create', {}, {absolute: true})
                        }, {
                            title: "Actualización",
                            href: $state.href('associated.updates.list', {}, {absolute: true})
                        }
                    ]
                }
            ]
        };

        $scope.search = function (search) {
            if ($scope.searchActive) {
                if (search === $stateParams.s) {
                    $scope.searchActive = false;
                } else {
                    $state.go('main.project.project_search', {s: search});
                }
            } else {
                $scope.searchActive = true;
            }
        };

        /** watch menu type changes */
        var unregisterWatch = $scope.$watch('type', function (newValue, oldValue) {
            $scope.mainMenuItems = [];
            if (newValue === menuType.MAIN) {
                $scope.loadMainMenuItems();
            }
            if (newValue === menuType.ASSOCIATED) {
                $scope.loadAssociatedMenuItems();
            }
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });

        $scope.logout = function () {
            ScreenLoader.show();
            UserAssociated.logout(function (response) {
                ScreenLoader.hide();
                $rootScope.userLogged = null;
                $state.go('main.home');
            }, function (errorResponse) {
                ScreenLoader.hide();
                $rootScope.userLogged = null;
                $state.go('main.home');
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .directive('menuTop', menuTop);

    /** @ngInject */
    function menuTop() {
        return {
            restrict: 'EA',
            scope: {
                type: "@type"
            },
            templateUrl: 'app/pages/components/menuTop/menuTop.html',
            controller: 'MenuTopCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .directive('articleSocialLink', articleSocialLink);

    /** @ngInject */
    function articleSocialLink($state, SharedLink) {
        return {
            restrict: 'E',
            templateUrl: 'app/pages/components/social_link/article_social_link.html',
            scope: {
                article: '='
            },
            link: function (scope, element, attrs) {
                scope.generateLink = function (social) {
                    var url = $state.href('main.article.show', {
                        id_edition: scope.article.idEdition,
                        slug: scope.article.slug
                    }, {absolute: true});

                    return SharedLink[social](url);
                }
            }
            // controller: function ($scope, ) {
            //     $state.href('user.home.view', params, {absolute: true})
            //     var sharedLinks = [];
            //
            // }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .directive('uptodateSocialLink', uptodateSocialLink);

    /** @ngInject */
    function uptodateSocialLink($state, SharedLink) {
        return {
            restrict: 'E',
            templateUrl: 'app/pages/components/social_link/article_social_link.html',
            scope: {
                article: '='
            },
            link: function (scope, element, attrs) {
                scope.generateLink = function (social) {
                    var url = $state.href('main.uptodate.show', {
                        slug: scope.article.slug
                    }, {absolute: true});

                    return SharedLink[social](url);
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .controller('TopBarCtrl', TopBarCtrl);

    /** @ngInject */
    function TopBarCtrl($scope, $rootScope, toastr, $state, $stateParams, assetPaths, messagesHelper, errorCodes, LoopBackAuth, ScreenLoader, UserEntity, UserAssociated, validationUtils, Sector, Category, $q) {

        $scope.credentials = {};
        $scope.recovery = {};
        $scope.logoTop = assetPaths.images.logo1x;
        $scope.form = 'login';
        $scope.isCollapsed = true;
        $scope.isSubmenuCollapsed = true;
        $rootScope.activeMenu = '';
        $scope.mainMenuItems = [];

        $scope.articleConfig = $rootScope.currentConfig ? $rootScope.currentConfig.article || {} : {};

        /** trigger for login user*/
        $scope.signin = function (isValid) {
            if (isValid) {
                $scope.login($scope.credentials, true);
            }
        };

        /** login user */
        $scope.login = function (credentials, rememberMe) {

            rememberMe = !!rememberMe;
            ScreenLoader.show();
            UserAssociated.login({rememberMe: rememberMe}, credentials, function (response) {
                ScreenLoader.hide();
                $rootScope.userLogged = LoopBackAuth.currentUserData;
                $scope.credentials = {};

                var idCompany = response.user.company ? response.user.company.id : null;
                try {
                    if (OneSignal && idCompany) {
                        OneSignal.push(function () {
                            OneSignal.sendTags({'idCompany': idCompany});
                        });
                    }
                } catch (e) {
                    console.log('OneSignal sendTag error', e);
                }

                $state.go('associated.home');

            }, function (errorResponse) {
                ScreenLoader.hide();

                /** unverified account */
                if (errorResponse &&
                    errorResponse.data &&
                    errorResponse.data.error &&
                    errorResponse.data.error.code === errorCodes.LOGIN_FAILED_EMAIL_NOT_VERIFIED) {
                    toastr.clear();
                    toastr.error(messagesHelper.unverified_account);
                    return;
                }

                toastr.clear();
                toastr.error(messagesHelper.bad_credentials);
            });
        };

        /** logout user */
        $scope.logout = function () {
            ScreenLoader.show();
            UserAssociated.logout(function (response) {
                ScreenLoader.hide();
                $rootScope.userLogged = null;

                try {
                    if (OneSignal) {
                        OneSignal.push(function () {
                            OneSignal.deleteTags(['idCompany']);
                        });
                    }
                } catch (e) {
                    console.log('OneSignal deleteTag error', e);
                }

                $state.go('main.home');
            }, function (errorResponse) {
                ScreenLoader.hide();
                $rootScope.userLogged = null;
                $state.go('main.home');
            });
        };

        /** set form view */
        $scope.setForm = function (form) {
            $scope.form = form;
        };

        /** toggle active menu */
        $scope.toggleActiveMenu = function (menu) {
            if ($rootScope.activeMenu === menu) {
                $rootScope.activeMenu = '';
            } else {
                $rootScope.activeMenu = menu;
            }
        };

        /** check active menu */
        $scope.isActiveMenu = function (menu) {
            return $rootScope.activeMenu === menu;
        };

        $rootScope.$watch('activeMenu', function (newValue, oldValue) {
            if (newValue) {
                $('body').addClass('open-mobile-section');
            } else {
                $('body').removeClass('open-mobile-section');
            }
        });

        /** toggle submenu collapsed */
        $scope.toggleSubmenuCollapsed = function () {
            $scope.isSubmenuCollapsed = !$scope.isSubmenuCollapsed;
        };

        /** load main menu items */
        $scope.loadMainMenuItems = function () {
            $scope.mainMenuItems = [];

            $q.all([
                Sector.find({filter: {where: {mainMenu: true}, order: "mainMenuOrder ASC"}}).$promise,
                Category.find({filter: {where: {mainMenu: true}, order: "name ASC"}}).$promise
            ]).then(function (results) {

                var sectors = results[0];
                var categories = results[1];
                var items = [];

                items.push({
                    title: 'Inicio',
                    childrens: [],
                    href: $state.href('main.home', {absolute: true})
                });

                sectors.forEach(function (item) {
                    items.push({
                        entityId: item.id,
                        title: item.name,
                        childrens: [],
                        href: $state.href('main.project.project_sector', {idSector: item.id}, {absolute: true})
                    });
                });

                if (categories && Array.isArray(categories) && categories.length) {
                    var menuItem = {
                        title: 'Tema',
                        childrens: categories.map(function (item) {
                            return {
                                entityId: item.id,
                                title: item.name,
                                href: $state.href('main.project.project_category', {idCategory: item.id}, {absolute: true})
                            }
                        })
                    };
                    items.push(menuItem);
                }

                if ($scope.articleConfig && $scope.articleConfig.menuName) {
                    items.push({
                        title: $scope.articleConfig.menuName,
                        childrens: [],
                        href: $state.href('main.article.list', {}, {absolute: true})
                    });
                }

                $scope.mainMenuItems = items;

            }, function (error) {
                console.log("Load menu items error.", error);
            });
        };

        /** recovery password */
        $scope.sendRecovery = function (isValid) {
            if (isValid) {
                if (!$scope.recovery.username) {
                    toastr.clear();
                    toastr.error(messagesHelper.complete_all_fields);
                    return;
                }

                ScreenLoader.show();
                UserAssociated.sendPassword({username: $scope.recovery.username}, function (response) {
                    ScreenLoader.hide();
                    $scope.recovery = {};
                    toastr.clear();
                    toastr.success(messagesHelper.success_recovery);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    console.log("Recovery password error.", errorResponse);
                    validationUtils.processErrorResponse(errorResponse);
                });
            }
        };

        $scope.loadMainMenuItems();

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.components')
        .directive('topBar', topBar);

    /** @ngInject */
    function topBar() {
        return {
            restrict: 'E',
            templateUrl: 'app/pages/components/topBar/topBar.html',
            controller: 'TopBarCtrl'
        };
    }
})();
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme.components')
        .directive('breadcrumb', breadcrumb);

    /** @ngInject */
    function breadcrumb($state) {
        return {
            restrict: 'EA',
            templateUrl: 'app/theme/components/breadcrumb/breadcrumb.html',
            scope: {
                states: '=?'
            },
            link: function (scope) {
                console.log(scope.states[0]);
                scope.$watch(function () {
                    scope.activePageTitle = $state.current.title;
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.theme.components')
        .directive('pageTop', pageTop);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: function ($scope, $rootScope, $state) {
            }
        };
    }
})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('ProjectDirectory.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('articleCard', articleCard);

    /** @ngInject */
    function articleCard() {
        return {
            restrict: 'EA',
            scope: {
                classes: "=classes",
                article: "=article",
                imageHeight: "=imageHeight",
                highlight: "=highlight",
                urlView: "@urlView"
            },
            templateUrl: 'app/resources/directives/articles/articleCard/articleCard.html',
            controller: function ($scope, $element, $attrs) {

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('articleSharedLinks', articleSharedLinks);

    /** @ngInject */
    function articleSharedLinks($state) {
        return {
            restrict: 'E',
            templateUrl: 'app/resources/directives/articles/articleSharedLinks/articleSharedLinks.html',
            scope: {
                article: '=article'
            },
            controller: function ($scope, $element, $attrs, socialType, sharedLink) {

                $scope.social = [];

                var unregisterWatch = $scope.$watch('article', function (newValue, oldValue) {
                    if (newValue /*!== oldValue*/) {

                        var social = [];
                        Object.keys(socialType).forEach(function (key) {
                            if (socialType.hasOwnProperty(key)) {
                                var url = $state.href('main.article.find_by_slug', {
                                    slug: $scope.article.slug
                                }, {absolute: true});

                                social.push({
                                    id: socialType[key],
                                    url: sharedLink[socialType[key]](url)
                                });
                            }
                        });

                        $scope.social = social;
                    }
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('articleSlickImageSlide', articleSlickImageSlide);

    /** @ngInject */
    function articleSlickImageSlide() {
        return {
            restrict: 'EA',
            scope: {
                article: "=article",
                height: "=height",
                previewHeight: "=previewHeight",
                minItemsToShowNavigation: "=minItemsToShowNavigation"
            },
            templateUrl: 'app/resources/directives/articles/articleSlickImageSlide/articleSlickImageSlide.html',
            controller: function ($scope, $element, $attrs, Image, $timeout) {

                $scope.interval = 5000;
                $scope.noWrapSlides = false;
                $scope.active = 0;

                $scope.images = [];

                $scope.setActive = function (index) {
                    $timeout(function () {
                        if ($scope.active !== index) {
                            $scope.active = index;
                            console.log(index);
                        }
                    });
                };

                var unregisterWatch = $scope.$watch('article', function (newValue, oldValue) {
                    if (newValue) {

                        var images = [];
                        if (newValue.avatar) {
                            images.push(newValue.avatar);
                        }

                        if (newValue.images && Array.isArray(newValue.images)) {
                            newValue.images.forEach(function (image) {
                                images.push(image);
                            });
                        }
                        $scope.images = images;
                    }
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('errorMessage', errorMessage);

    /** @ngInject */
    function errorMessage() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                limit: "=limit",
            },
            templateUrl: 'app/resources/directives/manageProjects/errorMessage/errorMessage.html',
            controller: function ($scope, $rootScope, $element, $attrs) {

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('GmapsCtrl', GmapsCtrl);

    /** @ngInject */
    function GmapsCtrl($scope, $rootScope, toastr, $state, ScreenLoader, uiGmapGoogleMapApi, uiGmapIsReady, Project, assetPaths) {

        $scope.markers = [];
        $scope.windowOptions = {
            boxClass: "gmap-infobox",
        };
        $scope.defaultMapCenter = {latitude: -12.046374, longitude: -77.042793};
        $scope.mapControl = {};
        $scope.options = {
            minZoom: 2,
            maxZoom: 11,
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true
        };

        $scope.events = {
            // idle: function (map) {
            //     if (map.getZoom() > 6) {
            //         map.setZoom(6);
            //     }
            // }
        };

        uiGmapGoogleMapApi.then(function (maps) {
            $scope.map = {
                center: $scope.defaultMapCenter,
                zoom: 6,
                bounds: {
                    northeast: {
                        latitude: -12,
                        longitude: -77
                    },
                    southwest: {
                        latitude: -12.046374,
                        longitude: -77.042793
                    }
                }
            };
        });

        /** get marker image */
        $scope.getMarkerImage = function (project) {
            return assetPaths.symbols["M"];
            return assetPaths.symbols[project.sector.name.charAt(0).toUpperCase()];
        };

        /** create marker */
        $scope.createMarker = function (id, latitude, longitude, isDraggable) {
            return {
                id: id,
                latitude: latitude,
                longitude: longitude,
                options: {
                    draggable: isDraggable
                },
                // icon: {
                //     url: $scope.getMarkerImage(location)
                // }
            }
        };

        /** calculate center of map */
        $scope.recalculateMapCenter = function () {
            if ($scope.markers.length) {
                var bounds = new google.maps.LatLngBounds();
                $scope.markers.forEach(function (marker) {
                    bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
                });

                $scope.mapControl.getGMap().fitBounds(bounds);
            }
        };

        /** refresh markers in map */
        $scope.updateMap = function () {
            uiGmapIsReady.promise()
                .then(function (instances) {
                    var markers = [];
                    $scope.locations.forEach(function (location, index) {
                        markers.push($scope.createMarker('marker_' + index, location.latitude, location.longitude, false));
                    });

                    $scope.markers = markers;
                    $scope.recalculateMapCenter();
                });
        };

        /** watch location changes */
        var unregisterWatch = $scope.$watch('locations', function (newValues, oldValues) {
            $scope.updateMap();
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('gmaps', gmaps);

    /** @ngInject */
    function gmaps() {
        return {
            restrict: 'EA',
            scope: {
                locations: "=locations",
            },
            templateUrl: 'app/resources/directives/manageProjects/gmaps/gmaps.html',
            controller: 'GmapsCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputAction', inputAction);

    /** @ngInject */
    function inputAction() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputAction/inputAction.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-actions').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputGoals', inputGoals);

    /** @ngInject */
    function inputGoals() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputGoals/inputGoals.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-goals').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputHistory', inputHistory);

    /** @ngInject */
    function inputHistory() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputHistory/inputHistory.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-history').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputImpact', inputImpact);

    /** @ngInject */
    function inputImpact() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputImpact/inputImpact.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-impact').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputMonitoring', inputMonitoring);

    /** @ngInject */
    function inputMonitoring() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputMonitoring/inputMonitoring.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-monitoring').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputObjective', inputObjective);

    /** @ngInject */
    function inputObjective() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputObjective/inputObjective.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputReferred', inputReferred);

    /** @ngInject */
    function inputReferred() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputReferred/inputReferred.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputResults', inputResults);

    /** @ngInject */
    function inputResults() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputResults/inputResults.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-results').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputSatisfactionIndicator', inputSatisfactionIndicator);

    /** @ngInject */
    function inputSatisfactionIndicator() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputSatisfactionIndicator/inputSatisfactionIndicator.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputSummary', inputSummary);

    /** @ngInject */
    function inputSummary() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputSummary/inputSummary.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-summary').scope.charcount;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorActivity', selectorActivity);

    /** @ngInject */
    function selectorActivity() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorActivity/selectorActivity.html',
            controller: function ($scope, $rootScope, $element, $attrs, Activity, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.activities = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Activity.find({filter: {include: []}}, function (response) {
                        $scope.activities = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                        console.log("Activities load resources error.", errorResponse);
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.activities.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.activities.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorAlliance', selectorAlliance);

    /** @ngInject */
    function selectorAlliance() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorAlliance/selectorAlliance.html',
            controller: function ($scope, $element, $attrs, Alliance, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.alliances = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Alliance.find({filter: {include: []}}, function (response) {
                        $scope.alliances = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.alliances.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.alliances.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorAward', selectorAward);

    /** @ngInject */
    function selectorAward() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                limit: "=limit",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorAward/selectorAward.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = "";
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = "";
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorBeneficiary', selectorBeneficiary);

    /** @ngInject */
    function selectorBeneficiary() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorBeneficiary/selectorBeneficiary.html',
            controller: function ($scope, $element, $attrs, Beneficiary, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.beneficiaries = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.loadResources = function () {
                    Beneficiary.find({}, function (response) {
                        $scope.beneficiaries = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.beneficiaries.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.beneficiaries.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id;
                            });
                            if (selected) {
                                item.customAmount = selected.customAmount;
                                if (item.custom === true) {
                                    item.customValue = selected.customValue;
                                }
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, amount, value) {
                    var idx = $scope.selected.findIndex(function (el) {
                        return el.id === item.id;
                    });
                    if (idx > -1) {
                        if (item.custom && !amount) {
                            value = undefined;
                        }
                        if (!amount && !value) {
                            $scope.selected.splice(idx, 1);
                        } else {
                            $scope.selected[idx].customAmount = amount;
                            $scope.selected[idx].customValue = value;
                        }
                    } else {
                        $scope.selected.push({
                            id: item.id,
                            custom: item.custom,
                            customValue: value,
                            customAmount: amount
                        })
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.selected = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorCategory', selectorCategory);

    /** @ngInject */
    function selectorCategory() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorCategory/selectorCategory.html',
            controller: function ($scope, $element, $attrs, Category, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.categories = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Category.find({
                        filter: {
                            include: ["subcategories"],
                            where: {idCategory: null}
                        }
                    }, function (response) {
                        $scope.categories = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.categories.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.categories.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorCompany', selectorCompany);

    /** @ngInject */
    function selectorCompany() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                fieldName: "=fieldName",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorCompany/selectorCompany.html',
            controller: function ($scope, $rootScope, $element, $attrs, Company, projectFieldUtils) {

                $scope.companies = [];

                /** find companies */
                $scope.loadCompanies = function () {
                    Company.find({filter: {order: "name ASC"}}, function (response) {
                        $scope.companies = response;
                    }, function (errorResponse) {
                        console.log(errorResponse);
                    })
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

                /** field visibility verification */
                if (projectFieldUtils.isVisible($scope.fieldName)) {
                    $scope.loadCompanies();

                    if (projectFieldUtils.isPrivate($scope.fieldName)) {
                        angular.element($element).addClass('invisible-item');
                    }
                } else {
                    $element.remove();
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorDiffusion', selectorDiffusion);

    /** @ngInject */
    function selectorDiffusion() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorDiffusion/selectorDiffusion.html',
            controller: function ($scope, $element, $attrs, Diffusion, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.diffusions = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Diffusion.find({filter: {include: []}}, function (response) {
                        $scope.diffusions = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.diffusions.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.diffusions.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorFinancing', selectorFinancing);

    /** @ngInject */
    function selectorFinancing() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorFinancing/selectorFinancing.html',
            controller: function ($scope, $element, $attrs, Financing, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.financing = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Financing.find({filter: {include: []}}, function (response) {
                        $scope.financing = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.financing.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.financing.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorImageUpload', selectorImageUpload);

    /** @ngInject */
    function selectorImageUpload() {
        return {
            restrict: 'EA',
            scope: {
                // selected: "=ngModel",
                visibility: "=visibility",
                visibilityAvatar: "=visibilityAvatar",
                isRequired: "=isRequired",
                isRequiredAvatar: "=isRequiredAvatar",
                files: "=files",
                container: "=container",
                idAvatar: "=idAvatar",
                errors: "=errors",
                errorsAvatar: "=errorsAvatar"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorImageUpload/selectorImageUpload.html',
            controller: function ($scope, $element, $attrs, pdConfig, Upload, LoopBackAuth, $timeout, ScreenLoader, toastr, messagesHelper, validationUtils, assetPaths, projectFieldVisibility, recommendedSizes) {

                $scope.recommendedSizes = recommendedSizes.projectSlide;

                // $scope.files = [];
                $scope.uFiles = [null];
                $scope.noImageUrl = assetPaths.images.noImageUrl;

                $scope.itemsPerColumn = 0;
                $scope.objectives = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                /** add upload item */
                $scope.addUploadItem = function () {
                    // if (!$scope.newItem) {
                    //     toastr.clear();
                    //     toastr.error(messagesHelper.complete_the_field);
                    //     return;
                    // }
                    $scope.uFiles.push(null);
                };

                /** remove item */
                $scope.removeItem = function (index) {
                    if ($scope.files[index].id === $scope.idAvatar) {
                        $scope.idAvatar = null;
                    }
                    $scope.files.splice(index, 1);
                };

                /** remove upload item */
                $scope.removeUploadItem = function (index) {
                    $scope.uFiles.splice(index, 1);
                };

                /** upload file */
                $scope.uploadFile = function (file, index) {
                    ScreenLoader.show();
                    if (file) {
                        file.upload = Upload.upload({
                            url: pdConfig.apiUrlBase + '/files/' + $scope.container + '/upload?access_token=' + LoopBackAuth.accessTokenId,
                            data: {file: file}
                        });
                        file.upload.then(function (response) {
                            $timeout(function () {
                                ScreenLoader.hide();
                                toastr.clear();
                                toastr.success(messagesHelper.success_upload);
                                $scope.files.push(response.data[0]);

                                // $scope.removeUploadItem(index);
                                $scope.file = null;
                            });
                        }, function (response) {
                            ScreenLoader.hide();
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                                console.log($scope.errorMsg);
                                validationUtils.processErrorResponse(response);
                            }
                        }, function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    }
                };

                /** set as avatar */
                $scope.setAsAvatar = function (index, checked) {
                    for (var i = 0; i < $scope.files.length; i++) {
                        if (i !== index) {
                            $scope.files[i].checked = false;
                        } else {
                            $scope.files[i].checked = checked;
                        }
                    }
                    $scope.idAvatar = checked ? $scope.files[index].id : null;
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE ||
                        $scope.visibilityAvatar === projectFieldVisibility.PUBLIC ||
                        $scope.visibilityAvatar === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('files', function (newValue, oldValue) {
                    $scope.files = newValue || [];

                    for (var i = 0; i < $scope.files.length; i++) {
                        $scope.files[i].checked = $scope.files[i].id === $scope.idAvatar;
                    }

                }, true);

                var unregisterVisibilityWatch = $scope.$watchGroup(['visibility', 'visibilityAvatar'], function (newValues, oldValues) {

                    var visibility = newValues[0];
                    var visibilityAvatar = newValues[1];

                    if (visibility === projectFieldVisibility.PUBLIC || visibilityAvatar === projectFieldVisibility.PUBLIC) {
                        angular.element($element).removeClass('private-item');
                        angular.element($element).addClass('public-item');
                    }

                    if (visibility === projectFieldVisibility.PRIVATE || visibilityAvatar === projectFieldVisibility.PRIVATE) {
                        angular.element($element).removeClass('public-item');
                        angular.element($element).addClass('private-item');
                    }

                }, true);


                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorInformationBase', selectorInformationBase);

    /** @ngInject */
    function selectorInformationBase() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorInformationBase/selectorInformationBase.html',
            controller: function ($scope, $element, $attrs, InformationBase, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.informationBases = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    InformationBase.find({filter: {include: []}}, function (response) {
                        $scope.informationBases = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.informationBases.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.informationBases.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorLink', selectorLink);

    /** @ngInject */
    function selectorLink() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorLink/selectorLink.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = {
                    title: "",
                    url: ""
                };
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem || !$scope.newItem.title || !$scope.newItem.url) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = {
                        title: "",
                        url: ""
                    };
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorLocation', selectorLocation);

    /** @ngInject */
    function selectorLocation() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorLocation/selectorLocation.html',
            controller: function ($scope, $rootScope, $element, $attrs, Region, Province, District, ScreenLoader, pdConfig, $http, $httpParamSerializer, $q, toastr, messagesHelper, validationUtils, projectFieldUtils, projectFieldVisibility) {

                $scope.regions = [];
                $scope.provinces = [];
                $scope.districts = [];

                $scope.isEdition = false;
                $scope.currentIndex = 0;
                $scope.location = {
                    idRegion: null,
                    idProvince: null,
                    idDistrict: null,
                    populatedCenter: null,
                    latitude: null,
                    longitude: null,
                };

                /** find regions */
                $scope.loadRegions = function () {
                    ScreenLoader.show();
                    Region.find({}, function (response) {
                        ScreenLoader.hide();
                        $scope.regions = response;
                        $scope.provinces = [];
                        $scope.districts = [];
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** find provinces */
                $scope.loadProvinces = function (idRegion) {
                    ScreenLoader.show();
                    Province.find({filter: {where: {idRegion: idRegion}}}, function (response) {
                        ScreenLoader.hide();
                        $scope.provinces = response;
                        $scope.districts = [];
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** find districts */
                $scope.loadDistricts = function (idProvince) {
                    ScreenLoader.show();
                    District.find({filter: {where: {idProvince: idProvince}}}, function (response) {
                        ScreenLoader.hide();
                        $scope.districts = response;
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** calculate coordinates */
                $scope.calculateCoords = function () {
                    var key = pdConfig.geocodeApiKey;
                    var address = ['Perú'];
                    var params = {
                        key: key,
                        address: '',
                        components: {
                            country: 'PE'
                        }
                    };

                    if ($scope.location.idRegion) {
                        var region = $scope.regions.find(function (item) {
                            return item.id === $scope.location.idRegion;
                        });
                        if (region) {
                            address.unshift(region.name);
                        }
                    }
                    if ($scope.location.idProvince) {
                        var province = $scope.provinces.find(function (item) {
                            return item.id === $scope.location.idProvince;
                        });
                        if (province) {
                            address.unshift(province.name);
                        }
                    }
                    if ($scope.location.idDistrict) {
                        var district = $scope.districts.find(function (item) {
                            return item.id === $scope.location.idDistrict;
                        });
                        if (district) {
                            address.unshift(district.name);
                        }
                    }
                    if ($scope.location.populatedCenter) {
                        address.unshift($scope.location.populatedCenter);
                    }

                    params.address = address.join(', ');

                    var url = "https://maps.googleapis.com/maps/api/geocode/json?" + $httpParamSerializer(params);
                    ScreenLoader.show();
                    $http.post(url).then(function (response) {
                        ScreenLoader.hide();

                        if (response.data &&
                            response.data.status &&
                            response.data.status === 'OK' &&
                            response.data.results &&
                            response.data.results.length) {

                            var result = response.data.results[0];
                            var coordinates = result.geometry.location;

                            $scope.location.latitude = coordinates.lat;
                            $scope.location.longitude = coordinates.lng;
                        } else {
                            $scope.location.latitude = null;
                            $scope.location.longitude = null;
                        }
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        $scope.location.latitude = null;
                        $scope.location.longitude = null;
                    });
                };

                /** create or update location */
                $scope.createOrUpdateLocation = function () {
                    if (!$scope.isValidLocation($scope.location)) {
                        toastr.error(messagesHelper.complete_all_location_fields);
                        return;
                    }
                    if (!$scope.isValidCoordinates($scope.location)) {
                        toastr.error(messagesHelper.invalid_coordinates);
                        return;
                    }
                    if ($scope.isEdition && $scope.model[$scope.currentIndex]) {
                        $scope.model[$scope.currentIndex] = angular.copy($scope.location);
                    } else {
                        $scope.model.push(angular.copy($scope.location));
                    }
                    $scope.resetLocation();
                };

                /** reset location */
                $scope.resetLocation = function () {
                    $scope.location = {
                        idRegion: null,
                        idProvince: null,
                        idDistrict: null,
                        populatedCenter: null,
                        latitude: null,
                        longitude: null,
                    };
                    $scope.provinces = [];
                    $scope.districts = [];
                    $scope.isEdition = false;
                };

                /** remove location */
                $scope.removeLocation = function (index) {
                    if ($scope.currentIndex === index) {
                        $scope.model.splice(index, 1);
                        $scope.resetLocation();
                    }
                };

                /** select location */
                $scope.selectLocation = function (location, index) {
                    $scope.currentIndex = index;
                    $scope.location = angular.copy(location);
                    $scope.reloadResources(location.idRegion, location.idProvince);
                    $scope.isEdition = true;
                };

                /** reload resources */
                $scope.reloadResources = function (idRegion, idProvince) {
                    ScreenLoader.show();
                    $q.all([
                        Province.find({filter: {where: {idRegion: idRegion}}}).$promise,
                        District.find({filter: {where: {idProvince: idProvince}}}).$promise,
                    ]).then(function (results) {
                        ScreenLoader.hide();

                        $scope.provinces = results[0];
                        $scope.districts = results[1];

                    }, function (error) {
                        ScreenLoader.hide();
                        toastr.error(messagesHelper.fail_operation);
                    });
                };

                /** valid location check */
                $scope.isValidLocation = function (location) {
                    return location.idRegion
                        && location.idProvince
                        && location.idDistrict
                        // && location.populatedCenter
                        && location.latitude
                        && location.longitude;
                };

                /** coordinates validation */
                $scope.isValidCoordinates = function (location) {
                    return validationUtils.isValidLatitude(location.latitude)
                        && validationUtils.isValidLongitude(location.longitude);
                };

                /** check visibility */
                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadRegions();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadRegions();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });

                /** init */
                if (!$scope.model || !Array.isArray($scope.model)) {
                    $scope.model = [];
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorOds', selectorOds);

    /** @ngInject */
    function selectorOds() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors",
                viewMode: "@viewMode"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorODS/selectorODS.html',
            controller: function ($scope, $element, $attrs, Objective, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.objectives = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Objective.find({filter: {include: ["image"]}}, function (response) {
                        $scope.objectives = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.objectives.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.objectives.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {
                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorVideo', selectorVideo);

    /** @ngInject */
    function selectorVideo() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorVideo/selectorVideo.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = "";
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = "";
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorWomanEmpowerment', selectorWomanEmpowerment);

    /** @ngInject */
    function selectorWomanEmpowerment() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorWomanEmpowerment/selectorWomanEmpowerment.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.toggleSelection = function () {
                    $scope.model = !$scope.model;
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseActions', collapseActions);

    /** @ngInject */
    function collapseActions() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseActions/collapseActions.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseAlliances', collapseAlliances);

    /** @ngInject */
    function collapseAlliances() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseAlliances/collapseAlliances.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseAwards', collapseAwards);

    /** @ngInject */
    function collapseAwards() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseAwards/collapseAwards.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseBeneficiary', collapseBeneficiary);

    /** @ngInject */
    function collapseBeneficiary() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseBeneficiary/collapseBeneficiary.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseCategory', collapseCategory);

    /** @ngInject */
    function collapseCategory() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseCategory/collapseCategory.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

                $scope.groupCategories = function (models) {
                    var result = [];
                    models.forEach(function (model, index) {
                        /** root category */
                        if (!model.idCategory) {
                            var cat = model;
                            cat.childrens = models.filter(function (subCat) {
                                return subCat.idCategory === model.id
                            });
                            result.push(cat);
                        }
                    });
                    return result;
                }

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseCompany', collapseCompany);

    /** @ngInject */
    function collapseCompany() {
        return {
            restrict: 'EA',
            scope: {
                companyName: "<companyName",
                companyEmail: "<companyEmail",
                companyPhone: "<companyPhone",
                companyCharge: "<companyCharge",
                isVisibleCompanyName: "=isVisibleCompanyName",
                isVisibleCompanyEmail: "=isVisibleCompanyEmail",
                isVisibleCompanyPhone: "=isVisibleCompanyPhone",
                isVisibleCompanyCharge: "=isVisibleCompanyCharge",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseCompany/collapseCompany.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseDates', collapseDates);

    /** @ngInject */
    function collapseDates() {
        return {
            restrict: 'EA',
            scope: {
                startDate: "<startDate",
                endDate: "<endDate",
                endDateExecution: "<endDateExecution",
                duration: "<duration",
                isVisibleStartDate: "=isVisibleStartDate",
                isVisibleEndDate: "=isVisibleEndDate",
                isVisibleDuration: "=isVisibleDuration",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseDates/collapseDates.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseDiffusions', collapseDiffusions);

    /** @ngInject */
    function collapseDiffusions() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseDiffusions/collapseDiffusions.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseFinancing', collapseFinancing);

    /** @ngInject */
    function collapseFinancing() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseFinancing/collapseFinancing.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseGoals', collapseGoals);

    /** @ngInject */
    function collapseGoals() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseGoals/collapseGoals.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseHistory', collapseHistory);

    /** @ngInject */
    function collapseHistory() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseHistory/collapseHistory.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseLinks', collapseLinks);

    /** @ngInject */
    function collapseLinks() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseLinks/collapseLinks.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseLocations', collapseLocations);

    /** @ngInject */
    function collapseLocations() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseLocations/collapseLocations.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseMonitoring', collapseMonitoring);

    /** @ngInject */
    function collapseMonitoring() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseMonitoring/collapseMonitoring.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseReferred', collapseReferred);

    /** @ngInject */
    function collapseReferred() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseReferred/collapseReferred.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseSummary', collapseSummary);

    /** @ngInject */
    function collapseSummary() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed"
            },
            templateUrl: 'app/resources/directives/projects/collapseSummary/collapseSummary.html',
            controller: function ($scope, $element, $attrs) {

                $scope.toggleCollapsed = function () {
                    $scope.isCollapsed = !$scope.isCollapsed;
                };

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('collapseUpdates', collapseUpdates);

    /** @ngInject */
    function collapseUpdates() {
        return {
            restrict: 'EA',
            scope: {
                model: "<ngModel",
                isCollapsed: "=isCollapsed",
                uniqueOpened: "=uniqueOpened"
            },
            templateUrl: 'app/resources/directives/projects/collapseUpdates/collapseUpdates.html',
            controller: function ($scope, $element, $attrs) {
                $scope.itemCollapsed = {};

                $scope.toggleCollapsed = function (key) {
                    $scope.itemCollapsed[key] = !$scope.itemCollapsed[key];
                    if ($scope.uniqueOpened) {
                        Object.keys($scope.itemCollapsed).forEach(function (itemKey, index) {
                            if ($scope.itemCollapsed.hasOwnProperty(itemKey) && parseInt(itemKey) !== parseInt(key)) {
                                $scope.itemCollapsed[itemKey] = true;
                            }
                        });
                    }
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    if (newValue && Array.isArray(newValue)) {
                        newValue.forEach(function (item, index) {
                            $scope.itemCollapsed[index] = !!$scope.isCollapsed;
                        });
                    }
                }, true);

                var unregisterWatch2 = $scope.$watch('isCollapsed', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (newValue === true) {
                            if ($scope.uniqueOpened) {
                                Object.keys($scope.itemCollapsed).forEach(function (key, index) {
                                    if ($scope.itemCollapsed.hasOwnProperty(key)) {
                                        $scope.itemCollapsed[key] = true;
                                    }
                                });
                            }
                        }
                    }
                }, true);

                var unregisterWatch3 = $scope.$watch('itemCollapsed', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        var keyOpened = Object.keys(newValue).find(function (key, index) {
                            return newValue.hasOwnProperty(key) && newValue[key] !== oldValue[key] && newValue[key] === false;
                        });

                        $scope.isCollapsed = !(keyOpened !== undefined && keyOpened >= 0);

                    }
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterWatch2();
                    unregisterWatch3();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('imagesSlide', imagesSlide);

    /** @ngInject */
    function imagesSlide() {
        return {
            restrict: 'EA',
            scope: {
                project: "=project",
                height: "=height",
            },
            templateUrl: 'app/resources/directives/projects/imagesSlide/imagesSlide.html',
            controller: function ($scope, $element, $attrs, Image, $timeout) {

                $scope.interval = 5000;
                $scope.noWrapSlides = false;
                $scope.active = 0;

                $scope.setActive = function (index) {
                    $timeout(function () {
                        if ($scope.active !== index) {
                            $scope.active = index;
                            console.log(index);
                        }
                    });
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('projectCard', projectCard);

    /** @ngInject */
    function projectCard() {
        return {
            restrict: 'EA',
            scope: {
                classes: "=classes",
                project: "=project",
                imageHeight: "=imageHeight",
                highlight: "=highlight",
                urlView: "@urlView"
            },
            templateUrl: 'app/resources/directives/projects/projectCard/projectCard.html',
            controller: function ($scope, $element, $attrs) {

                $scope.showTag = false;

                var unregisterWatch = $scope.$watch('project', function (newValue, oldValue) {

                    if ($scope.project.updates && $scope.project.updates.length > 0) {
                        var lastUpdate = $scope.project.updates[0];
                        var diffInDays = moment().diff(moment(lastUpdate.date), 'days');

                        $scope.showTag = diffInDays >= 0 && diffInDays <= 21;

                    } else {
                        $scope.showTag = false;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('projectCompanyCard', projectCompanyCard);

    /** @ngInject */
    function projectCompanyCard() {
        return {
            restrict: 'EA',
            scope: {
                company: "<company"
            },
            templateUrl: 'app/resources/directives/projects/projectCompanyCard/projectCompanyCard.html',
            controller: function ($scope, $element, $attrs) {

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('projectSharedLinks', projectSharedLinks);

    /** @ngInject */
    function projectSharedLinks($state) {
        return {
            restrict: 'E',
            templateUrl: 'app/resources/directives/projects/projectSharedLinks/projectSharedLinks.html',
            scope: {
                project: '=project'
            },
            controller: function ($scope, $element, $attrs, socialType, sharedLink) {

                $scope.social = [];

                var unregisterWatch = $scope.$watch('project', function (newValue, oldValue) {
                    if (newValue !== oldValue) {

                        var social = [];
                        Object.keys(socialType).forEach(function (key) {
                            if (socialType.hasOwnProperty(key)) {
                                var url = $state.href('main.project.find_by_slug', {
                                    slug: $scope.project.slug
                                }, {absolute: true});

                                social.push({
                                    id: socialType[key],
                                    url: sharedLink[socialType[key]](url)
                                });
                            }
                        });

                        $scope.social = social;
                    }
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('slickImageSlide', slickImageSlide);

    /** @ngInject */
    function slickImageSlide() {
        return {
            restrict: 'EA',
            scope: {
                project: "=project",
                height: "=height",
                previewHeight: "=previewHeight",
            },
            templateUrl: 'app/resources/directives/projects/slickImageSlide/slickImageSlide.html',
            controller: function ($scope, $element, $attrs, Image, $timeout) {

                $scope.interval = 5000;
                $scope.noWrapSlides = false;
                $scope.active = 0;

                $scope.setActive = function (index) {
                    $timeout(function () {
                        if ($scope.active !== index) {
                            $scope.active = index;
                            console.log(index);
                        }
                    });
                }
            }
        };
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('ProjectDirectory').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/article/list.html','<div class="container m-t-20 m-b-20" ng-init="init(\'filter_by_company\')"><div class="article-section-header clearfix p-t-0"><div class="col-md-7 col-xs-12 article-name p-t-15" ng-if="sectionName">{{sectionName}}</div><div class="col-md-5 col-xs-12 no-padding p-t-15"></div></div><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters fixed-filters="fixedFilters" sectors="sectors" companies="companies" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10">{{finishedLoadingArticles ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="article" dir-paginate="article in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><article-card article="article" image-height="\'140\'" url-view="{{getArticleHref(article.slug)}}"></article-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div>');
$templateCache.put('app/pages/article/show.html','<div class="container m-t-20 m-b-20" ng-if="article"><div class="article-section-header clearfix p-t-0"><div class="col-md-7 col-xs-12 article-name p-t-15" ng-if="sectionName">{{sectionName}}</div><div class="col-md-5 col-xs-12 no-padding p-t-15"><div class="col-md-6 col-xs-6 article-shared"><div class="m-b-5 m-r-5 text-right text-uppercase">Compartir</div><div class="pull-right"><article-shared-links article="article"></article-shared-links></div></div><div class="col-md-6 col-xs-6"><div class="article-update" ng-if="article.publicUpdatedAt">Actualizado: {{article.publicUpdatedAt | date : \'dd.MM.yyyy\'}}</div></div></div></div><div class="col-md-12 d-md-flex no-padding"><div class="col-xs-12 col-md-5 col-sm-12"><article-slick-image-slide article="article" height="380" preview-height="100" min-items-to-show-navigation="2"></article-slick-image-slide></div><div class="col-xs-12 col-md-7 col-sm-12 p-15"><div class="article-content-header"><div class="company-name" ng-if="article.company">{{article.company.name}}</div><div class="article-name">{{article.title}}</div><div class="article-location">{{article.location}}</div></div><div class="article-content" ta-bind="" ng-model="article.content" style-for-all-child="{\'font-size\': \'14px\', \'line-height\': \'19.2px\'}"></div><div ng-if="article.links && article.links.length" class="m-t-20"><div>Enlaces</div><ul class="list-unstyled"><li ng-repeat="item in article.links" class="p-t-5">- <a href="{{item.url}}" target="_blank">{{item.title}}</a></li></ul></div></div></div></div>');
$templateCache.put('app/pages/associated/associated.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading"><div id="header-container"><top-bar></top-bar><slide-top></slide-top><menu-top type="associated"></menu-top></div><div class="page-main"><div class="container" autoscroll="true" autoscroll-body-top="" calculate-min-height=""><div class="row"><div class="col-md-8" ui-view=""></div><div class="col-md-4"><company-info company="userLogged.company"></company-info></div></div></div></div><footer class="page-footer clearfix" id="footer-container"><div class="footer-copyright-container"><div class="container"><span class="copyright">&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa. Todos los derechos reservados.</span></div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/home/home.html','<intro-message ng-model="currentConfig.message"></intro-message><div class="container"><div class="col-md-2 col-xs-12 col-sm-12 visible-xs" ng-if="hasPublicity" style="padding: 20px 60px 0 60px;"><publicity-banner></publicity-banner></div></div><div class="container m-t-20 m-b-20"><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters sectors="sectors" regions="regions" provinces="provinces" districts="districts" categories="categories" companies="companies" objectives="objectives" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10" ng-if="hasAppliedFilters()">{{finishedLoadingProjects ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="project" dir-paginate="project in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><project-card project="project" image-height="\'140\'" url-view="{{getProjectHref(project.slug)}}"></project-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2 col-xs-12 col-sm-12 hidden-xs" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div><div class="container m-t-20"><div class="col-md-12"><section-header title="\'Ubicaci\xF3n Geogr\xE1fica de los Proyectos Sociales\'"></section-header></div><div class="col-md-12 m-b-4x"><div class="col-md-2 map-filter-container" ng-if="finishedLoadingResources"><advanced-filters sectors="sectors" regions="regions" provinces="provinces" districts="districts" categories="categories" applied-filters="{}" apply="applyMapFilter(newPageNumber, newPageFilters)"></advanced-filters></div><gmap-projects projects="mapResults" class="col-md-12 no-padding"></gmap-projects></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading"><div id="header-container"><top-bar></top-bar><slide-top></slide-top><menu-top type="main"></menu-top></div><div class="page-main" calculate-min-height=""><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div><footer class="page-footer clearfix" id="footer-container"><div class="footer-projects clearfix"><div class="container"><div class="row"><div class="col-xs-12 col-md-6"><section-header title="\'Nuevos proyectos\'"></section-header><last-projects></last-projects></div><div class="col-xs-12 col-md-6"><section-header title="\'Suscr\xEDbase\'" description="\'\'"></section-header><subscription-form></subscription-form></div></div></div></div><div class="footer-menu clearfix"><div class="container"><div class="row column-container"><div class="vcenter column"><a href="http://www.snmpe.org.pe" target="_blank"><img ng-src="{{logoSNMPE}}" alt="" class="logo-snmpe"></a><div class="visible-xs p-15">&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa. Todos los derechos reservados.</div></div><div class="vcenter column"><ul><li><a ui-sref="main.about-us">Qui\xE9nes somos</a></li><li><a ui-sref="main.terms">T\xE9rminos y condiciones de privacidad</a></li><li><a ui-sref="main.objectives">Objetivos del desarrollo sostenible</a></li><li><a ui-sref="main.contact">Contacto</a></li></ul></div></div></div></div><div class="footer-copyright-container hidden-xs"><div class="container"><span class="copyright">&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa. Todos los derechos reservados.</span></div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/project/project_category.html','<div class="container"><div class="col-md-2 col-xs-12 col-sm-12 visible-xs" ng-if="hasPublicity" style="padding: 20px 60px 0 60px;"><publicity-banner></publicity-banner></div></div><div class="container m-t-20 m-b-20" ng-init="init(\'filter_by_category\')"><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters fixed-filters="fixedFilters" sectors="sectors" regions="regions" provinces="provinces" districts="districts" companies="companies" objectives="objectives" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10" ng-if="category"><div class="text-uppercase">{{category.name}}</div></div><div class="col-md-12 p-10">{{finishedLoadingProjects ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="project" dir-paginate="project in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><project-card project="project" image-height="\'140\'" url-view="{{getProjectHref(project.slug)}}"></project-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2 col-xs-12 col-sm-12 hidden-xs" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div>');
$templateCache.put('app/pages/project/project_company.html','<div class="container"><div class="col-md-2 col-xs-12 col-sm-12 visible-xs" ng-if="hasPublicity" style="padding: 20px 60px 0 60px;"><publicity-banner></publicity-banner></div></div><div class="container m-t-20 m-b-20" ng-init="init(\'filter_by_company\')"><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters fixed-filters="fixedFilters" sectors="sectors" regions="regions" provinces="provinces" districts="districts" categories="categories" objectives="objectives" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10" ng-if="company"><div class="text-uppercase">{{company.publicName}}</div><div class="m-t-20"><div ng-bind-html="company.description"></div></div><div class="clearfix m-t-20"><div class="col-md-8 no-padding"><div ng-if="company.webSite">SITIO-WEB: <a href="{{company.webSite|formatUrl}}" target="_blank">{{company.webSite}}</a></div></div><div class="col-md-4 no-padding p-t-10"><dark-social-links links="company.social" class="pull-right"></dark-social-links></div></div></div><div class="col-md-12 p-10">{{finishedLoadingProjects ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="project" dir-paginate="project in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><project-card project="project" image-height="\'140\'" url-view="{{getProjectHref(project.slug)}}"></project-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2 col-xs-12 col-sm-12 hidden-xs" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div>');
$templateCache.put('app/pages/project/project_search.html','<div class="container"><div class="col-md-2 col-xs-12 col-sm-12 visible-xs" ng-if="hasPublicity" style="padding: 20px 60px 0 60px;"><publicity-banner></publicity-banner></div></div><div class="container m-t-20 m-b-20" ng-init="init(\'filter_by_search\')"><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters fixed-filters="fixedFilters" regions="regions" provinces="provinces" districts="districts" categories="categories" companies="companies" objectives="objectives" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10"><div class="text-uppercase">Resultados de la b\xFAsqueda</div></div><div class="col-md-12 p-10">{{finishedLoadingProjects ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="project" dir-paginate="project in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><project-card project="project" image-height="\'140\'" highlight="searchText" url-view="{{getProjectHref(project.slug)}}"></project-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2 col-xs-12 col-sm-12 hidden-xs" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div>');
$templateCache.put('app/pages/project/project_sector.html','<div class="container"><div class="col-md-2 col-xs-12 col-sm-12 visible-xs" ng-if="hasPublicity" style="padding: 20px 60px 0 60px;"><publicity-banner></publicity-banner></div></div><div class="container m-t-20 m-b-20" ng-init="init(\'filter_by_sector\')"><div class="col-md-12 d-md-flex"><div class="col-md-2 col-xs-12 no-padding"><div class="list-filter-container" ng-if="finishedLoadingResources"><advanced-filters fixed-filters="fixedFilters" regions="regions" provinces="provinces" districts="districts" categories="categories" companies="companies" objectives="objectives" applied-filters="appliedFilters" apply="applyListFilter(newPageNumber, newPageFilters)"></advanced-filters></div></div><div class="{{hasPublicity ? \'col-md-8\' : \'col-md-10\'}} col-xs-12"><div class="col-md-12 p-10" ng-if="sector"><div class="text-uppercase">{{sector.name}}</div></div><div class="col-md-12 p-10">{{finishedLoadingProjects ? listTotal + \' Resultados encontrados ...\' : \'Cargando ...\'}}</div><filter-tags filters="appliedFilters" show-tooltips="true" class="col-md-12 p-l-10"></filter-tags><div class="col-md-12 no-padding" equalize-height=""><div class="p-10 {{hasPublicity ? \'col-md-4\' : \'col-md-3\'}}" equalize-height-add="project" dir-paginate="project in listResults | itemsPerPage: pageSize" total-items="listTotal" current-page="pagination.current"><project-card project="project" image-height="\'140\'" url-view="{{getProjectHref(project.slug)}}"></project-card></div></div><div class="col-md-12 p-10"><dir-pagination-controls on-page-change="applyListFilter(newPageNumber)" template-url="app/pages/components/pagination/dirPagination.tpl.html"></dir-pagination-controls></div></div><div class="col-md-2 col-xs-12 col-sm-12 hidden-xs" ng-if="hasPublicity" style="padding-top: 46px;"><publicity-banner></publicity-banner></div></div></div>');
$templateCache.put('app/pages/project/project_show.html','<div class="container project-home-container m-t-20 m-b-20" ng-if="project"><div class="project-section-header clearfix p-t-0"><div class="col-md-7 col-xs-12 project-name p-t-15">{{project.nameToPublish}}<div class="project-name-small p-t-5">{{project.name}}</div></div><div class="col-md-5 col-xs-12 no-padding p-t-15"><div class="col-md-6 col-xs-6 project-shared"><div class="m-b-5 m-r-5 text-right text-uppercase">Compartir</div><div class="pull-right"><project-shared-links project="project"></project-shared-links></div></div><div class="col-md-6 col-xs-6"><div class="project-update">Actualizado: {{project.updated_at | date : \'dd.MM.yyyy\'}}</div></div></div></div><div class="col-md-12 d-md-flex no-padding"><div class="col-md-7 col-xs-12 col-sm-12"><slick-image-slide project="project" height="380" preview-height="120"></slick-image-slide><div ng-repeat="video in project.videos track by $index"><embed-video data-ng-href="{{video}}" controls="0" iframe-id="video_{{$index}}" width="100%" height="435"><a ng-href="{{video}}">Watch</a></embed-video></div></div><div class="col-md-5 col-xs-12 col-sm-12 p-15 panel-bordered-light"><project-company-card company="project.company"></project-company-card><hr class="panel-separator" ng-if="project.company"><div ng-if="$projectFieldUtils.isPublicOrOwner(\'objective\', project.company.id)"><div ng-if="project.objective" class="project-item-card"><div class="card-header">Objetivo</div><div style="text-transform: none;">{{project.objective}}</div></div><hr class="panel-separator" ng-if="project.objective"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'summary\', project.company.id)"><div ng-if="project.objectives && project.objectives.length" class="project-item-card"><div class="card-header">Objetivos de Desarrollo sostenible</div><div class="card-content"><img ng-repeat="objective in project.objectives | orderBy : \'order\'" ng-src="{{objective.image.url | imageUrl}}" uib-tooltip="{{objective.name}}" class="m-r-5" width="50" height="50"></div></div><hr class="panel-separator" ng-if="project.objectives"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'summary\', project.company.id)"><div ng-if="project.summary" class="project-item-card"><div class="card-header">Resumen</div><div ng-bind-html="project.summary" style="text-transform: none;"></div></div><hr class="panel-separator" ng-if="project.summary"></div><collapse-updates ng-model="project.updates" is-collapsed="true" unique-opened="false"></collapse-updates><div ng-if="$projectFieldUtils.isPublicOrOwner(\'locations\', project.company.id)"><collapse-locations ng-model="project.locations" is-collapsed="true"></collapse-locations><hr class="panel-separator" ng-if="project.locations && project.locations.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'categories\', project.company.id)"><collapse-category ng-model="project.categories" is-collapsed="true"></collapse-category><hr class="panel-separator" ng-if="project.categories && project.categories.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'startDate\', project.company.id) || $projectFieldUtils.isPublicOrOwner(\'endDate\', project.company.id) || $projectFieldUtils.isPublicOrOwner(\'duration\', project.company.id)"><collapse-dates start-date="project.startDate" end-date="project.endDate" end-date-execution="project.endDateExecution" duration="project.duration" is-visible-start-date="$projectFieldUtils.isPublicOrOwner(\'startDate\', project.company.id)" is-visible-end-date="$projectFieldUtils.isPublicOrOwner(\'endDate\', project.company.id)" is-visible-duration="$projectFieldUtils.isPublicOrOwner(\'duration\', project.company.id)" is-collapsed="true"></collapse-dates><hr class="panel-separator" ng-if="project.startDate || project.endDate || project.duration || project.endDateExecution"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'actions\', project.company.id)"><collapse-actions ng-model="project.actions" is-collapsed="true"></collapse-actions><hr class="panel-separator" ng-if="project.actions && project.actions.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'goals\', project.company.id)"><collapse-goals ng-model="project.goals" is-collapsed="true"></collapse-goals><hr class="panel-separator" ng-if="project.goals && project.goals.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'monitoring\', project.company.id)"><collapse-monitoring ng-model="project.monitoring" is-collapsed="true"></collapse-monitoring><hr class="panel-separator" ng-if="project.monitoring && project.monitoring.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'alliances\', project.company.id)"><collapse-alliances ng-model="project.alliances" is-collapsed="true"></collapse-alliances><hr class="panel-separator" ng-if="project.alliances && project.alliances.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'financing\', project.company.id)"><collapse-financing ng-model="project.financings" is-collapsed="true"></collapse-financing><hr class="panel-separator" ng-if="project.financings && project.financings.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'history\', project.company.id)"><collapse-history ng-model="project.history" is-collapsed="true"></collapse-history><hr class="panel-separator" ng-if="project.history"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'beneficiaries\', project.company.id)"><collapse-beneficiary ng-model="project.beneficiaries" is-collapsed="true"></collapse-beneficiary><hr class="panel-separator" ng-if="project.beneficiaries && project.beneficiaries.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'awards\', project.company.id)"><collapse-awards ng-model="project.awards" is-collapsed="true"></collapse-awards><hr class="panel-separator" ng-if="project.awards && project.awards.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'links\', project.company.id)"><collapse-links ng-model="project.links" is-collapsed="true"></collapse-links><hr class="panel-separator" ng-if="project.links && project.links.length"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'referred\', project.company.id)"><collapse-referred ng-model="project.referred" is-collapsed="true"></collapse-referred><hr class="panel-separator" ng-if="project.referred"></div><div ng-if="$projectFieldUtils.isPublicOrOwner(\'companyName\', project.company.id) || $projectFieldUtils.isPublicOrOwner(\'companyEmail\', project.company.id) || $projectFieldUtils.isPublicOrOwner(\'companyPhone\', project.company.id) || $projectFieldUtils.isPublicOrOwner(\'companyCharge\', project.company.id)"><collapse-company company-name="project.companyName" company-email="project.companyEmail" company-phone="project.companyPhone" company-charge="project.companyCharge" is-visible-company-name="$projectFieldUtils.isPublicOrOwner(\'companyName\', project.company.id)" is-visible-company-email="$projectFieldUtils.isPublicOrOwner(\'companyEmail\', project.company.id)" is-visible-company-phone="$projectFieldUtils.isPublicOrOwner(\'companyPhone\', project.company.id)" is-visible-company-charge="$projectFieldUtils.isPublicOrOwner(\'companyCharge\', project.company.id)" is-collapsed="true"></collapse-company><hr class="panel-separator" ng-if="project.companyName || project.companyEmail || project.companyPhone || project.companyCharge"></div></div></div></div>');
$templateCache.put('app/pages/static/about-us.html','<div class="container"><div class="row" ng-init="init(\'about-us\')"><div class="panel clearfix" ng-if="page"><div class="col-md-12"><section-header title="\'Qui\xE9nes somos\'"></section-header></div><div class="col-md-12 panel-content"><div ng-bind-html="page.content" style-for-all-child="{\'font-size\': \'14px\', \'line-height\': \'19.2px\'}"></div></div></div></div></div>');
$templateCache.put('app/pages/static/contact.html','<div class="container"><div class="row" ng-init="init(\'contact\')"><div class="panel clearfix" ng-if="page"><div class="col-md-12"><section-header title="\'Contacto\'"></section-header></div><div class="col-md-12 panel-content"><div class="col-md-4 contact-form"><div class="contact-info">Si usted desea comunicarse con nosotros o tiene alguna consulta o duda, complete el siguiente formulario:</div><form name="contactForm" id="contactForm" angular-validator-submit="sendContactForm(contactForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><input type="text" name="name" id="name" class="form-control" placeholder="Nombre y Apellidos (*)" ng-model="contact.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div><div class="form-group"><input type="text" name="email" id="email" class="form-control" placeholder="Correo Electr\xF3nico (*)" ng-model="contact.email" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div><div class="form-group"><input type="text" name="subject" id="subject" class="form-control" placeholder="Asunto (*)" ng-model="contact.subject" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div><div class="form-group"><textarea name="message" id="message" class="form-control" placeholder="Mensaje" ng-model="contact.message" validate-on="blur">\n                        </textarea></div><div vc-recaptcha="" key="reCaptchaKey" lang="es" size="normal" on-create="onWidgetCreate(widgetId)" ng-model="contact.reCaptchaResponse"></div><br><div class="form-group"><button background-color="{{$currentEdition.color1}}" type="submit" class="btn btn-primary">Enviar</button></div></form></div><div class="col-md-8"><div class="col-md-12 no-padding contact-location"><div class="contact-location-title">Ub\xEDquenos</div><div class="contact-location-map"><iframe ng-src="{{trustSrc(page.properties.urlMap)}}" width="100%" height="350px" frameborder="0" style="border:0" allowfullscreen=""></iframe></div></div><div class="col-md-12 no-padding m-t-10" ng-bind-html="page.content"></div></div></div></div></div></div>');
$templateCache.put('app/pages/static/objectives.html','<div class="container"><div class="row" ng-init="init(\'ods\')"><div class="panel clearfix" ng-if="page"><div class="col-md-12"><section-header title="\'Objetivos del desarrollo sostenible\'"></section-header></div><div class="col-md-12 panel-content"><div ng-bind-html="page.content" style-for-all-child="{\'font-size\': \'14px\', \'line-height\': \'19.2px\'}"></div></div></div></div></div>');
$templateCache.put('app/pages/static/schedule.html','<editorial></editorial><div class="row"><div class="page-breadcrumb"><ul><li><a ui-sref="main.home" hover-color="{{$currentEdition.color1}}">{{$stateUtil.getStateTitle(\'main.home\')}}</a></li><li><a href="javascript:;" font-color="{{$currentEdition.color1}}">{{$stateUtil.getStateTitle(\'main.schedule\')}}</a></li></ul></div></div><div class="row" ng-init="init(\'schedule\')"><div class="panel clearfix panel-about-us" ng-if="page"><div class="col-md-12 panel-header"><span class="panel-title" font-color="{{$currentEdition.color1}}" border-color="{{$currentEdition.color1}}">{{page.title}}</span></div><div class="col-md-12 panel-content"><div ng-bind-html="page.content" style-for-all-child="{\'font-size\': \'16px\', \'line-height\': \'19.2px\'}"></div></div></div></div>');
$templateCache.put('app/pages/static/terms.html','<div class="container"><div class="row" ng-init="init(\'terms\')"><div class="panel clearfix" ng-if="page"><div class="col-md-12"><section-header title="\'T\xE9rminos y condiciones\'"></section-header></div><div class="col-md-12 panel-content"><div ng-bind-html="page.content" style-for-all-child="{\'font-size\': \'14px\', \'line-height\': \'19.2px\'}"></div></div></div></div></div>');
$templateCache.put('app/pages/subscription/confirm.html','<div class="container m-t-20 m-b-20" ng-init="init(\'confirm\')"><div class="col-md-12 d-md-flex"><div class="col-md-12"><div class="col-md-12 p-10"><div class="text-uppercase">Confirmaci\xF3n de Suscripci\xF3n</div></div><div class="col-md-12 p-10">{{statusMessage}}</div><div class="col-md-12 p-10"><a ui-sref="main.home" class="btn btn-xs btn-primary"><i class="fa fa-home"></i> Ir al inicio</a></div></div></div></div>');
$templateCache.put('app/resources/components/taUploadImage/taFilesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de Art\xEDculos</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFiles($file, $invalidFiles)" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre la imagen aqu\xED o haga click para subir una.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setImage(row.name)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/resources/directives/advancedFilters/advancedFilters.html','<div class="project-filter-container" ng-if="sectors || regions || provinces || districts || categories || companies || objectives"><form action=""><div class="header-title">B\xFAsqueda Avanzada</div><button type="button" class="btn btn-block m-b-10" ng-show="showToggleCollapsed" ng-click="isFiltersCollapsed = !isFiltersCollapsed">{{ isFiltersCollapsed ? \'Seleccione\' : \'Ocultar Filtros\' }}</button><div uib-collapse="isFiltersCollapsed"><multiselect ng-model="filters.sectors" options="sectors" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="sectorLabels" show-select-all="false" show-unselect-all="true" ng-if="sectors && sectors.length"></multiselect><multiselect ng-model="filters.regions" options="regions" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="regionLabels" show-select-all="false" show-unselect-all="true" ng-if="regions && regions.length"></multiselect><multiselect ng-model="filters.provinces" options="filteredProvinces" show-tooltip="false" show-search="true" search-limit="1000" id-prop="id" display-prop="name" labels="provinceLabels" show-select-all="false" show-unselect-all="true" ng-if="filteredProvinces && filteredProvinces.length"></multiselect><multiselect ng-model="filters.districts" options="filteredDistricts" show-tooltip="false" show-search="true" search-limit="1000" id-prop="id" display-prop="name" labels="districtLabels" show-select-all="false" show-unselect-all="true" ng-if="filteredDistricts && filteredDistricts.length"></multiselect><multiselect ng-model="filters.categories" options="categories" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="categoryLabels" show-select-all="false" show-unselect-all="true" ng-if="categories && categories.length"></multiselect><multiselect ng-model="filters.companies" options="companies" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="companyLabels" show-select-all="false" show-unselect-all="true" ng-if="companies && companies.length"></multiselect><multiselect ng-model="filters.objectives" options="objectives" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="objectiveLabels" show-select-all="false" show-unselect-all="true" ng-if="objectives && objectives.length"></multiselect></div><button type="button" class="btn btn-block" ng-click="resetFilters()" ng-if="showReset">Limpiar Filtros</button> <button type="button" class="btn btn-primary btn-sm btn-block" ng-click="applyFilters()">Filtrar</button></form></div>');
$templateCache.put('app/resources/directives/advancedFilters/filterTags.html','<div ng-show="filters.sectors || filters.regions || filters.provinces || filters.companies || filters.categories || filters.objectives" class="clearfix"><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.sectors" ng-init="key=\'sectors\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.regions" ng-init="key=\'regions\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.provinces" ng-init="key=\'provinces\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.districts" ng-init="key=\'districts\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.categories" ng-init="key=\'categories\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.companies" ng-init="key=\'companies\'"></div><div ng-include="\'tagFilterItem.tpl.html\'" ng-repeat="item in filters.objectives" ng-init="key=\'objectives\'"></div></div><script type="text/ng-template" id="tagFilterItem.tpl.html"><div class="filter-tag pointer"> {{item.name | cut: \'\' : 25}} <button type="button" class="close" aria-label="Close" ng-click="removeFilter(key, $index)"> <span aria-hidden="true">&times;</span> </button> </div></script>');
$templateCache.put('app/resources/directives/charCounter/charCounter.html','<div class="text-right"><span class="label label-info">{{model.length || 0}} / {{limit}}</span></div>');
$templateCache.put('app/resources/directives/companyInfo/companyInfo.html','<div class="associated-company-info-container" ng-if="company"><div class="title">Empresa Asociada</div><div class="clearfix"><div class="col-md-2 col-xs-3 col-sm-2 no-padding" ng-if="company.sector && company.sector.imageLogo"><img ng-src="{{company.sector.imageLogo.url | imageUrl}}" alt="" class="sector-logo"></div><div class="company-name col-md-10 col-xs-9 col-sm-10 p-10">{{company.publicName}}</div></div><button class="btn btn-primary btn-block m-t-10" ui-sref="main.project.project_company({idCompany: company.id})">Ver Proyectos</button><hr><div class="title">Perfil</div><div ng-if="company.description" ng-bind-html="company.description"></div><div class="m-t-10"><div ng-if="company.webSite"><b class="fa fa-circle-o fa-2x"></b><span class="p-10">{{company.webSite}}</span></div></div><div class="m-t-20 clearfix"><dark-social-links links="company.social"></dark-social-links></div></div>');
$templateCache.put('app/resources/directives/darkSocialLinks/darkSocialLinks.html','<ul class="dark-social-link clearfix" ng-if="links && links.length"><li ng-repeat="social in links"><a href="{{social.url|formatUrl}}" target="_blank"><i class="socicon socicon-{{social.id}}"></i></a></li></ul>');
$templateCache.put('app/resources/directives/gmapProjects/gmapProjects.html','<div class="gmap-container" id="map"><ui-gmap-google-map center="map.center" zoom="map.zoom" draggable="true" options="options" control="mapControl" events="events"><ui-gmap-markers models="markers" fit="\'true\'" coords="\'self\'" icon="\'icon\'" options="\'options\'" click="onClick"></ui-gmap-markers><ui-gmap-window coords="activeModel" options="windowOptions" show="activeModel.show" closeclick="closeClick"><div><div class="header-info"><img ng-src="{{activeModel.imageUrl}}"> <span class="pointer" ui-sref="main.project.find_by_slug({slug: \'{{activeModel.slug}}\'})">{{activeModel.title}}</span></div><div class="description">{{activeModel.description}}</div></div></ui-gmap-window></ui-gmap-google-map></div>');
$templateCache.put('app/resources/directives/introMessage/introMessage.html','<div class="container m-t-20 visible-xs" ng-if="message"><div class="col-xs-12 text-center" ng-bind-html="message"></div></div>');
$templateCache.put('app/resources/directives/lastProjects/lastProjects.html','<div class="last-projects-container p-t-15"><div class="col-md-6 col-xs-12 col-sm-12 project-footer-card clearfix" ng-repeat="project in results"><div class="col-md-3 col-xs-4 col-sm-3 no-padding"><div background-image="{{project.avatar.url | imageUrl}}" background-image-height="60" class="project-image"></div></div><div class="col-md-9 col-xs-8 col-sm-9 p-r-0"><span class="first-title" ng-if="project.company">{{project.company.publicName}}</span> <span class="second-title pointer" ui-sref="main.project.find_by_slug({slug: project.slug})">{{project.nameToPublish}}</span></div></div></div>');
$templateCache.put('app/resources/directives/publicityBanner/publicityBanner.html','<div class="slide-publicity-banner-container" ng-if="banners && banners.length"><div uib-carousel="" active="active" interval="interval" no-wrap="noWrapSlides"><div uib-slide="" ng-repeat="banner in banners" index="$index"><div ng-if="banner.url"><a ng-href="{{banner.url}}" target="_blank"><img ng-src="{{banner.imageWeb.url | imageUrl}}" alt="" class="hidden-xs"> <img ng-src="{{banner.imageMobile.url | imageUrl}}" alt="" class="visible-xs"><div class="carousel-caption"><h3 ng-if="banner.title">{{banner.title}}</h3></div></a></div><div ng-if="!banner.url"><img ng-src="{{banner.imageWeb.url | imageUrl}}" alt="" class="hidden-xs"> <img ng-src="{{banner.imageMobile.url | imageUrl}}" alt="" class="visible-xs"><div class="carousel-caption"><h3 ng-if="banner.title">{{banner.title}}</h3></div></div></div></div></div>');
$templateCache.put('app/resources/directives/recommendedSizes/recommendedSizes.html','<div>Dimensiones recomendadas. {{width}}{{unit}} de ancho por {{height}}{{unit}} de alto</div>');
$templateCache.put('app/resources/directives/sectionHeader/sectionHeader.html','<div class="section-header"><div class="section-title" ng-if="title">{{title}}</div><div class="section-description" ng-if="description">{{description}}</div></div>');
$templateCache.put('app/resources/directives/slideTop/slideTop.html','<div class="image-slide-top-container" ng-if="slides && slides.length"><div class="container"><div ng-style="{height : imageHeight}"><div uib-carousel="" active="active" interval="interval" no-wrap="noWrapSlides"><div uib-slide="" ng-repeat="slide in slides" index="$index"><div class="slide-image hidden-xs" ng-click="goto(slide.url)" ng-class="{pointer: slide.url}" background-image="{{slide.imageWeb.url | imageUrl}}" background-image-height="{{imageHeight}}"></div><div class="slide-image visible-xs" ng-click="goto(slide.url)" ng-class="{pointer: slide.url}" background-image="{{slide.imageMobile.url | imageUrl}}" background-image-height="{{imageHeight}}"></div><div class="carousel-caption unselectable" ng-click="goto(slide.url)" ng-class="{pointer: slide.url}" ng-if="slide.title"><h3>{{slide.title}}</h3></div></div></div></div></div></div>');
$templateCache.put('app/resources/directives/subscriptionForm/subscriptionForm.html','<div class="subscription-form-container p-t-15"><form class="subscription-form" name="subscriptionForm" angular-validator-submit="create(subscriptionForm.$valid)" novalidate="" angular-validator=""><div class="col-md-12"><div class="col-md-8 no-padding"><div class="form-group col-md-6 no-padding p-r-5"><input type="email" name="email" id="email" class="form-control upper-placeholder" placeholder="Correo electr\xF3nico" ng-model="subscription.email" validate-on="blur" validator="validateEmail(subscription.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></div><div class="form-group col-md-6 no-padding p-r-5"><input type="text" name="name" id="name" class="form-control upper-placeholder" placeholder="Nombre" ng-model="subscription.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div><div class="p-r-5"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="terms" ng-model="subscription.terms"> <span>Si, acepto los <a ui-sref="main.terms">t\xE9rminos y condiciones</a></span></label></div></div><div class="col-md-4 no-padding p-r-5"><button type="submit" class="btn btn-xs btn-primary">Suscribirme</button></div></div></form></div>');
$templateCache.put('app/pages/associated/home/associated_home.html','<div class="panel panel-bordered"><div class="col-md-12"><section-header title="\'Bienvenido \' + ((userLogged.company ? userLogged.company.publicName : \'\') | uppercase)" description="\'Seleccione una opci\xF3n\'"></section-header></div><div class="panel-content clearfix"><div class="col-md-3"><a ui-sref="associated.profile" class="user-menu-item"><img src="{{profileIcon}}"> <span>Perfil</span></a></div><div class="col-md-3"><a ui-sref="associated.project.list" class="user-menu-item"><img src="{{newProjectIcon}}"> <span>Proyectos</span></a></div><div class="col-md-3"><a ui-sref="associated.project.create" class="user-menu-item"><img src="{{projectListIcon}}"> <span>Nuevo proyecto</span></a></div><div class="col-md-3"><a ui-sref="associated.updates.list" class="user-menu-item"><img src="{{updateProjectIcon}}"> <span>Actualizaci\xF3n</span></a></div></div></div>');
$templateCache.put('app/pages/associated/profile/associated_profile.html','<div class="panel panel-bordered"><div class="col-md-12"><section-header title="\'Perfil\'" description="\'Edite los datos de su empresa\'"></section-header></div><div class="panel-content" style="position:relative;"><form name="profileForm" class="form-horizontal" angular-validator-submit="createOrUpdate(profileForm.$valid)" angular-validator="" novalidate=""><div class="row"><div class="col-md-12"><div class="col-xs-12 col-sm-12 col-md-6 p-5"><input type="text" name="name" id="name" class="form-control upper-placeholder" placeholder="Nombre de la empresa" ng-model="company.name" ng-required="company.type !== \'remote\'" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-6 p-5"><input type="text" name="publicName" id="publicName" class="form-control upper-placeholder" placeholder="Nombre p\xFAblico de la empresa" ng-model="company.publicName" ng-required="company.type !== \'remote\'" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-12 p-5"><input type="email" name="email" id="email" class="form-control upper-placeholder" placeholder="Correo electr\xF3nico" ng-model="company.email" validate-on="blur" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" ng-required="company.type !== \'remote\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-12 p-5"><input type="email" name="email2" id="email2" class="form-control upper-placeholder" placeholder="Correo electr\xF3nico 2" ng-model="company.email2" validate-on="blur" invalid-message="\'El campo es incorrecto.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-12 p-5"><input type="email" name="email3" id="email3" class="form-control upper-placeholder" placeholder="Correo electr\xF3nico 3" ng-model="company.email3" validate-on="blur" invalid-message="\'El campo es incorrecto.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-12 p-5"><input type="email" name="email4" id="email4" class="form-control upper-placeholder" placeholder="Correo electr\xF3nico 4" ng-model="company.email4" validate-on="blur" invalid-message="\'El campo es incorrecto.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-xs-12 col-sm-12 col-md-12 p-5"><input type="text" name="web" id="web" class="form-control upper-placeholder" placeholder="Url - Sitio Web" ng-model="company.webSite" ng-required="company.type !== \'remote\'" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'"></div><div class="col-md-12 p-5"><div class="btn-group" uib-dropdown=""><button id="single-button" type="button" class="btn" uib-dropdown-toggle="">Adicionar Enlace <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat="item in socialNetworks"><a href="javascript:;" ng-click="addSocial(item.id)"><i class="fa fa-fw {{item.icon}}"></i> {{item.name}}</a></li></ul></div></div><div class="col-md-12 col-xs-12 col-sm-12 p-5" ng-repeat="social in company.social"><div class="col-md-11 col-sm-11 col-xs-10 no-padding"><input type="text" name="social_{{social.id}}" id="social_{{social.id}}" class="form-control upper-placeholder" placeholder="{{social.id}}" uib-tooltip="{{social.id}}" ng-model="social.url"></div><div class="col-md-1 col-sm-1 col-xs-2"><button type="button" class="btn" ng-click="removeSocial($index)"><i class="fa fa-trash"></i></button></div></div></div><div class="col-md-12 col-xs-12 col-sm-12 m-t-20" style="position: absolute; bottom: 0;"><button type="submit" class="btn btn-primary">Guardar</button></div></div></form><div class="row" style="margin-bottom: 30px;"><div class="col-md-12"><div class="col-md-12 col-xs-12 col-sm-12 no-padding m-t-10" text-angular="" id="description" ng-model="company.description" name="ta-company-description" placeholder="PERFIL O DESCRIPCI\xD3N DE LA EMPRESA" ta-maxlength="500" ta-max-text="500" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right"><span class="label label-info">{{getCharCount(\'ta-company-description\') || 0}} / 500</span></div></div></div></div></div>');
$templateCache.put('app/pages/associated/project/associated_project.html','<div class="panel panel-bordered" ng-init="init(\'list\')"><div class="col-md-12"><section-header title="\'Proyectos\'" description="\'Ingrese el nombre del proyecto para editar\'"></section-header></div><div class="panel-content clearfix"><div class="col-md-12"><div class="search-input-group"><input class="search-input upper-placeholder" type="text" ng-model="search" placeholder="Nombre del Proyecto"> <span class="fa fa-search search-icon" ng-click="loadProjects()"></span></div></div><ul class="project-results-container col-md-12 m-t-20"><li ng-repeat="project in projects" class="clearfix"><div class="col-md-6 col-xs-7 col-sm-6 no-padding">{{project.name}}</div><div class="col-md-3 col-xs-1 col-sm-3 no-padding text-center"><span class="fa {{project.publishedVersion ? \'fa-star\' : \'fa-star-o\'}}"></span> <span class="hidden-xs m-l-5">{{project.publishedVersion ? \'Publicado\' : \'Despublicado\'}}</span></div><div class="col-md-3 col-xs-4 col-sm-3 no-padding text-right"><span class="p-l-r-5">[{{getStatusName(project.status)}}]</span> <span class="fa fa-pencil pointer" ng-if="project.status!==\'pending\'" ui-sref="associated.project.edit({id: project.id})"></span></div></li><li ng-if="finishedLoading && !projects.length" class="clearfix">No se encontraron resultados.</li></ul></div></div>');
$templateCache.put('app/pages/associated/project/associated_project_create_or_update.html','<div class="panel panel-bordered"><div class="col-md-12"><div class="col-md-10"><section-header title="\'Nuevo Proyecto\'" description="\'Complete todos los campos del formulario. Los campos sombreados no ser\xE1n publicados.\'"></section-header></div><div class="col-md-2 p-t-20"><strong class="pointer text-uppercase" ng-click="step = (step === 1 ? 2 : 1)">{{step === 1 ? \'Paso 2 >\' : \'< Paso 1\'}}</strong></div></div><div class="panel-content clearfix"><div class="col-md-12 project-management no-padding"><form name="createForm" class="" ng-submit="createOrUpdate(true || createForm.$valid, \'pending\')" novalidate=""><div class="col-md-12 no-padding"><div class="" ng-show="step===1"><div class="clearfix"><div class="col-md-6 no-padding" ng-if="$projectFieldUtils.isVisible(\'name\')"><div class="form-group"><div class="col-md-12"><input type="text" name="name" id="name" placeholder="Nombre del proyecto {{$projectFieldUtils.isRequired(\'name\') ? \'(*)\' : \'\'}}" class="form-control" ng-model="project.name"></div><div class="col-md-12 p-b-10" ng-if="errorDetails[\'name\'] && errorDetails[\'name\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'name\']">{{error}}</div></div></div></div><div class="col-md-6 no-padding" ng-if="$projectFieldUtils.isVisible(\'nameToPublish\')"><div class="form-group"><div class="col-md-12"><input type="text" name="nameToPublish" id="nameToPublish" placeholder="Nombre con el que se publicar\xE1 {{$projectFieldUtils.isRequired(\'nameToPublish\') ? \'(*)\' : \'\'}}" class="form-control" maxlength="70" ng-model="project.nameToPublish"><char-counter ng-model="project.nameToPublish" limit="70"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errorDetails[\'nameToPublish\'] && errorDetails[\'nameToPublish\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'nameToPublish\']">{{error}}</div></div></div></div></div><selector-location visibility="$projectFieldUtils.getVisibility(\'locations\')" is-required="$projectFieldUtils.isRequired(\'locations\')" errors="errorDetails[\'locations\']" ng-model="selectedLocations" class="col-md-12 no-padding"></selector-location><selector-activity columns="2" visibility="$projectFieldUtils.getVisibility(\'activities\')" is-required="$projectFieldUtils.isRequired(\'activities\')" errors="errorDetails[\'activities\']" ng-model="selectedActivities" class="col-md-12 no-padding"></selector-activity><input-objective ng-model="project.objective" visibility="$projectFieldUtils.getVisibility(\'objective\')" is-required="$projectFieldUtils.isRequired(\'objective\')" errors="errorDetails[\'objective\']" class="col-md-12 no-padding" limit="charLimits.objective"></input-objective><selector-information-base columns="2" visibility="$projectFieldUtils.getVisibility(\'informationBases\')" is-required="$projectFieldUtils.isRequired(\'informationBases\')" errors="errorDetails[\'informationBases\']" ng-model="selectedInformationBases" class="col-md-12 no-padding"></selector-information-base><selector-category columns="3" visibility="$projectFieldUtils.getVisibility(\'categories\')" is-required="$projectFieldUtils.isRequired(\'categories\')" errors="errorDetails[\'categories\']" ng-model="selectedCategories" class="col-md-12 no-padding"></selector-category><selector-woman-empowerment ng-model="project.womanEmpowerment" visibility="$projectFieldUtils.getVisibility(\'womanEmpowerment\')" is-required="$projectFieldUtils.isRequired(\'womanEmpowerment\')" errors="errorDetails[\'womanEmpowerment\']" class="col-md-12 no-padding"></selector-woman-empowerment><selector-ods columns="6" view-mode="horizontal" visibility="$projectFieldUtils.getVisibility(\'objectives\')" is-required="$projectFieldUtils.isRequired(\'objectives\')" errors="errorDetails[\'objectives\']" ng-model="project.objectives" class="col-md-12 no-padding"></selector-ods><input-summary ng-model="project.summary" visibility="$projectFieldUtils.getVisibility(\'summary\')" is-required="$projectFieldUtils.isRequired(\'summary\')" errors="errorDetails[\'summary\']" class="col-md-12 no-padding" limit="charLimits.summary"></input-summary><div class="form-group clearfix" ng-if="$projectFieldUtils.isVisibleSomeItem([\'startDate\', \'endDate\', \'duration\'])"><label class="control-label col-md-12"><strong class="text-uppercase">Fechas de Relevancia</strong></label><div class="col-md-12" ng-if="$projectFieldUtils.isVisible(\'startDate\')"><div class="col-md-8 no-padding"><div class="col-md-11 no-padding"><input type="text" name="startDate" id="startDate" placeholder="Inicio (d\xEDa/mes/a\xF1o) {{$projectFieldUtils.isRequired(\'startDate\') ? \'(*)\' : \'\'}}" class="form-control date-picker" date-range-picker="" readonly="readonly" ng-model="startDatePicker.date" options="options"></div><div class="col-md-1 p-l-5"><button type="button" class="btn btn-xs" ng-click="clearStartDate()"><span class="fa fa-times"></span></button></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'startDate\'] && errorDetails[\'startDate\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'startDate\']">{{error}}</div></div></div></div><div class="col-md-12" ng-if="$projectFieldUtils.isVisible(\'endDate\')"><div class="col-md-8 no-padding p-t-10 p-b-5"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-model="project.endDateExecution" ng-change="toggleEndDateExecution(project.endDateExecution)"> <span>Proyecto en Ejecuci\xF3n</span></label></div><div class="col-md-8 no-padding"><div class="col-md-11 no-padding"><input type="text" name="endDate" id="endDate" ng-disabled="project.endDateExecution" placeholder="{{project.endDateExecution ? \'En ejecuci\xF3n\' : \'Fin (d\xEDa/mes/a\xF1o)\'}} {{$projectFieldUtils.isRequired(\'endDate\') ? \'(*)\' : \'\'}}" class="form-control date-picker" date-range-picker="" readonly="readonly" ng-model="endDatePicker.date" options="options"></div><div class="col-md-1 p-l-5"><button type="button" class="btn btn-xs" ng-click="clearEndDate()" ng-disabled="project.endDateExecution"><span class="fa fa-times"></span></button></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'endDate\'] && errorDetails[\'endDate\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'endDate\']">{{error}}</div></div></div></div><div class="col-md-12"><div class="col-md-8 no-padding p-t-10" ng-if="$projectFieldUtils.isVisible(\'duration\')"><div class="col-md-11 no-padding"><input type="text" name="duration" id="duration" placeholder="Periodo de duraci\xF3n {{$projectFieldUtils.isRequired(\'duration\') ? \'(*)\' : \'\'}}" class="form-control" ng-model="project.duration"></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'duration\'] && errorDetails[\'duration\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'duration\']">{{error}}</div></div></div></div></div><input-action ng-model="project.actions" visibility="$projectFieldUtils.getVisibility(\'actions\')" is-required="$projectFieldUtils.isRequired(\'actions\')" errors="errorDetails[\'actions\']" class="col-md-12 no-padding" limit="charLimits.action"></input-action><input-goals ng-model="project.goals" visibility="$projectFieldUtils.getVisibility(\'goals\')" is-required="$projectFieldUtils.isRequired(\'goals\')" errors="errorDetails[\'goals\']" class="col-md-12 no-padding" limit="charLimits.goals"></input-goals></div><div ng-show="step===2"><input-monitoring ng-model="project.monitoring" visibility="$projectFieldUtils.getVisibility(\'monitoring\')" is-required="$projectFieldUtils.isRequired(\'monitoring\')" errors="errorDetails[\'monitoring\']" class="col-md-12 no-padding" limit="charLimits.monitoring"></input-monitoring><input-results ng-model="project.results" visibility="$projectFieldUtils.getVisibility(\'results\')" is-required="$projectFieldUtils.isRequired(\'results\')" errors="errorDetails[\'results\']" class="col-md-12 no-padding" limit="charLimits.results"></input-results><input-impact ng-model="project.impact" visibility="$projectFieldUtils.getVisibility(\'impact\')" is-required="$projectFieldUtils.isRequired(\'impact\')" errors="errorDetails[\'impact\']" class="col-md-12 no-padding" limit="charLimits.impact"></input-impact><selector-alliance columns="1" visibility="$projectFieldUtils.getVisibility(\'alliances\')" is-required="$projectFieldUtils.isRequired(\'alliances\')" errors="errorDetails[\'alliances\']" ng-model="selectedAlliances" class="col-md-12 no-padding"></selector-alliance><selector-financing columns="2" visibility="$projectFieldUtils.getVisibility(\'financing\')" is-required="$projectFieldUtils.isRequired(\'financing\')" errors="errorDetails[\'financing\']" ng-model="selectedFinancings" class="col-md-12 no-padding"></selector-financing><input-history ng-model="project.history" visibility="$projectFieldUtils.getVisibility(\'history\')" is-required="$projectFieldUtils.isRequired(\'history\')" errors="errorDetails[\'history\']" class="col-md-12 no-padding" limit="charLimits.history"></input-history><selector-beneficiary columns="2" visibility="$projectFieldUtils.getVisibility(\'beneficiaries\')" is-required="$projectFieldUtils.isRequired(\'beneficiaries\')" errors="errorDetails[\'beneficiaries\']" ng-model="selectedBeneficiaries" class="col-md-12 no-padding"></selector-beneficiary><selector-diffusion columns="1" visibility="$projectFieldUtils.getVisibility(\'diffusions\')" is-required="$projectFieldUtils.isRequired(\'diffusions\')" errors="errorDetails[\'diffusions\']" ng-model="selectedDiffusions" class="col-md-12 no-padding"></selector-diffusion><input-satisfaction-indicator ng-model="project.satisfactionIndicator" visibility="$projectFieldUtils.getVisibility(\'satisfactionIndicator\')" is-required="$projectFieldUtils.isRequired(\'satisfactionIndicator\')" errors="errorDetails[\'satisfactionIndicator\']" class="col-md-12 no-padding"></input-satisfaction-indicator><selector-image-upload container="\'Projects\'" files="project.images" visibility="$projectFieldUtils.getVisibility(\'images\')" visibility-avatar="$projectFieldUtils.getVisibility(\'idAvatar\')" is-required="$projectFieldUtils.isRequired(\'images\')" is-required-avatar="$projectFieldUtils.isRequired(\'idAvatar\')" id-avatar="project.idAvatar" errors="errorDetails[\'images\']" errors-avatar="errorDetails[\'idAvatar\']" class="col-md-12 no-padding"></selector-image-upload><selector-video ng-model="project.videos" visibility="$projectFieldUtils.getVisibility(\'videos\')" is-required="$projectFieldUtils.isRequired(\'videos\')" errors="errorDetails[\'videos\']" class="col-md-12 no-padding"></selector-video><selector-link ng-model="project.links" visibility="$projectFieldUtils.getVisibility(\'links\')" is-required="$projectFieldUtils.isRequired(\'links\')" errors="errorDetails[\'links\']" class="col-md-12 no-padding"></selector-link><selector-award ng-model="project.awards" visibility="$projectFieldUtils.getVisibility(\'awards\')" is-required="$projectFieldUtils.isRequired(\'awards\')" errors="errorDetails[\'awards\']" class="col-md-12 no-padding" limit="charLimits.award"></selector-award><input-referred ng-model="project.referred" visibility="$projectFieldUtils.getVisibility(\'referred\')" is-required="$projectFieldUtils.isRequired(\'referred\')" errors="errorDetails[\'referred\']" class="col-md-12 no-padding" limit="charLimits.referred"></input-referred><div class="form-group" ng-if="$projectFieldUtils.isVisibleSomeItem([\'companyName\', \'companyCharge\', \'companyEmail\', \'companyPhone\'])"><label class="control-label col-md-12" for="company_name"><strong class="text-uppercase">Respecto de la empresa</strong><div>Contacto para obtener mayor informaci\xF3n sobre el proyecto</div></label><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyName\')"><input type="text" name="company_name" id="company_name" placeholder="Nombre {{$projectFieldUtils.isRequired(\'companyName\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyName\')}" ng-model="project.companyName"><div class="p-b-10" ng-if="errorDetails[\'companyName\'] && errorDetails[\'companyName\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyName\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyCharge\')"><input type="text" name="company_charge" id="company_charge" placeholder="Cargo {{$projectFieldUtils.isRequired(\'companyCharge\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyCharge\')}" ng-model="project.companyCharge"><div class="p-b-10" ng-if="errorDetails[\'companyCharge\'] && errorDetails[\'companyCharge\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyCharge\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyEmail\')"><input type="text" name="company_email" id="company_email" placeholder="E-MAIL {{$projectFieldUtils.isRequired(\'companyEmail\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyEmail\')}" ng-model="project.companyEmail"><div class="p-b-10" ng-if="errorDetails[\'companyEmail\'] && errorDetails[\'companyEmail\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyEmail\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyPhone\')"><input type="text" name="company_phone" id="company_phone" placeholder="T\xE9lefono {{$projectFieldUtils.isRequired(\'companyPhone\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyPhone\')}" ng-model="project.companyPhone"><div class="p-b-10" ng-if="errorDetails[\'companyPhone\'] && errorDetails[\'companyPhone\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyPhone\']">{{error}}</div></div></div></div></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-show="step === 1" ng-click="step=2">Siguiente</button> <button type="submit" class="btn btn-primary" ng-show="step === 2">Guardar</button></div><div class="col-md-12 text-center m-t-20" ng-show="step === 2"><div class="pointer text-uppercase" ng-click="step=1">< Regresar al paso 1</div><div class="error-message p-t-5">Importante: Revise que ha completado todos los campos obligatorios</div></div></div></form></div></div></div>');
$templateCache.put('app/pages/associated/updates/associated_updates.html','<div class="panel panel-bordered" ng-init="init(\'list\')"><div class="col-md-12"><section-header title="\'Actualizaci\xF3n\'" description="\'Ingrese el nombre del proyecto para agregar la actualizaci\xF3n\'"></section-header></div><div class="panel-content clearfix"><div class="col-md-12"><div class="search-input-group"><input class="search-input upper-placeholder" type="text" ng-model="search" placeholder="Nombre del Proyecto"> <span class="fa fa-search search-icon" ng-click="loadProjects()"></span></div></div><div ng-show="!selectedProject"><ul class="project-results-container col-md-12 m-t-20"><li ng-repeat="project in projects" class="clearfix"><div class="col-md-11 col-xs-10 col-sm-10 no-padding">{{project.name}}</div><div class="col-md-1 col-xs-2 col-sm-2 no-padding text-right"><span class="pointer fa fa-plus p-l-r-5" ng-click="selectProject(project)"></span></div></li><li ng-if="finishedLoading && !projects.length" class="clearfix">No se encontraron resultados.</li></ul></div><div ng-show="selectedProject"><ul class="project-results-container col-md-12 m-t-20"><li>{{selectedProject.name}}</li></ul><form name="createForm" ng-submit="create(true)" novalidate=""><div class="col-md-12 m-t-20"><div class="text-uppercase">A\xF1adir actualizaci\xF3n</div><div class="m-t-5" text-angular="" id="content" ng-model="update.content" name="ta-project-update" placeholder="" ta-toolbar="taToolbar" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div></div><div class="form-group"><div class="col-md-12 m-t-10"><button type="submit" class="btn btn-primary">Guardar</button> <button type="button" class="btn" ng-click="cancelUpdate()">Cancelar</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/components/menuTop/menuTop.html','<div class="page-top-container" scroll-position="scrolled" max-height="400"><div class="container"><div class="col-md-12 m-t-10"><div ng-include="\'mainMenu.tpl.html\'"></div></div></div><div class="float-menu" ng-class="{\'show\': scrolled}"><div class="col-md-2 col-xlg-1"><a href="https://www.snmpe.org.pe/" target="_blank"><img class="logo" ng-src="{{logoTop}}" alt=""></a></div><div class="col-md-10 col-xlg-11 p-t-5"><div ng-include="\'mainMenu.tpl.html\'"></div></div></div></div><script type="text/ng-template" id="mainMenu.tpl.html"><ul class="main-menu"> <li ng-repeat="menu in mainMenuItems" ng-class="{\'dropdown\': menu.childrens.length > 0}"> <a ng-if="menu.childrens.length == 0" href="{{menu.href}}"> {{menu.title}} </a> <a ng-if="menu.childrens.length > 0" data-toggle="dropdown" class="dropdown-toggle pointer">{{menu.title}} <b class="caret"></b> </a> <ul class="dropdown-menu" ng-if="menu.childrens.length > 0"> <li ng-repeat="children in menu.childrens"> <a href="{{children.href}}" target="{{menu.target}}"> {{children.title}} </a> </li> </ul> </li> <li class="pull-right" ng-show="$root.enabledSearchComponent"> <div class="search-container" ng-class="{\'active\': searchActive}"> <input type="text" placeholder="Buscar ..." ng-model="$root.searchText"> <button type="button" class="search-btn" ng-click="search($root.searchText)"><i class="fa fa-search"></i> </button> </div> </li> </ul></script>');
$templateCache.put('app/pages/components/pagination/dirPagination.tpl.html','<ul class="custom-pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
$templateCache.put('app/pages/components/social_link/article_social_link.html','<ul class="small-social-link clearfix"><li ng-repeat="social in article.social | filter: {enabled: true}"><a ng-href="{{generateLink(social.id)}}" target="_blank"><i class="socicon socicon-{{social.id}}"></i></a></li></ul>');
$templateCache.put('app/pages/components/topBar/topBar.html','<div class="container top-bar"><nav id="navbar-example" class="navbar navbar-default" role="navigation"><div class="container-fluid"><div class="navbar-header"><button class="navbar-toggle menu-toggle" type="button" ng-class="{active: isActiveMenu(\'menu\')}" ng-click="toggleActiveMenu(\'menu\')"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <button class="navbar-toggle search-toggle" type="button" ng-if="$root.enabledSearchComponent" ng-class="{active: isActiveMenu(\'search\')}" ng-click="toggleActiveMenu(\'search\')"><span class="sr-only">Toggle navigation</span> <span class="fa fa-search"></span></button> <button class="navbar-toggle login-toggle" type="button" ng-class="{active: isActiveMenu(\'login\')}" ng-click="toggleActiveMenu(\'login\')"><span class="sr-only">Toggle navigation</span> <span class="fa fa-lock"></span></button> <a class="navbar-brand" href="https://www.snmpe.org.pe/" target="_blank"><img alt="Proyectos de Apoyo al Desarrollo" ng-src="{{logoTop}}"></a></div><div class="navbar-collapse" ng-class="{\'collapse\': $root.activeMenu === \'\'}"><ul class="nav navbar-nav navbar-right hidden-xs"><li ng-if="!$isEmptyOrNull(userLogged)"><a><span ui-sref="associated.home" class="pointer">{{\'Bienvenido \' + ((userLogged.company ? userLogged.company.publicName : \'\') | uppercase)}}</span> <b class="fa fa-lock m-l-r-10"></b> <b class="fa fa-times m-r-10 pointer" ng-click="logout()"></b></a></li><li ng-if="$isEmptyOrNull(userLogged)" id="fat-menu" class="dropdown"><a href="#" id="drop3" role="button" class="dropdown-toggle" data-toggle="dropdown">Iniciar sesi\xF3n <b class="fa fa-lock m-l-r-10"></b></a><ul class="dropdown-menu" aria-labelledby="btn-login"><li><div ng-include="\'loginSection.tpl.html\'"></div></li></ul></li></ul><div class="visible-xs p-t-20" ng-show="isActiveMenu(\'login\')" ng-include="\'loginSection.tpl.html\'"></div><div class="visible-xs p-t-20" ng-show="isActiveMenu(\'search\')" ng-include="\'searchSection.tpl.html\'"></div><div class="visible-xs p-t-20 main-menu-container" ng-show="isActiveMenu(\'menu\')" ng-include="\'menuSection.tpl.html\'"></div></div></div></nav></div><script type="text/ng-template" id="menuSection.tpl.html"><ul class="main-menu"> <li ng-repeat="menu in mainMenuItems"> <a ng-if="menu.childrens.length == 0" href="{{menu.href}}"> {{menu.title}} </a> <a ng-if="menu.childrens.length > 0" ng-click="toggleSubmenuCollapsed()" class="pointer">{{menu.title}} <b class="fa {{isSubmenuCollapsed ? \'fa-caret-down\' : \'fa-caret-up\'}}"></b> </a> <ul uib-collapse="isSubmenuCollapsed" ng-if="menu.childrens.length > 0" class="submenu"> <li ng-repeat="children in menu.childrens"> <a href="{{children.href}}" target="{{menu.target}}"> {{children.title}} </a> </li> </ul> </li> </ul></script><script type="text/ng-template" id="loginSection.tpl.html"><div class="login-form-container"> <!-- login form --> <form class="login-form" ng-if="!$isEmptyOrNull(userLogged)"> <a ui-sref="associated.home" class="d-block"> {{\'Bienvenido \' + ((userLogged.company ? userLogged.company.publicName : \'\') | uppercase)}} </a> <button type="button" class="btn btn-xs btn-primary btn-block" ng-click="logout()"> Cerrar Sesi\xF3n </button> </form> <form class="login-form" name="loginForm" ng-if="$isEmptyOrNull(userLogged)" ng-show="form === \'login\'" angular-validator-submit="signin(loginForm.$valid)" novalidate angular-validator> <div class="form-group"> <input name="username" type="text" class="form-control user-input" placeholder="usuario" ng-model="credentials.username" autocomplete="off"> </div> <div class="form-group"> <input name="password" type="password" class="form-control password-input" placeholder="contrase\xF1a" ng-model="credentials.password" autocomplete="new-password"> </div> <div class="clearfix"> <a href="javascript:;" class="pull-left" ng-click="setForm(\'recovery\')"> \xBFOlvidaste la contrase\xF1a? </a> <button type="submit" class="btn btn-xs btn-primary pull-right"> Ingresar </button> </div> </form> <!-- /login form --> <!-- remember password form --> <form class="login-form" name="recoveryForm" ng-show="form === \'recovery\'" angular-validator-submit="sendRecovery(recoveryForm.$valid)" novalidate angular-validator> <div class="form-group"> <input name="username" type="text" class="form-control user-input" placeholder="usuario" ng-model="recovery.username" autocomplete="off"> </div> <div class="clearfix"> <a href="javascript:;" class="pull-left" ng-click="setForm(\'login\')"> <i class="fa fa-arrow-left"></i> Iniciar sesi\xF3n </a> <button type="submit" class="btn btn-xs btn-primary pull-right"> Recuperar </button> </div> </form> <!-- remember password form --> </div></script><script type="text/ng-template" id="searchSection.tpl.html"><div class="search-form-container"> <!-- search form --> <form class="search-form" name="search-form"> <div class="form-group"> <input name="username" type="text" class="form-control user-input" placeholder="" ng-model="$root.searchText" autocomplete="off"> </div> <button type="button" ui-sref="main.project.project_search({s: $root.searchText})" class="btn btn-xs btn-primary btn-block"> Buscar </button> </form> <!-- /search form --> </div></script>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Ir a arriba" font-color="{{$currentEdition.color1}}"></i>');
$templateCache.put('app/theme/components/breadcrumb/breadcrumb.html','<div class="row"><div class="page-breadcrumb"><ul><li ng-repeat="item in states"><a href="{{item.url}}" hover-color="{{$currentEdition.color1}}">{{item.title}}</a></li><li><a href="" font-color="{{$currentEdition.color1}}">{{activePageTitle}}</a></li></ul></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top-container" scroll-position="scrolled" max-height="400"><div class="container"><div class="page-top clearfix"><div class="col-md-4 no-padding"><img src="{{logo}}" alt=""></div><div class="col-md-8 text-center"><ul class="top-menu"><li ng-repeat="sector in $sectors"><a href="">{{sector.name}}</a></li><li class="dropdown"><a href="" data-toggle="dropdown" class="dropdown-toggle">Categor\xEDa <b class="caret"></b></a><ul class="dropdown-menu" id="menu"><li ng-repeat="category in $categories"><a href="">{{category.name | cut: \'\' : 25}}</a></li></ul></li><li class="logout-item"><a href=""><span class="fa fa-sign-out"></span></a></li></ul></div></div></div><div class="float-menu" ng-class="{\'show\': scrolled}"><div class="col-md-2 col-xlg-1"><a ui-sref="main.home" ng-if="$currentEdition.logoFilename"><img class="logo" ng-src="{{$currentEdition.logoFilename | imageUrl : \'logos\'}}" alt=""></a></div><div class="col-md-10 col-xlg-11"><ul class="main-menu"><li ng-repeat="menu in mainMenuItems" ng-class="{\'dropdown\': menu.childrens.length > 0}"><a ng-if="menu.childrens.length == 0" href="{{menu.href}}" target="{{menu.target}}" hover-color="{{$currentEdition.color1}}">{{menu.title}}</a> <a ng-if="menu.childrens.length > 0" hover-color="{{$currentEdition.color1}}" href="{{menu.href}}" data-toggle="dropdown" class="dropdown-toggle">{{menu.title}} <b class="caret"></b></a><ul class="dropdown-menu" id="float-menu" ng-if="menu.childrens.length > 0"><li ng-repeat="children in menu.childrens"><a href="{{children.href}}" hover-color="white" target="{{menu.target}}" hover-background-color="{{$currentEdition.color1}}">{{children.title}}</a></li></ul></li><li class="pull-right"><a ui-sref="main.search" hover-color="{{$currentEdition.color1}}">{{menu.name}} <i class="fa fa-search"></i></a></li></ul></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/resources/directives/articles/articleCard/articleCard.html','<div class="article-card"><div class="card-header"><div class="tag" ng-if="article.tag">{{article.tag | uppercase}}</div><div background-image="{{article.avatar.url | imageUrl}}" background-image-height="{{imageHeight}}" ng-style="{height : imageHeight}"></div></div><div class="card-content"><div class="main-title" ng-if="article.company && article.company.publicName" ng-bind-html="article.company.publicName | highlightText : highlight"></div><a ng-href="{{urlView}}" class="secondary-title" ng-if="article.title" ng-bind-html="article.title | highlightText : highlight">{{}}</a></div></div>');
$templateCache.put('app/resources/directives/articles/articleSharedLinks/articleSharedLinks.html','<ul class="small-social-link clearfix" ng-if="social"><li ng-repeat="item in social"><a href="{{item.url}}" target="_blank"><i class="socicon socicon-{{item.id}}"></i></a></li></ul>');
$templateCache.put('app/resources/directives/articles/articleSlickImageSlide/articleSlickImageSlide.html','<div ng-if="images && images.length" class="article-slick-images"><slick init-onload="true" data="images" lazy-load="ondemand" slides-to-show="1" slides-to-scroll="1" arrows="false" fade="true" as-nav-for=".slider-nav" class="slider-for m-b-15"><div ng-repeat="image in images"><div class="slick-thumbs" background-image="{{image.url|imageUrl}}" background-image-height="{{height}}"><div class="tag" ng-if="article.tag">{{article.tag}}</div></div></div></slick><div class="col-md-12 p-l-r-30" ng-show="images.length >= minItemsToShowNavigation"><slick init-onload="true" data="images" lazy-load="ondemand" center-padding="0" slides-to-show="3" slides-to-scroll="1" arrows="true" as-nav-for=".slider-for" center-mode="true" focus-on-select="true" class="slider-nav"><div ng-repeat="image in images"><div class="slick-thumbs" background-image="{{image.url|imageUrl}}" background-image-height="{{previewHeight}}"></div></div></slick></div></div>');
$templateCache.put('app/resources/directives/manageProjects/errorMessage/errorMessage.html','<label class="control-label has-error">El campo es requerido.</label>');
$templateCache.put('app/resources/directives/manageProjects/gmaps/gmaps.html','<div class="form-group"><label class="control-label col-md-12" for="map"><strong class="text-uppercase">Ubicaci\xF3n en el mapa</strong></label><div class="gmap-container" id="map"><ui-gmap-google-map center="map.center" zoom="map.zoom" draggable="true" options="options" control="mapControl" events="events"><ui-gmap-markers models="markers" fit="\'true\'" coords="\'self\'" icon="\'icon\'" options="\'options\'" click="onClick"></ui-gmap-markers></ui-gmap-google-map></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputAction/inputAction.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="actions"><strong class="text-uppercase">Acciones.</strong> Principales acciones realizadas o a realizar <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="actions" ng-model="model" name="ta-actions" placeholder="ACCIONES" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputGoals/inputGoals.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="goals"><strong class="text-uppercase">Metas.</strong> Metas logradas del proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="goals" ng-model="model" name="ta-goals" placeholder="METAS" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputHistory/inputHistory.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="history"><strong class="text-uppercase">Historia que contar ...</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="history" ng-model="model" name="ta-history" placeholder="HISTORIA" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputImpact/inputImpact.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="impact"><strong class="text-uppercase">Indicadores.</strong> Impacto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="impact" ng-model="model" name="ta-impact" placeholder="IMPACTO" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputMonitoring/inputMonitoring.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="monitoring"><strong class="text-uppercase">Monitoreo y Evaluaci\xF3n.</strong> Describir brevemente <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="monitoring" ng-model="model" name="ta-monitoring" placeholder="DESCRIBIR" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputObjective/inputObjective.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="objective"><strong class="text-uppercase">Objetivo.</strong> Describa el objetivo del proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="objective" id="objective" cols="30" rows="5" class="form-control" ng-model="model" maxlength="{{limit}}">\n        </textarea><char-counter ng-model="model" limit="limit" ng-if="limit"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputReferred/inputReferred.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="referred"><strong class="text-uppercase">El proyecto ha sido mencionado / referido en:</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="referred" id="referred" cols="30" rows="5" class="form-control" placeholder="Detalle" ng-model="model" maxlength="{{limit}}">\n        </textarea><char-counter ng-model="model" limit="limit" ng-if="limit"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputResults/inputResults.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="results"><strong class="text-uppercase">Indicadores.</strong> Resultados <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="results" ng-model="model" name="ta-results" placeholder="RESULTADOS" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputSatisfactionIndicator/inputSatisfactionIndicator.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="satisfactionIndicator"><strong>\xBFTiene un indicador de satisfacci\xF3n o recepci\xF3n de opini\xF3n sobre el proyecto de parte de los beneficiarios?\xBFCu\xE1l y c\xF3mo?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="satisfactionIndicator" id="satisfactionIndicator" cols="30" rows="5" class="form-control" placeholder="Detalle" ng-model="model">\n        </textarea></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputSummary/inputSummary.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="summary"><strong class="text-uppercase">Resumen.</strong> Rese\xF1a p\xFAblica <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="summary" ng-model="model" name="ta-summary" placeholder="RESUMEN" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorActivity/selectorActivity.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Actividad.</strong> Indique la actividad que realiza la empresa en el entorno de este proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorAlliance/selectorAlliance.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Alianzas en la gesti\xF3n del proyecto</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorAward/selectorAward.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Referencias</strong> (premios, entrevistas, etc) <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><textarea name="award" cols="30" rows="3" class="form-control" placeholder="Premios" ng-model="selected[$index]" maxlength="{{limit}}">\n                </textarea><char-counter ng-model="selected[$index]" limit="limit" ng-if="limit"></char-counter><div class="text-right p-t-5"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><textarea name="award" cols="30" rows="3" class="form-control" placeholder="Premios" ng-model="newItem" maxlength="{{limit}}">\n                </textarea><char-counter ng-model="newItem" limit="limit" ng-if="limit"></char-counter><div class="text-right p-t-5"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorBeneficiary/selectorBeneficiary.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Beneficiarios</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><div class="form-group p-t-10"><div class="col-md-2 no-padding"><input type="text" name="customAmount_{{column + \'_\' +$index}}" id="customAmount_{{column + \'_\' +$index}}" class="form-control col-md-12" only-natural-number="" ng-change="changeSelection(item, item.customAmount, item.customValue)" ng-model="item.customAmount"></div><label class="control-label col-md-10 p-t-5" for="customAmount_{{column + \'_\' +$index}}">{{item.name}}</label></div><div class="col-md-12 no-padding p-r-15" ng-if="item.customAmount && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-change="changeSelection(item, item.customAmount, item.customValue)" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorCategory/selectorCategory.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Rubro del Proyecto</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div ng-if="item.subcategories && item.subcategories.length" style="padding: 10px 0 0 30px;"><div ng-repeat="subcat in item.subcategories" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[subcat.id]" ng-change="changeSelection(subcat, selection[subcat.id])"> <span>{{subcat.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[subcat.id] === true && subcat.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="subcat.customValue"></div></div></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorCompany/selectorCompany.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}"><label class="control-label col-md-12" for="company"><strong class="text-uppercase">Empresa</strong></label><div class="col-md-12"><select class="form-control" name="company" id="company" ng-model="model" ng-options="company.id as company.publicName for company in companies"><option selected="" value="">{{\'Empresa\'|uppercase}}</option></select></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorDiffusion/selectorDiffusion.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Difusi\xF3n</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Los alcances y avances de este proyecto son informados y conocidos por:</div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorFinancing/selectorFinancing.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Financiamiento</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorImageUpload/selectorImageUpload.html','<div class="clearfix" ng-class="{\'has-error-item\': (errors && errors.length) || (errorsAvatar && errorsAvatar.length)}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Elementos gr\xE1ficos</strong> <span ng-if="isRequired || isRequiredAvatar" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle"><div>Fotos</div><div>M\xEDnimo 3 fotos</div><div>Formato JPG. M\xE1ximo 2000KB</div><recommended-sizes width="recommendedSizes.width" height="recommendedSizes.height" unit="px"></recommended-sizes></div></div><div class="clearfix"><div ng-repeat="file in files" class="col-md-12 no-padding" ng-class="{\'p-t-1\': !$first}"><div class="clearfix"><div class="col-md-1 no-padding"><img class="img-responsive" ng-src="{{file.url|imageUrl}}"></div><div class="col-md-11"><a href="javascript:;" class="remove-item-btn" ng-click="removeItem($index)"><i class="fa fa-minus-circle"></i></a></div></div><div class="p-t-10 p-b-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="files[$index].checked" ng-change="setAsAvatar($index, files[$index].checked)"> <span>Marcar como foto portada</span></label></div></div><div class="col-md-12 no-padding p-t-2"><div class="clearfix"><div class="col-md-2 no-padding"><img ng-if="file" class="img-responsive" ngf-thumbnail="file"></div><div class="col-md-12 no-padding p-t-10"><button class="btn btn-sm" ngf-select="" ng-model="file" accept="image/*" ngf-max-size="2MB">{{file?\'Cambiar\':\'Examinar\'}}</button> <button type="button" class="btn btn-sm btn-primary" ng-click="uploadFile(file, $index)" ng-disabled="!file">Subir</button></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="(errors && errors.length) || (errorsAvatar && errorsAvatar.length)"><div class="error-message" ng-repeat="error in errors">{{error}}</div><div class="error-message" ng-repeat="errorsAvatar in errorsAvatar">{{errorsAvatar}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorInformationBase/selectorInformationBase.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>\xBFCu\xE1l es la base / informaci\xF3n que sustenta la pertinencia de este proyecto?<br>\xBFPor qu\xE9 se decide hacerlo?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorLink/selectorLink.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Enlaces</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><div class="col-md-6 no-padding p-r-5"><input type="text" name="link_title{{$index}}" id="link_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="selected[$index].title"></div><div class="col-md-6 no-padding p-l-5"><input type="text" name="link_url{{$index}}" id="link_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="selected[$index].url"></div><div class="text-right"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><div class="col-md-6 no-padding p-r-5"><input type="text" name="link_add_title{{$index}}" id="link_add_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="newItem.title"></div><div class="col-md-6 no-padding p-l-5"><input type="text" name="link_add_url{{$index}}" id="link_add_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="newItem.url"></div><div class="text-right"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorLocation/selectorLocation.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-6 no-padding"><div class="form-group"><label class="control-label col-md-12" for="region"><strong class="text-uppercase">Lugar.</strong> En el que se ha desarrollado el proyecto. <span ng-if="isRequired" class="info-tag" uib-tooltip="El proyecto debe tener al menos una sede" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><select class="form-control" name="region" id="region" ng-model="location.idRegion" ng-change="loadProvinces(location.idRegion)" ng-options="region.id as (region.name) for region in regions"><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div><div class="col-md-12"><select class="form-control" name="province" id="province" ng-model="location.idProvince" ng-change="loadDistricts(location.idProvince)" ng-options="province.id as (province.name) for province in provinces"><option selected="" disabled="" value="">{{\'Provincia\'|uppercase}}</option></select></div><div class="col-md-12"><select class="form-control" name="district" id="district" ng-model="location.idDistrict" ng-options="district.id as (district.name) for district in districts"><option selected="" disabled="" value="">{{\'Distrito\'|uppercase}}</option></select></div><div class="col-md-12"><input type="text" name="populatedCenter" id="populatedCenter" placeholder="Centro Poblado" class="form-control" ng-model="location.populatedCenter"></div><div class="col-md-12 text-right"><button type="button" class="btn btn-xs" ng-click="calculateCoords()"><span class="fa fa-map-pin"></span> Calcular Coordenadas</button></div></div><div class="form-group"><label class="control-label col-md-12" for="coordinates"><strong class="text-uppercase">Coordenadas.</strong> Un proyecto para editar o actualizar</label><div class="col-md-12" id="coordinates"><input type="text" name="latitude" id="latitude" placeholder="Latitud" class="form-control" ng-model="location.latitude"></div><div class="col-md-12"><input type="text" name="longitude" id="longitude" placeholder="Longitud" class="form-control" ng-model="location.longitude"></div></div><div class="col-md-12 text-right"><button type="button" class="btn btn-xs" ng-click="createOrUpdateLocation()"><span class="fa fa-save"></span> {{(isEdition ? \'Actualizar\' : \'Adicionar\') + \' lugar\'}}</button></div><div class="col-md-12"><table class="table table-location mb-20"><thead><tr><th>Lugares</th><th></th></tr></thead><tbody><tr ng-repeat="location in model track by $index"><td><div class="location-card"><div><span class="fa fa-map-marker"></span> {{location.latitude + \', \' + location.longitude}}</div></div></td><td style="padding-right: 0 !important;"><button type="button" class="btn btn-xs" ng-click="selectLocation(location, $index)"><span class="fa fa-edit"></span></button> <button type="button" class="btn btn-xs" ng-click="removeLocation($index)"><span class="fa fa-trash"></span></button></td></tr><tr ng-if="model.length===0"><td colspan="2">No se han adicionado sedes al proyecto.</td></tr></tbody></table></div></div><div class="col-md-6"><gmaps locations="model"></gmaps></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorODS/selectorODS.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Objetivos de Desarrollo Sostenible (ODS)</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Para mayor informaci\xF3n sobre la calificaci\xF3n de los ODS para su proyecto, ingrese al link https://www.un.org/sustainabledevelopment/es/objetivos-desarrollo-sostenible/</div></div><div class="selector-body clearfix"><div ng-if="viewMode === \'horizontal\'" class="col-md-12 no-padding"><div ng-repeat="item in objectives" class="item col-md-2 col-xs-4 col-sm-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ods{{item.id}}" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span></span></label> <label for="ods{{item.id}}"><img ng-src="{{item.image.url | url}}" alt="" width="50"></label></div></div><div ng-if="viewMode === \'vertical\'" ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ods{{item.id}}" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span></span></label> <label for="ods{{item.id}}"><img ng-src="{{item.image.url | url}}" alt="" width="50"></label></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorVideo/selectorVideo.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Videos</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Ingresar la URL del video de youtube</div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><input type="text" name="video{{$index}}" id="video{{$index}}" placeholder="Url del Video" class="form-control" style="display: block;" ng-model="selected[$index]"><div class="text-right"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><input type="text" name="video-add" id="video-add" placeholder="Url del Video" class="form-control" style="display: block;" ng-model="newItem"><div class="text-right"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorWomanEmpowerment/selectorWomanEmpowerment.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="woman-empowerment"><strong>\xBFEl proyecto implica empoderamiento y/o fortalecimiento de la mujer?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" id="woman-empowerment"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-checked="model" ng-click="toggleSelection()"> <span>Si</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-checked="!model" ng-click="toggleSelection()"> <span>No</span></label></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseActions/collapseActions.html','<div class="collapse-project-item" ng-if="model"><div class="collapse-header">Acciones <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseAlliances/collapseAlliances.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Alianzas en la gesti\xF3n del proyecto <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model" class="p-t-5">- {{item.name}}{{item.custom && item.customAlliance.value ? \': \' + item.customAlliance.value : \'\'}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseAwards/collapseAwards.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Referencias <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model track by $index" class="p-t-5">{{$index+1}}. {{item}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseBeneficiary/collapseBeneficiary.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Beneficiarios <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model" class="p-t-5">- {{item.name}}: {{item.customBeneficiary.amount || \'\'}} {{item.custom && item.customBeneficiary.value ? item.customBeneficiary.value : \'\'}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseCategory/collapseCategory.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Rubro del proyecto <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in groupCategories(model)" class="p-t-5">- {{item.name}}{{item.custom && item.customCategory.value ? \': \' + item.customCategory.value : \'\'}}<div ng-repeat="child in item.childrens" class="p-l-10 p-t-5">- {{child.name}}{{child.custom && child.customCategory.value ? \': \' + child.customCategory.value : \'\'}}</div></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseCompany/collapseCompany.html','<div class="collapse-project-item" ng-if="companyName || companyEmail || companyPhone || companyCharge"><div class="collapse-header">Respecto de la Empresa <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-if="isVisibleCompanyName && companyName" class="p-t-5">Nombre: {{companyName}}</div><div ng-if="isVisibleCompanyEmail && companyEmail" class="p-t-5">Email: {{companyEmail}}</div><div ng-if="isVisibleCompanyPhone && companyPhone" class="p-t-5">Tel\xE9fono: {{companyPhone}}</div><div ng-if="isVisibleCompanyCharge && companyCharge" class="p-t-5">Cargo: {{companyCharge}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseDates/collapseDates.html','<div class="collapse-project-item" ng-if="startDate || endDate || duration || endDateExecution"><div class="collapse-header">Fechas de Relevancia <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-if="isVisibleStartDate && startDate" class="p-t-5">Fecha de Inicio: {{startDate| date: \'MM.yyyy\'}}</div><div ng-if="isVisibleEndDate && endDate && !endDateExecution" class="p-t-5">Fecha de Fin: {{endDate| date: \'MM.yyyy\'}}</div><div ng-if="isVisibleEndDate && endDateExecution" class="p-t-5">Fecha de Fin: Proyecto en Ejecuci\xF3n</div><div ng-if="isVisibleDuration && duration" class="p-t-5">Duraci\xF3n: {{duration}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseDiffusions/collapseDiffusions.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Difusi\xF3n <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model" class="p-t-5">- {{item.name}} {{item.custom && item.customDiffusion.value ? item.customDiffusion.value : \'\'}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseFinancing/collapseFinancing.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Financiamiento <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model" class="p-t-5">- {{item.name}}{{item.custom && item.customFinancing.value ? \': \' + item.customFinancing.value : \'\'}}</div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseGoals/collapseGoals.html','<div class="collapse-project-item" ng-if="model"><div class="collapse-header">Metas <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseHistory/collapseHistory.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Historia que contar <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseLinks/collapseLinks.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Enlaces <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model track by $index" class="p-t-5">- <a href="{{item.url}}" target="_blank">{{item.title}}</a></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseLocations/collapseLocations.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Lugar <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-repeat="item in model track by $index" class="p-t-10"><div ng-if="item.region" class="p-t-5">Regi\xF3n: {{item.region.name}}</div><div ng-if="item.province" class="p-t-5">Provincia: {{item.province.name}}</div><div ng-if="item.district" class="p-t-5">Distrito: {{item.district.name}}</div><div ng-if="item.populatedCenter" class="p-t-5">Centro Poblado: {{item.populatedCenter}}</div></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseMonitoring/collapseMonitoring.html','<div class="collapse-project-item" ng-if="model"><div class="collapse-header">Monitoreo y Evaluaci\xF3n <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseReferred/collapseReferred.html','<div class="collapse-project-item" ng-if="model && model.length"><div class="collapse-header">Referido <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseSummary/collapseSummary.html','<div class="collapse-project-item" ng-if="model"><div class="collapse-header">Resumen <span class="btn-toggle-collapse pull-right pointer fa {{isCollapsed ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed()"></span></div><div uib-collapse="isCollapsed" class="collapse-content"><div ng-bind-html="model" class="p-t-5"></div></div></div>');
$templateCache.put('app/resources/directives/projects/collapseUpdates/collapseUpdates.html','<div class="collapse-project-item collapse-updates" ng-if="model && model.length"><div class="collapse-header">Actualizaci\xF3n</div><div ng-repeat="item in model track by $index" class="collapse-updates-item"><div class="collapse-header">{{item.date | date: \'dd.MM.yyyy\'}} <span class="btn-toggle-collapse pull-right pointer fa {{itemCollapsed[$index] ? \'fa-plus\' : \'fa-minus\'}}" ng-click="toggleCollapsed($index)"></span></div><div uib-collapse="itemCollapsed[$index]" class="collapse-content clearfix"><div class="col-md-1 col-xs-1 col-sm-1 no-padding text-left"><span class="fa fa-circle-o fa-2x"></span></div><div class="col-md-11 col-xs-11 col-sm-11"><div ng-bind-html="item.content" style-for-all-child="{\'color\': \'white\'}"></div></div></div><hr class="collapse-update-separator"></div></div>');
$templateCache.put('app/resources/directives/projects/imagesSlide/imagesSlide.html','<div class="image-slide-top-container" ng-if="project.images && project.images.length"><div uib-carousel="" active="active" interval="interval" no-wrap="noWrapSlides"><div uib-slide="" ng-repeat="image in project.images" index="$index" class="{{$index === active ? \'active\' : \'\'}}"><div class="slide-image" background-image="{{image.url | imageUrl}}" background-image-height="{{height}}"></div></div></div></div>');
$templateCache.put('app/resources/directives/projects/projectCard/projectCard.html','<div class="project-card"><div class="card-header"><div class="tag" ng-if="showTag">{{\'Actualizaci\xF3n\' | uppercase}}</div><div background-image="{{project.avatar.url | imageUrl}}" background-image-height="{{imageHeight}}" ng-style="{height : imageHeight}"></div></div><div class="card-content"><div class="main-title" ng-if="project.company && project.company.publicName" ng-bind-html="project.company.publicName | highlightText : highlight"></div><a ng-href="{{urlView}}" class="secondary-title" ng-if="project.nameToPublish" ng-bind-html="project.nameToPublish | highlightText : highlight">{{}}</a></div></div>');
$templateCache.put('app/resources/directives/projects/projectCompanyCard/projectCompanyCard.html','<div class="project-company-card" ng-if="company"><div class="card-header">Proyecto realizado por:</div><div class="card-content clearfix"><div class="col-md-2 col-xs-3 col-sm-2" ng-if="company.sector && company.sector.imageLogo"><img ng-src="{{company.sector.imageLogo.url | imageUrl}}" class="sector-logo"></div><div class="col-md-10 col-xs-9 col-sm-10"><div>{{company.publicName}}</div><button type="button" class="btn btn-sm btn-primary m-t-5" ui-sref="main.project.project_company({idCompany: company.id})">Ver m\xE1s proyectos</button></div></div></div>');
$templateCache.put('app/resources/directives/projects/projectSharedLinks/projectSharedLinks.html','<ul class="small-social-link clearfix" ng-if="social"><li ng-repeat="item in social"><a href="{{item.url}}" target="_blank"><i class="socicon socicon-{{item.id}}"></i></a></li></ul>');
$templateCache.put('app/resources/directives/projects/slickImageSlide/slickImageSlide.html','<div ng-if="project.images && project.images.length"><slick init-onload="true" data="project.images" lazy-load="ondemand" slides-to-show="1" slides-to-scroll="1" arrows="false" fade="true" as-nav-for=".slider-nav" class="slider-for m-b-15"><div ng-repeat="image in project.images"><div class="slick-thumbs" background-image="{{image.url|imageUrl}}" background-image-height="{{height}}"></div></div></slick><div class="col-md-12 p-l-r-30"><slick init-onload="true" data="project.images" lazy-load="ondemand" center-padding="0" slides-to-show="3" slides-to-scroll="1" arrows="true" as-nav-for=".slider-for" center-mode="true" focus-on-select="true" class="slider-nav"><div ng-repeat="image in project.images"><div class="slick-thumbs" background-image="{{image.url|imageUrl}}" background-image-height="{{previewHeight}}"></div></div></slick></div></div>');}]);